{
  "level": "ep01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:ep01",
    "objects": "AREAS.E3:ep01.e3",
    "mesh": "TREES.E3:ep01.e3"
  },
  "spawn_point": {
    "position": [
      -3828.9796920623608,
      -4954.10885358732,
      902.70703125
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3828.9796920623608,
      -4854.10885358732,
      902.70703125
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4133.0,
      -5114.505859375,
      878.70703125
    ],
    "bbox_max": [
      -3527.91259765625,
      -4642.935546875,
      1067.6239013671875
    ],
    "vertex_count": 899,
    "vertices": [
      [
        -3527.91259765625,
        -5023.9755859375,
        878.70703125
      ],
      [
        -3548.697021484375,
        -5035.97509765625,
        878.70703125
      ],
      [
        -3601.944580078125,
        -4944.0283203125,
        878.70703125
      ],
      [
        -3581.159912109375,
        -4932.0283203125,
        878.70703125
      ],
      [
        -3588.666748046875,
        -5044.599609375,
        1013.6239013671875
      ],
      [
        -3578.0,
        -5044.599609375,
        1013.6239013671875
      ],
      [
        -3566.609619140625,
        -5024.89111328125,
        937.6498413085938
      ],
      [
        -3566.414306640625,
        -5025.08642578125,
        938.1212768554688
      ],
      [
        -3566.414306640625,
        -5025.08642578125,
        938.1212768554688
      ],
      [
        -3563.0,
        -5024.50048828125,
        934.7070922851562
      ],
      [
        -3565.0,
        -5024.50048828125,
        936.70703125
      ],
      [
        -3565.0,
        -5024.50048828125,
        936.70703125
      ],
      [
        -3563.0,
        -5024.50048828125,
        934.7070922851562
      ],
      [
        -3560.0,
        -5021.50048828125,
        931.70703125
      ],
      [
        -3570.0,
        -5019.57177734375,
        941.70703125
      ],
      [
        -3567.0,
        -5015.3291015625,
        938.7069702148438
      ],
      [
        -3563.0,
        -5015.3291015625,
        938.7071533203125
      ],
      [
        -3560.0,
        -5019.57177734375,
        941.7068481445312
      ],
      [
        -3563.390380859375,
        -5024.89111328125,
        937.6500854492188
      ],
      [
        -3563.58544921875,
        -5025.08642578125,
        938.1212768554688
      ],
      [
        -3563.58544921875,
        -5025.08642578125,
        938.1212768554688
      ],
      [
        -3606.977783203125,
        -5074.74658203125,
        1000.6239013671875
      ],
      [
        -3609.0,
        -5073.92529296875,
        1000.6239013671875
      ],
      [
        -3606.977783203125,
        -5074.74658203125,
        1000.6239013671875
      ],
      [
        -3612.0,
        -5075.7060546875,
        997.6239013671875
      ],
      [
        -3609.0,
        -5073.92529296875,
        1000.6239013671875
      ],
      [
        -3611.97412109375,
        -5079.7431640625,
        993.597900390625
      ],
      [
        -3611.84619140625,
        -5079.76904296875,
        993.6239013671875
      ],
      [
        -3611.97412109375,
        -5079.7431640625,
        993.597900390625
      ],
      [
        -3612.0,
        -5079.70654296875,
        993.6239013671875
      ],
      [
        -3596.666748046875,
        -5051.599609375,
        1013.6239013671875
      ],
      [
        -3596.666748046875,
        -5047.599609375,
        1013.6239013671875
      ],
      [
        -3596.666748046875,
        -5051.599609375,
        1013.6239013671875
      ],
      [
        -3588.666748046875,
        -5054.599609375,
        1013.6239013671875
      ],
      [
        -3572.169921875,
        -5069.76904296875,
        1009.7423706054688
      ],
      [
        -3572.169921875,
        -5072.76904296875,
        1012.7423706054688
      ],
      [
        -3570.0,
        -5074.60009765625,
        1013.6239013671875
      ],
      [
        -3572.169921875,
        -5072.76904296875,
        1012.7423706054688
      ],
      [
        -3572.169921875,
        -5069.76904296875,
        1009.7423706054688
      ],
      [
        -3570.0,
        -5069.76904296875,
        1008.7930297851562
      ],
      [
        -3596.666748046875,
        -5047.599609375,
        1013.6239013671875
      ],
      [
        -3588.666748046875,
        -5044.599609375,
        1013.6239013671875
      ],
      [
        -3578.0,
        -5054.599609375,
        1013.6239013671875
      ],
      [
        -3588.666748046875,
        -5054.599609375,
        1013.6239013671875
      ],
      [
        -3578.0,
        -5044.599609375,
        1013.6239013671875
      ],
      [
        -3578.0,
        -5054.599609375,
        1013.6239013671875
      ],
      [
        -3572.169677734375,
        -5051.599609375,
        977.5731201171875
      ],
      [
        -3572.169677734375,
        -5054.599609375,
        980.5731201171875
      ],
      [
        -3570.0,
        -5049.76904296875,
        976.6239013671875
      ],
      [
        -3572.169677734375,
        -5051.599609375,
        977.5731201171875
      ],
      [
        -3570.0,
        -5054.599609375,
        981.4545288085938
      ],
      [
        -3572.169677734375,
        -5054.599609375,
        980.5731201171875
      ],
      [
        -3606.86962890625,
        -5049.72998046875,
        990.6239013671875
      ],
      [
        -3606.86962890625,
        -5049.72998046875,
        990.6239013671875
      ],
      [
        -3609.0,
        -5050.662109375,
        990.6239013671875
      ],
      [
        -3611.14404296875,
        -5044.599609375,
        997.6239013671875
      ],
      [
        -3611.846435546875,
        -5044.75341796875,
        997.7775268554688
      ],
      [
        -3612.0,
        -5044.97412109375,
        997.6239013671875
      ],
      [
        -3611.846435546875,
        -5044.75341796875,
        997.7775268554688
      ],
      [
        -3598.4443359375,
        -5069.76904296875,
        999.068359375
      ],
      [
        -3593.70361328125,
        -5069.76904296875,
        996.9942626953125
      ],
      [
        -3598.4443359375,
        -5069.76904296875,
        999.068359375
      ],
      [
        -3593.70361328125,
        -5069.76904296875,
        996.9942626953125
      ],
      [
        -3590.148193359375,
        -5072.76904296875,
        995.438720703125
      ],
      [
        -3590.148193359375,
        -5076.76904296875,
        995.438720703125
      ],
      [
        -3590.148193359375,
        -5072.76904296875,
        995.438720703125
      ],
      [
        -3604.0869140625,
        -5052.5126953125,
        991.5369262695312
      ],
      [
        -3604.0869140625,
        -5071.85595703125,
        991.5369262695312
      ],
      [
        -3604.0869140625,
        -5071.85595703125,
        991.5369262695312
      ],
      [
        -3604.0869140625,
        -5052.5126953125,
        991.5369262695312
      ],
      [
        -3605.0,
        -5076.76904296875,
        990.6239013671875
      ],
      [
        -3604.0869140625,
        -5077.68212890625,
        991.5369262695312
      ],
      [
        -3608.857421875,
        -5079.76904296875,
        993.6239013671875
      ],
      [
        -3609.0,
        -5054.662109375,
        1000.6239013671875
      ],
      [
        -3605.0,
        -5052.912109375,
        1000.6239013671875
      ],
      [
        -3612.0,
        -5058.97412109375,
        997.6239013671875
      ],
      [
        -3609.0,
        -5054.662109375,
        1000.6239013671875
      ],
      [
        -3602.0,
        -5058.599609375,
        993.6239013671875
      ],
      [
        -3605.0,
        -5052.912109375,
        1000.6239013671875
      ],
      [
        -3602.0,
        -5058.599609375,
        993.6239013671875
      ],
      [
        -3604.0869140625,
        -5061.60009765625,
        991.5369262695312
      ],
      [
        -3604.0869140625,
        -5077.68212890625,
        991.5369262695312
      ],
      [
        -3604.0869140625,
        -5054.599609375,
        991.5369262695312
      ],
      [
        -3612.0,
        -5054.599609375,
        997.6239013671875
      ],
      [
        -3609.0,
        -5054.599609375,
        1000.6239013671875
      ],
      [
        -3609.0,
        -5054.599609375,
        1000.6239013671875
      ],
      [
        -3608.857177734375,
        -5054.599609375,
        1000.6239013671875
      ],
      [
        -3612.0,
        -5054.224609375,
        997.6239013671875
      ],
      [
        -3611.739013671875,
        -5054.599609375,
        997.8848876953125
      ],
      [
        -3560.0,
        -5047.59912109375,
        942.9495239257812
      ],
      [
        -3566.999755859375,
        -5054.599609375,
        982.381103515625
      ],
      [
        -3570.0,
        -5047.599609375,
        942.9496459960938
      ],
      [
        -3567.0,
        -5044.599609375,
        982.3812866210938
      ],
      [
        -3567.0,
        -5047.599609375,
        1003.6239013671875
      ],
      [
        -3567.0,
        -5076.76904296875,
        1003.6239013671875
      ],
      [
        -3567.0,
        -5047.599609375,
        1013.6239013671875
      ],
      [
        -3567.0,
        -5076.76904296875,
        1013.6239013671875
      ],
      [
        -3609.0,
        -5054.224609375,
        1025.6239013671875
      ],
      [
        -3605.0,
        -5052.724609375,
        1025.6239013671875
      ],
      [
        -3605.0,
        -5052.724609375,
        1025.6239013671875
      ],
      [
        -3612.0,
        -5058.349609375,
        1022.6239013671875
      ],
      [
        -3609.0,
        -5054.224609375,
        1025.6239013671875
      ],
      [
        -3602.0,
        -5058.60009765625,
        1018.6239013671875
      ],
      [
        -3612.0,
        -5062.349609375,
        1018.6239013671875
      ],
      [
        -3609.0,
        -5064.22509765625,
        1015.6239013671875
      ],
      [
        -3605.0,
        -5062.724609375,
        1015.6239013671875
      ],
      [
        -3602.0,
        -5058.60009765625,
        1018.6239013671875
      ],
      [
        -3609.0,
        -5064.22509765625,
        1015.6239013671875
      ],
      [
        -3605.0,
        -5062.724609375,
        1015.6239013671875
      ],
      [
        -3609.0,
        -5054.599609375,
        1015.6239013671875
      ],
      [
        -3605.0,
        -5054.599609375,
        1015.6239013671875
      ],
      [
        -3605.0,
        -5054.599609375,
        1015.6239013671875
      ],
      [
        -3612.0,
        -5054.599609375,
        1022.6239013671875
      ],
      [
        -3609.272705078125,
        -5054.599609375,
        1025.3511962890625
      ],
      [
        -3606.79931640625,
        -5049.80029296875,
        1015.6239013671875
      ],
      [
        -3609.0,
        -5048.97509765625,
        1015.6239013671875
      ],
      [
        -3606.79931640625,
        -5049.80029296875,
        1015.6239013671875
      ],
      [
        -3607.0908203125,
        -5049.5087890625,
        1015.6239013671875
      ],
      [
        -3607.0908203125,
        -5049.5087890625,
        1015.6239013671875
      ],
      [
        -3607.333740234375,
        -5049.60009765625,
        1015.6239013671875
      ],
      [
        -3667.0,
        -4979.76904296875,
        1025.6239013671875
      ],
      [
        -3627.0,
        -4979.76904296875,
        1025.6239013671875
      ],
      [
        -3627.0,
        -4979.76904296875,
        1025.6239013671875
      ],
      [
        -3667.0,
        -4924.76904296875,
        1025.6239013671875
      ],
      [
        -3627.0,
        -4924.76904296875,
        1025.6239013671875
      ],
      [
        -3627.0,
        -4924.76904296875,
        1025.6239013671875
      ],
      [
        -3667.0,
        -4974.76904296875,
        1025.6239013671875
      ],
      [
        -3627.0,
        -4974.76904296875,
        1025.6239013671875
      ],
      [
        -3627.0,
        -4974.76904296875,
        1025.6239013671875
      ],
      [
        -3667.0,
        -4919.76904296875,
        1025.6239013671875
      ],
      [
        -3627.0,
        -4919.76904296875,
        1025.6239013671875
      ],
      [
        -3627.0,
        -4919.76904296875,
        1025.6239013671875
      ],
      [
        -3909.725341796875,
        -5029.7998046875,
        1015.6257934570312
      ],
      [
        -3894.274658203125,
        -5029.7998046875,
        1015.6257934570312
      ],
      [
        -3857.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3877.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3787.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3807.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3927.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3947.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3877.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3857.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3947.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3927.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3717.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3737.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3737.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3737.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3857.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3857.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3807.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3787.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3807.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      [
        -3807.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3807.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3787.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3787.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      [
        -3787.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3807.0,
        -5079.76904296875,
        1017.0
      ],
      [
        -3807.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      [
        -3787.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      [
        -3787.0,
        -5079.76904296875,
        1017.0
      ],
      [
        -3807.0,
        -5060.0,
        1015.6239013671875
      ],
      [
        -3787.0,
        -5060.0,
        1015.6239013671875
      ],
      [
        -3947.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3947.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3877.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3877.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3927.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3927.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3877.0,
        -5114.505859375,
        1032.6239013671875
      ],
      [
        -3877.0,
        -5108.32568359375,
        1037.6239013671875
      ],
      [
        -3927.0,
        -5114.505859375,
        1032.6239013671875
      ],
      [
        -3927.0,
        -5108.32568359375,
        1037.6239013671875
      ],
      [
        -3927.0,
        -5095.94873046875,
        1037.6239013671875
      ],
      [
        -3877.0,
        -5095.94873046875,
        1037.6239013671875
      ],
      [
        -3892.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      [
        -3892.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      [
        -3888.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      [
        -3892.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      [
        -3892.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      [
        -3888.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      [
        -3888.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      [
        -3888.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      [
        -3912.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      [
        -3912.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      [
        -3912.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      [
        -3916.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      [
        -3916.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      [
        -3912.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      [
        -3916.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      [
        -3916.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      [
        -3877.0,
        -5095.94873046875,
        1037.6239013671875
      ],
      [
        -3877.0,
        -5097.1748046875,
        1037.6239013671875
      ],
      [
        -3927.0,
        -5095.94873046875,
        1037.6239013671875
      ],
      [
        -3927.0,
        -5097.17431640625,
        1037.6239013671875
      ],
      [
        -3927.0,
        -5108.32568359375,
        1037.6239013671875
      ],
      [
        -3926.697265625,
        -5108.54541015625,
        1037.6239013671875
      ],
      [
        -3927.0,
        -5097.9326171875,
        1037.6239013671875
      ],
      [
        -3927.0,
        -5097.9326171875,
        1037.6239013671875
      ],
      [
        -3877.302734375,
        -5108.54541015625,
        1037.6239013671875
      ],
      [
        -3877.0,
        -5108.32568359375,
        1037.6239013671875
      ],
      [
        -3877.0,
        -5097.9326171875,
        1037.6239013671875
      ],
      [
        -3877.0,
        -5097.9326171875,
        1037.6239013671875
      ],
      [
        -3881.774658203125,
        -5053.25,
        1015.6239013671875
      ],
      [
        -3877.0,
        -5066.76904296875,
        1015.6239013671875
      ],
      [
        -3927.0,
        -5066.76904296875,
        1015.6239013671875
      ],
      [
        -3922.225341796875,
        -5053.25,
        1015.6239013671875
      ],
      [
        -3922.225341796875,
        -5080.2880859375,
        1015.6239013671875
      ],
      [
        -3927.0,
        -5066.76904296875,
        1015.6239013671875
      ],
      [
        -3877.0,
        -5066.76904296875,
        1015.6239013671875
      ],
      [
        -3881.774658203125,
        -5080.2880859375,
        1015.6239013671875
      ],
      [
        -3922.225341796875,
        -5053.25,
        1015.6239013671875
      ],
      [
        -3894.765380859375,
        -5034.89453125,
        1027.8258056640625
      ],
      [
        -3894.274658203125,
        -5034.56640625,
        1027.8258056640625
      ],
      [
        -3894.274658203125,
        -5029.7998046875,
        1027.8258056640625
      ],
      [
        -3909.725341796875,
        -5029.7998046875,
        1027.8258056640625
      ],
      [
        -3899.253662109375,
        -5037.89453125,
        1032.6239013671875
      ],
      [
        -3894.765380859375,
        -5034.89453125,
        1027.8258056640625
      ],
      [
        -3909.725341796875,
        -5029.7998046875,
        1027.8258056640625
      ],
      [
        -3909.725341796875,
        -5029.7998046875,
        1015.6257934570312
      ],
      [
        -3894.274658203125,
        -5034.56640625,
        1015.6257934570312
      ],
      [
        -3894.274658203125,
        -5029.7998046875,
        1015.6257934570312
      ],
      [
        -3894.274658203125,
        -5029.7998046875,
        1027.8258056640625
      ],
      [
        -3894.274658203125,
        -5034.56640625,
        1027.8258056640625
      ],
      [
        -3881.774658203125,
        -5053.25,
        1015.6239013671875
      ],
      [
        -3922.225341796875,
        -5080.2880859375,
        1015.6239013671875
      ],
      [
        -3912.0,
        -5063.76904296875,
        1015.6239013671875
      ],
      [
        -3912.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      [
        -3912.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      [
        -3916.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      [
        -3916.0,
        -5063.76904296875,
        1015.6239013671875
      ],
      [
        -3912.0,
        -5063.76904296875,
        1015.6239013671875
      ],
      [
        -3916.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      [
        -3916.0,
        -5063.76904296875,
        1015.6239013671875
      ],
      [
        -3881.774658203125,
        -5080.2880859375,
        1015.6239013671875
      ],
      [
        -3892.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      [
        -3892.0,
        -5063.76904296875,
        1015.6239013671875
      ],
      [
        -3888.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      [
        -3892.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      [
        -3892.0,
        -5063.76904296875,
        1015.6239013671875
      ],
      [
        -3888.0,
        -5063.76904296875,
        1015.6239013671875
      ],
      [
        -3888.0,
        -5063.76904296875,
        1015.6239013671875
      ],
      [
        -3888.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      [
        -3909.725341796875,
        -5094.01904296875,
        1015.6239013671875
      ],
      [
        -3907.0,
        -5094.01904296875,
        1015.6239013671875
      ],
      [
        -3894.274658203125,
        -5094.01904296875,
        1015.6239013671875
      ],
      [
        -3897.0,
        -5094.01904296875,
        1015.6239013671875
      ],
      [
        -3897.0,
        -5095.51904296875,
        1015.6239013671875
      ],
      [
        -3894.274658203125,
        -5095.51904296875,
        1015.6239013671875
      ],
      [
        -3907.0,
        -5095.51904296875,
        1015.6239013671875
      ],
      [
        -3909.725341796875,
        -5095.51904296875,
        1015.6239013671875
      ],
      [
        -3907.0,
        -5094.01904296875,
        1015.6239013671875
      ],
      [
        -3907.0,
        -5095.51904296875,
        1015.6239013671875
      ],
      [
        -3897.0,
        -5094.01904296875,
        1015.6239013671875
      ],
      [
        -3897.0,
        -5095.51904296875,
        1015.6239013671875
      ],
      [
        -3877.0,
        -5114.505859375,
        1032.6239013671875
      ],
      [
        -3877.0,
        -5114.505859375,
        1015.6239013671875
      ],
      [
        -3927.0,
        -5114.505859375,
        1032.6239013671875
      ],
      [
        -3927.0,
        -5114.505859375,
        1015.6239013671875
      ],
      [
        -3947.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3946.96923828125,
        -5029.7998046875,
        1032.6546630859375
      ],
      [
        -3927.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3927.03076171875,
        -5029.7998046875,
        1032.6546630859375
      ],
      [
        -3932.000244140625,
        -5104.69287109375,
        1037.6239013671875
      ],
      [
        -3932.000244140625,
        -5101.5654296875,
        1037.6239013671875
      ],
      [
        -3932.000244140625,
        -5101.5654296875,
        1037.6239013671875
      ],
      [
        -3932.000244140625,
        -5104.69287109375,
        1037.6239013671875
      ],
      [
        -3946.96923828125,
        -5029.7998046875,
        1032.6546630859375
      ],
      [
        -3927.03076171875,
        -5029.7998046875,
        1032.6546630859375
      ],
      [
        -3857.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3857.03076171875,
        -5029.7998046875,
        1032.6546630859375
      ],
      [
        -3877.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3876.96923828125,
        -5029.7998046875,
        1032.6546630859375
      ],
      [
        -3871.999755859375,
        -5104.69287109375,
        1037.6239013671875
      ],
      [
        -3871.999755859375,
        -5101.5654296875,
        1037.6239013671875
      ],
      [
        -3871.999755859375,
        -5101.5654296875,
        1037.6239013671875
      ],
      [
        -3871.999755859375,
        -5104.69287109375,
        1037.6239013671875
      ],
      [
        -3876.96923828125,
        -5029.7998046875,
        1032.6546630859375
      ],
      [
        -3857.03076171875,
        -5029.7998046875,
        1032.6546630859375
      ],
      [
        -3717.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3717.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3717.0,
        -5084.76904296875,
        1037.6239013671875
      ],
      [
        -3737.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3736.96923828125,
        -5029.7998046875,
        1032.6546630859375
      ],
      [
        -3717.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      [
        -3717.03076171875,
        -5029.7998046875,
        1032.6546630859375
      ],
      [
        -3720.53564453125,
        -5096.2333984375,
        1036.1593017578125
      ],
      [
        -3722.000244140625,
        -5092.69775390625,
        1037.6239013671875
      ],
      [
        -3736.96923828125,
        -5029.7998046875,
        1032.6546630859375
      ],
      [
        -3717.03076171875,
        -5029.7998046875,
        1032.6546630859375
      ],
      [
        -3787.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3807.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3857.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3877.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3927.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3947.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3717.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3737.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3922.225341796875,
        -5053.25,
        1013.6239013671875
      ],
      [
        -3881.774658203125,
        -5053.25,
        1013.6239013671875
      ],
      [
        -3909.725341796875,
        -5088.6435546875,
        1013.6239013671875
      ],
      [
        -3922.225341796875,
        -5080.2880859375,
        1013.6239013671875
      ],
      [
        -3881.774658203125,
        -5080.2880859375,
        1013.6239013671875
      ],
      [
        -3894.274658203125,
        -5088.6435546875,
        1013.6239013671875
      ],
      [
        -3881.774658203125,
        -5053.25,
        1013.6239013671875
      ],
      [
        -3877.0,
        -5066.76904296875,
        1013.6239013671875
      ],
      [
        -3927.0,
        -5066.76904296875,
        1013.6239013671875
      ],
      [
        -3922.225341796875,
        -5053.25,
        1013.6239013671875
      ],
      [
        -3922.225341796875,
        -5080.2880859375,
        1013.6239013671875
      ],
      [
        -3927.0,
        -5066.76904296875,
        1013.6239013671875
      ],
      [
        -3877.0,
        -5066.76904296875,
        1013.6239013671875
      ],
      [
        -3881.774658203125,
        -5080.2880859375,
        1013.6239013671875
      ],
      [
        -3892.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      [
        -3892.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      [
        -3888.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      [
        -3888.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      [
        -3888.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      [
        -3888.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      [
        -3888.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      [
        -3892.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      [
        -3892.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      [
        -3888.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      [
        -3912.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      [
        -3912.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      [
        -3912.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      [
        -3916.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      [
        -3916.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      [
        -3912.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      [
        -3916.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      [
        -3916.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      [
        -3737.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3737.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3857.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3857.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3807.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3787.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3877.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3877.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3888.09423828125,
        -5099.05517578125,
        1013.6239013671875
      ],
      [
        -3888.09423828125,
        -5099.05517578125,
        1015.6239013671875
      ],
      [
        -3888.09423828125,
        -5084.51220703125,
        1015.6248779296875
      ],
      [
        -3888.09423828125,
        -5084.51220703125,
        1013.6239013671875
      ],
      [
        -3888.09423828125,
        -5049.02587890625,
        1015.6248779296875
      ],
      [
        -3888.09423828125,
        -5049.02587890625,
        1013.6248779296875
      ],
      [
        -3888.09423828125,
        -5067.76904296875,
        1013.6239013671875
      ],
      [
        -3888.09423828125,
        -5067.76904296875,
        1015.6239013671875
      ],
      [
        -3888.09423828125,
        -5063.76904296875,
        1013.6239013671875
      ],
      [
        -3888.09423828125,
        -5063.76904296875,
        1015.6239013671875
      ],
      [
        -3877.0,
        -5114.505859375,
        1015.6239013671875
      ],
      [
        -3877.0,
        -5114.505859375,
        1013.6239013671875
      ],
      [
        -3717.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3717.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3947.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3947.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3927.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      [
        -3927.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      [
        -3927.0,
        -5114.505859375,
        1015.6239013671875
      ],
      [
        -3927.0,
        -5114.505859375,
        1013.6239013671875
      ],
      [
        -3915.90576171875,
        -5099.05517578125,
        1013.6239013671875
      ],
      [
        -3915.90576171875,
        -5099.05517578125,
        1015.6239013671875
      ],
      [
        -3915.90576171875,
        -5084.51220703125,
        1015.6248779296875
      ],
      [
        -3915.90576171875,
        -5084.51220703125,
        1013.6239013671875
      ],
      [
        -3915.90576171875,
        -5049.02587890625,
        1015.6248779296875
      ],
      [
        -3915.90576171875,
        -5049.02587890625,
        1013.6248779296875
      ],
      [
        -3915.90576171875,
        -5067.76904296875,
        1013.6239013671875
      ],
      [
        -3915.90576171875,
        -5067.76904296875,
        1015.6239013671875
      ],
      [
        -3915.90576171875,
        -5063.76904296875,
        1013.6239013671875
      ],
      [
        -3915.90576171875,
        -5063.76904296875,
        1015.6239013671875
      ],
      [
        -3909.725341796875,
        -5044.89453125,
        1014.6257934570312
      ],
      [
        -3912.71728515625,
        -5046.89453125,
        1013.6253662109375
      ],
      [
        -3912.71728515625,
        -5046.89453125,
        1014.6257934570312
      ],
      [
        -3894.274658203125,
        -5044.89453125,
        1014.6257934570312
      ],
      [
        -3891.28271484375,
        -5046.89453125,
        1014.6257934570312
      ],
      [
        -3891.28271484375,
        -5046.89453125,
        1013.6253662109375
      ],
      [
        -3912.71728515625,
        -5046.89453125,
        1015.6253662109375
      ],
      [
        -3891.28271484375,
        -5046.89453125,
        1015.6253662109375
      ],
      [
        -3997.0,
        -4989.76904296875,
        1032.6239013671875
      ],
      [
        -3807.0,
        -5012.73095703125,
        1008.8086547851562
      ],
      [
        -3877.0,
        -5012.73095703125,
        1008.8086547851562
      ],
      [
        -3947.0,
        -5012.73095703125,
        1008.8086547851562
      ],
      [
        -3927.0,
        -5012.73095703125,
        1008.8086547851562
      ],
      [
        -3857.0,
        -5012.73095703125,
        1008.8086547851562
      ],
      [
        -3737.0,
        -5012.73095703125,
        1008.8086547851562
      ],
      [
        -3787.0,
        -5012.73095703125,
        1008.8086547851562
      ],
      [
        -3717.0,
        -5012.73095703125,
        1008.8086547851562
      ],
      [
        -3997.0,
        -5029.76904296875,
        1027.6240234375
      ],
      [
        -3997.0,
        -4924.76904296875,
        1025.6239013671875
      ],
      [
        -4037.0,
        -4924.76904296875,
        1025.6239013671875
      ],
      [
        -4037.0,
        -4924.76904296875,
        1025.6239013671875
      ],
      [
        -3997.0,
        -4974.76904296875,
        1025.6239013671875
      ],
      [
        -4037.0,
        -4974.76904296875,
        1025.6239013671875
      ],
      [
        -4037.0,
        -4974.76904296875,
        1025.6239013671875
      ],
      [
        -3997.0,
        -4919.76904296875,
        1025.6239013671875
      ],
      [
        -4037.0,
        -4919.76904296875,
        1025.6239013671875
      ],
      [
        -4037.0,
        -4919.76904296875,
        1025.6239013671875
      ],
      [
        -3997.0,
        -4979.76904296875,
        1025.6239013671875
      ],
      [
        -4037.0,
        -4979.76904296875,
        1025.6239013671875
      ],
      [
        -4037.0,
        -4979.76904296875,
        1025.6239013671875
      ],
      [
        -3667.0,
        -4981.427734375,
        1057.5999755859375
      ],
      [
        -3997.0,
        -4981.427734375,
        1057.5999755859375
      ],
      [
        -3997.0,
        -4918.1103515625,
        1057.5999755859375
      ],
      [
        -3667.0,
        -4918.1103515625,
        1057.5999755859375
      ],
      [
        -3667.0,
        -4974.76904296875,
        1057.5999755859375
      ],
      [
        -3997.0,
        -4974.76904296875,
        1057.5999755859375
      ],
      [
        -3737.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3737.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3717.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3717.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3807.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3807.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3787.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3787.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3927.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3927.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3947.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3947.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3877.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3877.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3857.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3857.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3717.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3717.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3667.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3667.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3787.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3787.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3737.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3737.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3947.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3947.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3997.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3997.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3857.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3857.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3807.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3807.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3877.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3877.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3927.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      [
        -3927.0,
        -4984.76953125,
        1067.6239013671875
      ],
      [
        -3997.0,
        -4924.76904296875,
        1057.5999755859375
      ],
      [
        -3667.0,
        -4924.76904296875,
        1057.5999755859375
      ],
      [
        -3737.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3737.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3717.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3717.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3807.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3807.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3787.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3787.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3927.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3927.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3947.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3947.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3877.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3877.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3857.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3857.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3717.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3717.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3667.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3667.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3787.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3787.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3737.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3737.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3947.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3947.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3997.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3997.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3857.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3857.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3807.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3807.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3877.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3877.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3927.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      [
        -3927.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      [
        -3892.0,
        -4949.76904296875,
        1057.5999755859375
      ],
      [
        -3894.928955078125,
        -4942.69775390625,
        1057.5999755859375
      ],
      [
        -3894.928955078125,
        -4956.84033203125,
        1057.5999755859375
      ],
      [
        -3892.0,
        -4949.76904296875,
        1057.5999755859375
      ],
      [
        -3894.928955078125,
        -4942.69775390625,
        1057.5999755859375
      ],
      [
        -3902.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      [
        -3902.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      [
        -3909.071044921875,
        -4942.69775390625,
        1057.5999755859375
      ],
      [
        -3909.071044921875,
        -4942.69775390625,
        1057.5999755859375
      ],
      [
        -3912.0,
        -4949.76904296875,
        1057.5999755859375
      ],
      [
        -3912.0,
        -4949.76904296875,
        1057.5999755859375
      ],
      [
        -3909.071044921875,
        -4956.84033203125,
        1057.5999755859375
      ],
      [
        -3909.071044921875,
        -4956.84033203125,
        1057.5999755859375
      ],
      [
        -3902.0,
        -4959.76904296875,
        1057.5999755859375
      ],
      [
        -3902.0,
        -4959.76904296875,
        1057.5999755859375
      ],
      [
        -3894.928955078125,
        -4956.84033203125,
        1057.5999755859375
      ],
      [
        -3898.08056640625,
        -4961.392578125,
        1057.6239013671875
      ],
      [
        -3896.552490234375,
        -4960.759765625,
        1057.6239013671875
      ],
      [
        -3907.447509765625,
        -4960.759765625,
        1057.6239013671875
      ],
      [
        -3913.62353515625,
        -4953.6884765625,
        1057.6239013671875
      ],
      [
        -3912.99072265625,
        -4944.32177734375,
        1057.6239013671875
      ],
      [
        -3905.919189453125,
        -4938.1455078125,
        1057.6239013671875
      ],
      [
        -3896.552490234375,
        -4938.7783203125,
        1057.6239013671875
      ],
      [
        -3890.37646484375,
        -4953.6884765625,
        1057.6239013671875
      ],
      [
        -3839.071044921875,
        -4942.69775390625,
        1057.5999755859375
      ],
      [
        -3842.0,
        -4949.76904296875,
        1057.5999755859375
      ],
      [
        -3842.0,
        -4949.76904296875,
        1057.5999755859375
      ],
      [
        -3839.071044921875,
        -4956.84033203125,
        1057.5999755859375
      ],
      [
        -3832.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      [
        -3839.071044921875,
        -4942.69775390625,
        1057.5999755859375
      ],
      [
        -3824.928955078125,
        -4942.69775390625,
        1057.5999755859375
      ],
      [
        -3832.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      [
        -3822.0,
        -4949.76904296875,
        1057.5999755859375
      ],
      [
        -3824.928955078125,
        -4942.69775390625,
        1057.5999755859375
      ],
      [
        -3824.928955078125,
        -4956.84033203125,
        1057.5999755859375
      ],
      [
        -3822.0,
        -4949.76904296875,
        1057.5999755859375
      ],
      [
        -3839.071044921875,
        -4956.84033203125,
        1057.5999755859375
      ],
      [
        -3832.0,
        -4959.76904296875,
        1057.5999755859375
      ],
      [
        -3832.0,
        -4959.76904296875,
        1057.5999755859375
      ],
      [
        -3824.928955078125,
        -4956.84033203125,
        1057.5999755859375
      ],
      [
        -3828.080322265625,
        -4961.392578125,
        1057.6239013671875
      ],
      [
        -3826.552490234375,
        -4960.759765625,
        1057.6239013671875
      ],
      [
        -3837.447509765625,
        -4960.759765625,
        1057.6239013671875
      ],
      [
        -3820.376220703125,
        -4953.68798828125,
        1057.6239013671875
      ],
      [
        -3821.00927734375,
        -4944.3212890625,
        1057.6239013671875
      ],
      [
        -3828.080322265625,
        -4938.1455078125,
        1057.6239013671875
      ],
      [
        -3837.447509765625,
        -4938.7783203125,
        1057.6239013671875
      ],
      [
        -3843.62353515625,
        -4953.6884765625,
        1057.6239013671875
      ],
      [
        -3754.928955078125,
        -4956.84033203125,
        1057.5999755859375
      ],
      [
        -3752.0,
        -4949.76904296875,
        1057.5999755859375
      ],
      [
        -3752.0,
        -4949.76904296875,
        1057.5999755859375
      ],
      [
        -3754.928955078125,
        -4942.69775390625,
        1057.5999755859375
      ],
      [
        -3754.928955078125,
        -4942.69775390625,
        1057.5999755859375
      ],
      [
        -3762.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      [
        -3762.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      [
        -3769.071044921875,
        -4942.69775390625,
        1057.5999755859375
      ],
      [
        -3769.071044921875,
        -4942.69775390625,
        1057.5999755859375
      ],
      [
        -3772.0,
        -4949.76904296875,
        1057.5999755859375
      ],
      [
        -3772.0,
        -4949.76904296875,
        1057.5999755859375
      ],
      [
        -3769.071044921875,
        -4956.84033203125,
        1057.5999755859375
      ],
      [
        -3769.071044921875,
        -4956.84033203125,
        1057.5999755859375
      ],
      [
        -3762.0,
        -4959.76904296875,
        1057.5999755859375
      ],
      [
        -3762.0,
        -4959.76904296875,
        1057.5999755859375
      ],
      [
        -3754.928955078125,
        -4956.84033203125,
        1057.5999755859375
      ],
      [
        -3758.08056640625,
        -4961.392578125,
        1057.6239013671875
      ],
      [
        -3756.552490234375,
        -4960.759765625,
        1057.6239013671875
      ],
      [
        -3767.447509765625,
        -4960.759765625,
        1057.6239013671875
      ],
      [
        -3773.62353515625,
        -4953.6884765625,
        1057.6239013671875
      ],
      [
        -3772.99072265625,
        -4944.3212890625,
        1057.6239013671875
      ],
      [
        -3765.919189453125,
        -4938.1455078125,
        1057.6239013671875
      ],
      [
        -3756.552734375,
        -4938.7783203125,
        1057.6239013671875
      ],
      [
        -3750.37646484375,
        -4945.849609375,
        1057.6239013671875
      ],
      [
        -3839.071044921875,
        -4942.69775390625,
        1052.5999755859375
      ],
      [
        -3842.0,
        -4949.76904296875,
        1052.5999755859375
      ],
      [
        -3769.071044921875,
        -4942.69775390625,
        1052.5999755859375
      ],
      [
        -3772.0,
        -4949.76904296875,
        1052.5999755859375
      ],
      [
        -3754.928955078125,
        -4956.84033203125,
        1052.5999755859375
      ],
      [
        -3752.0,
        -4949.76904296875,
        1052.5999755859375
      ],
      [
        -3752.0,
        -4949.76904296875,
        1052.5999755859375
      ],
      [
        -3754.928955078125,
        -4942.69775390625,
        1052.5999755859375
      ],
      [
        -3772.0,
        -4949.76904296875,
        1052.5999755859375
      ],
      [
        -3769.071044921875,
        -4956.84033203125,
        1052.5999755859375
      ],
      [
        -3754.928955078125,
        -4942.69775390625,
        1052.5999755859375
      ],
      [
        -3762.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      [
        -3762.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      [
        -3769.071044921875,
        -4942.69775390625,
        1052.5999755859375
      ],
      [
        -3769.071044921875,
        -4956.84033203125,
        1052.5999755859375
      ],
      [
        -3762.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      [
        -3762.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      [
        -3754.928955078125,
        -4956.84033203125,
        1052.5999755859375
      ],
      [
        -3824.928955078125,
        -4956.84033203125,
        1052.5999755859375
      ],
      [
        -3822.0,
        -4949.76904296875,
        1052.5999755859375
      ],
      [
        -3822.0,
        -4949.76904296875,
        1052.5999755859375
      ],
      [
        -3824.928955078125,
        -4942.69775390625,
        1052.5999755859375
      ],
      [
        -3842.0,
        -4949.76904296875,
        1052.5999755859375
      ],
      [
        -3839.071044921875,
        -4956.84033203125,
        1052.5999755859375
      ],
      [
        -3824.928955078125,
        -4942.69775390625,
        1052.5999755859375
      ],
      [
        -3832.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      [
        -3832.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      [
        -3839.071044921875,
        -4942.69775390625,
        1052.5999755859375
      ],
      [
        -3839.071044921875,
        -4956.84033203125,
        1052.5999755859375
      ],
      [
        -3832.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      [
        -3832.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      [
        -3824.928955078125,
        -4956.84033203125,
        1052.5999755859375
      ],
      [
        -3892.0,
        -4949.76904296875,
        1052.5999755859375
      ],
      [
        -3894.928955078125,
        -4942.69775390625,
        1052.5999755859375
      ],
      [
        -3894.928955078125,
        -4956.84033203125,
        1052.5999755859375
      ],
      [
        -3892.0,
        -4949.76904296875,
        1052.5999755859375
      ],
      [
        -3909.071044921875,
        -4942.69775390625,
        1052.5999755859375
      ],
      [
        -3912.0,
        -4949.76904296875,
        1052.5999755859375
      ],
      [
        -3912.0,
        -4949.76904296875,
        1052.5999755859375
      ],
      [
        -3909.071044921875,
        -4956.84033203125,
        1052.5999755859375
      ],
      [
        -3894.928955078125,
        -4942.69775390625,
        1052.5999755859375
      ],
      [
        -3902.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      [
        -3902.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      [
        -3909.071044921875,
        -4942.69775390625,
        1052.5999755859375
      ],
      [
        -3909.071044921875,
        -4956.84033203125,
        1052.5999755859375
      ],
      [
        -3902.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      [
        -3902.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      [
        -3894.928955078125,
        -4956.84033203125,
        1052.5999755859375
      ],
      [
        -3717.0,
        -4982.59423828125,
        980.2155151367188
      ],
      [
        -3737.0,
        -4982.59423828125,
        980.2155151367188
      ],
      [
        -3737.0,
        -4916.94384765625,
        980.2155151367188
      ],
      [
        -3717.0,
        -4916.94384765625,
        980.2155151367188
      ],
      [
        -3787.0,
        -4982.59423828125,
        980.2155151367188
      ],
      [
        -3807.0,
        -4982.59423828125,
        980.2155151367188
      ],
      [
        -3807.0,
        -4916.94384765625,
        980.2155151367188
      ],
      [
        -3787.0,
        -4916.94384765625,
        980.2155151367188
      ],
      [
        -3857.0,
        -4982.59423828125,
        980.2155151367188
      ],
      [
        -3877.0,
        -4982.59423828125,
        980.2155151367188
      ],
      [
        -3877.0,
        -4916.94384765625,
        980.2155151367188
      ],
      [
        -3857.0,
        -4916.94384765625,
        980.2155151367188
      ],
      [
        -3927.0,
        -4982.59423828125,
        980.2155151367188
      ],
      [
        -3947.0,
        -4982.59423828125,
        980.2155151367188
      ],
      [
        -3947.0,
        -4916.94384765625,
        980.2155151367188
      ],
      [
        -3927.0,
        -4916.94384765625,
        980.2155151367188
      ],
      [
        -3857.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3857.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3737.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3717.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3807.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3787.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3857.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3807.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3717.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3667.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3787.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3737.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3737.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3737.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3807.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3807.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3857.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3807.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3787.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3787.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3787.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3737.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3787.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3807.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3807.0,
        -4819.76904296875,
        1015.6239013671875
      ],
      [
        -3787.0,
        -4819.76904296875,
        1015.6239013671875
      ],
      [
        -3807.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3787.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3717.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3717.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3717.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3667.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3667.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3667.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3717.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3737.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3737.0,
        -4819.76904296875,
        1015.6239013671875
      ],
      [
        -3717.0,
        -4819.76904296875,
        1015.6239013671875
      ],
      [
        -3737.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3717.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -4108.0,
        -4645.26904296875,
        1029.6239013671875
      ],
      [
        -4108.0,
        -4645.76904296875,
        1032.6239013671875
      ],
      [
        -4108.0,
        -4643.26904296875,
        1029.6239013671875
      ],
      [
        -4108.0,
        -4645.26904296875,
        1029.6239013671875
      ],
      [
        -4128.0,
        -4645.7685546875,
        1032.6239013671875
      ],
      [
        -4133.0,
        -4645.2685546875,
        1029.6239013671875
      ],
      [
        -4133.0,
        -4643.43603515625,
        1018.6239013671875
      ],
      [
        -4133.0,
        -4645.2685546875,
        1029.6239013671875
      ],
      [
        -4128.0,
        -4642.935546875,
        1015.6239013671875
      ],
      [
        -4133.0,
        -4643.43603515625,
        1018.6239013671875
      ],
      [
        -4108.0,
        -4654.26904296875,
        1029.6239013671875
      ],
      [
        -4108.0,
        -4656.26904296875,
        1029.6239013671875
      ],
      [
        -4108.0,
        -4656.26904296875,
        1029.6239013671875
      ],
      [
        -4108.0,
        -4656.76904296875,
        1032.6239013671875
      ],
      [
        -4128.0,
        -4656.76904296875,
        1032.6239013671875
      ],
      [
        -4133.0,
        -4656.26904296875,
        1029.6239013671875
      ],
      [
        -4032.64794921875,
        -4666.9248046875,
        1029.6239013671875
      ],
      [
        -4087.0,
        -4659.76904296875,
        1029.6239013671875
      ],
      [
        -3927.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3947.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3906.0,
        -4869.76904296875,
        1032.6239013671875
      ],
      [
        -3927.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3906.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3947.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3997.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3947.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3947.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3947.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3997.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3997.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3997.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3927.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3927.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3906.0,
        -4869.76904296875,
        1015.6239013671875
      ],
      [
        -3906.0,
        -4869.76904296875,
        1032.6239013671875
      ],
      [
        -3906.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3927.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3906.0,
        -4869.76904296875,
        1015.6239013671875
      ],
      [
        -3927.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3947.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3927.0,
        -4819.76904296875,
        1015.6239013671875
      ],
      [
        -3947.0,
        -4819.76904296875,
        1015.6239013671875
      ],
      [
        -3927.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3947.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3864.8369140625,
        -4810.24072265625,
        1016.6239013671875
      ],
      [
        -3887.814208984375,
        -4754.76904296875,
        1016.6239013671875
      ],
      [
        -3871.995361328125,
        -4792.958984375,
        1015.6239013671875
      ],
      [
        -3890.1162109375,
        -4801.02685546875,
        1015.6239013671875
      ],
      [
        -3884.14990234375,
        -4803.380859375,
        1015.6239013671875
      ],
      [
        -3885.1474609375,
        -4804.7890625,
        1015.6239013671875
      ],
      [
        -3886.85546875,
        -4804.54345703125,
        1015.6239013671875
      ],
      [
        -3887.56591796875,
        -4802.8896484375,
        1015.6239013671875
      ],
      [
        -3884.8603515625,
        -4801.72705078125,
        1015.6239013671875
      ],
      [
        -3884.14990234375,
        -4803.380859375,
        1015.6239013671875
      ],
      [
        -3887.56591796875,
        -4802.8896484375,
        1015.6239013671875
      ],
      [
        -3886.568359375,
        -4801.4814453125,
        1015.6239013671875
      ],
      [
        -3886.568359375,
        -4801.4814453125,
        1015.6239013671875
      ],
      [
        -3884.8603515625,
        -4801.72705078125,
        1015.6239013671875
      ],
      [
        -3885.1474609375,
        -4804.7890625,
        1015.6239013671875
      ],
      [
        -3886.85546875,
        -4804.54345703125,
        1015.6239013671875
      ],
      [
        -3882.1484375,
        -4808.47119140625,
        1015.6239013671875
      ],
      [
        -3881.437744140625,
        -4810.125,
        1015.6239013671875
      ],
      [
        -3884.143310546875,
        -4811.28759765625,
        1015.6239013671875
      ],
      [
        -3884.853759765625,
        -4809.6337890625,
        1015.6239013671875
      ],
      [
        -3881.437744140625,
        -4810.125,
        1015.6239013671875
      ],
      [
        -3882.435302734375,
        -4811.533203125,
        1015.6239013671875
      ],
      [
        -3884.853759765625,
        -4809.6337890625,
        1015.6239013671875
      ],
      [
        -3883.8564453125,
        -4808.2255859375,
        1015.6239013671875
      ],
      [
        -3883.8564453125,
        -4808.2255859375,
        1015.6239013671875
      ],
      [
        -3882.1484375,
        -4808.47119140625,
        1015.6239013671875
      ],
      [
        -3882.435302734375,
        -4811.533203125,
        1015.6239013671875
      ],
      [
        -3884.143310546875,
        -4811.28759765625,
        1015.6239013671875
      ],
      [
        -3884.155517578125,
        -4815.4169921875,
        1016.6239013671875
      ],
      [
        -3905.134765625,
        -4764.76904296875,
        1016.6239013671875
      ],
      [
        -3884.14990234375,
        -4803.380859375,
        1016.6239013671875
      ],
      [
        -3885.1474609375,
        -4804.7890625,
        1016.6239013671875
      ],
      [
        -3886.85546875,
        -4804.54345703125,
        1016.6239013671875
      ],
      [
        -3887.56591796875,
        -4802.8896484375,
        1016.6239013671875
      ],
      [
        -3884.8603515625,
        -4801.72705078125,
        1016.6239013671875
      ],
      [
        -3884.14990234375,
        -4803.380859375,
        1016.6239013671875
      ],
      [
        -3887.56591796875,
        -4802.8896484375,
        1016.6239013671875
      ],
      [
        -3886.568359375,
        -4801.4814453125,
        1016.6239013671875
      ],
      [
        -3886.568359375,
        -4801.4814453125,
        1016.6239013671875
      ],
      [
        -3884.8603515625,
        -4801.72705078125,
        1016.6239013671875
      ],
      [
        -3885.1474609375,
        -4804.7890625,
        1016.6239013671875
      ],
      [
        -3886.85546875,
        -4804.54345703125,
        1016.6239013671875
      ],
      [
        -3882.1484375,
        -4808.47119140625,
        1016.6239013671875
      ],
      [
        -3881.437744140625,
        -4810.125,
        1016.6239013671875
      ],
      [
        -3884.143310546875,
        -4811.28759765625,
        1016.6239013671875
      ],
      [
        -3884.853759765625,
        -4809.6337890625,
        1016.6239013671875
      ],
      [
        -3881.437744140625,
        -4810.125,
        1016.6239013671875
      ],
      [
        -3882.435302734375,
        -4811.533203125,
        1016.6239013671875
      ],
      [
        -3884.853759765625,
        -4809.6337890625,
        1016.6239013671875
      ],
      [
        -3883.8564453125,
        -4808.2255859375,
        1016.6239013671875
      ],
      [
        -3883.8564453125,
        -4808.2255859375,
        1016.6239013671875
      ],
      [
        -3882.1484375,
        -4808.47119140625,
        1016.6239013671875
      ],
      [
        -3882.435302734375,
        -4811.533203125,
        1016.6239013671875
      ],
      [
        -3884.143310546875,
        -4811.28759765625,
        1016.6239013671875
      ],
      [
        -3857.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3877.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3881.81298828125,
        -4833.2099609375,
        1012.9512939453125
      ],
      [
        -3869.01708984375,
        -4830.72265625,
        1012.968017578125
      ],
      [
        -3862.31201171875,
        -4829.41943359375,
        1012.9461059570312
      ],
      [
        -3877.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      [
        -3877.0,
        -4869.7998046875,
        1013.6243896484375
      ],
      [
        -3884.155517578125,
        -4815.4169921875,
        1012.7108764648438
      ],
      [
        -3881.81298828125,
        -4833.2099609375,
        1013.009765625
      ],
      [
        -3877.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3877.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3857.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3877.0,
        -4869.7998046875,
        1015.611572265625
      ],
      [
        -3881.81298828125,
        -4833.2099609375,
        1015.6239013671875
      ],
      [
        -3862.31201171875,
        -4829.41943359375,
        1015.6239013671875
      ],
      [
        -3880.212158203125,
        -4821.29052734375,
        1015.6239013671875
      ],
      [
        -3881.81005859375,
        -4820.638671875,
        1015.6239013671875
      ],
      [
        -3881.81005859375,
        -4820.638671875,
        1015.6239013671875
      ],
      [
        -3882.099365234375,
        -4818.8623046875,
        1015.6239013671875
      ],
      [
        -3879.193115234375,
        -4818.38916015625,
        1015.6239013671875
      ],
      [
        -3878.90380859375,
        -4820.16552734375,
        1015.6239013671875
      ],
      [
        -3880.791015625,
        -4817.7373046875,
        1015.6239013671875
      ],
      [
        -3879.193115234375,
        -4818.38916015625,
        1015.6239013671875
      ],
      [
        -3882.099365234375,
        -4818.8623046875,
        1015.6239013671875
      ],
      [
        -3880.791015625,
        -4817.7373046875,
        1015.6239013671875
      ],
      [
        -3878.90380859375,
        -4820.16552734375,
        1015.6239013671875
      ],
      [
        -3880.212158203125,
        -4821.29052734375,
        1015.6239013671875
      ],
      [
        -3878.193115234375,
        -4825.5888671875,
        1015.6239013671875
      ],
      [
        -3877.90380859375,
        -4827.36572265625,
        1015.6239013671875
      ],
      [
        -3880.81005859375,
        -4827.8388671875,
        1015.6239013671875
      ],
      [
        -3881.099365234375,
        -4826.0625,
        1015.6239013671875
      ],
      [
        -3879.212158203125,
        -4828.49072265625,
        1015.6239013671875
      ],
      [
        -3880.81005859375,
        -4827.8388671875,
        1015.6239013671875
      ],
      [
        -3879.791015625,
        -4824.9375,
        1015.6239013671875
      ],
      [
        -3878.193115234375,
        -4825.5888671875,
        1015.6239013671875
      ],
      [
        -3881.099365234375,
        -4826.0625,
        1015.6239013671875
      ],
      [
        -3879.791015625,
        -4824.9375,
        1015.6239013671875
      ],
      [
        -3877.90380859375,
        -4827.36572265625,
        1015.6239013671875
      ],
      [
        -3879.212158203125,
        -4828.49072265625,
        1015.6239013671875
      ],
      [
        -3877.0,
        -4869.76904296875,
        1016.6239013671875
      ],
      [
        -3884.155517578125,
        -4815.4169921875,
        1016.6239013671875
      ],
      [
        -3877.0,
        -4869.76904296875,
        1016.6239013671875
      ],
      [
        -3906.0,
        -4869.76904296875,
        1016.6239013671875
      ],
      [
        -3880.212158203125,
        -4821.29052734375,
        1016.6239013671875
      ],
      [
        -3881.81005859375,
        -4820.638671875,
        1016.6239013671875
      ],
      [
        -3881.81005859375,
        -4820.638671875,
        1016.6239013671875
      ],
      [
        -3882.099365234375,
        -4818.8623046875,
        1016.6239013671875
      ],
      [
        -3879.193115234375,
        -4818.38916015625,
        1016.6239013671875
      ],
      [
        -3878.90380859375,
        -4820.16552734375,
        1016.6239013671875
      ],
      [
        -3880.791015625,
        -4817.7373046875,
        1016.6239013671875
      ],
      [
        -3879.193115234375,
        -4818.38916015625,
        1016.6239013671875
      ],
      [
        -3882.099365234375,
        -4818.8623046875,
        1016.6239013671875
      ],
      [
        -3880.791015625,
        -4817.7373046875,
        1016.6239013671875
      ],
      [
        -3878.90380859375,
        -4820.16552734375,
        1016.6239013671875
      ],
      [
        -3880.212158203125,
        -4821.29052734375,
        1016.6239013671875
      ],
      [
        -3878.193115234375,
        -4825.5888671875,
        1016.6239013671875
      ],
      [
        -3877.90380859375,
        -4827.36572265625,
        1016.6239013671875
      ],
      [
        -3880.81005859375,
        -4827.8388671875,
        1016.6239013671875
      ],
      [
        -3881.099365234375,
        -4826.0625,
        1016.6239013671875
      ],
      [
        -3879.212158203125,
        -4828.49072265625,
        1016.6239013671875
      ],
      [
        -3880.81005859375,
        -4827.8388671875,
        1016.6239013671875
      ],
      [
        -3879.791015625,
        -4824.9375,
        1016.6239013671875
      ],
      [
        -3878.193115234375,
        -4825.5888671875,
        1016.6239013671875
      ],
      [
        -3881.099365234375,
        -4826.0625,
        1016.6239013671875
      ],
      [
        -3879.791015625,
        -4824.9375,
        1016.6239013671875
      ],
      [
        -3877.90380859375,
        -4827.36572265625,
        1016.6239013671875
      ],
      [
        -3879.212158203125,
        -4828.49072265625,
        1016.6239013671875
      ],
      [
        -3886.294921875,
        -4810.2529296875,
        1023.7573852539062
      ],
      [
        -3886.639404296875,
        -4809.42138671875,
        1022.2802124023438
      ],
      [
        -3886.294677734375,
        -4810.2529296875,
        1020.8128051757812
      ],
      [
        -3885.60595703125,
        -4811.916015625,
        1020.8226318359375
      ],
      [
        -3885.60595703125,
        -4811.916015625,
        1023.7671508789062
      ],
      [
        -3886.294921875,
        -4810.2529296875,
        1023.7573852539062
      ],
      [
        -3886.639404296875,
        -4809.42138671875,
        1022.2802124023438
      ],
      [
        -3886.294677734375,
        -4810.2529296875,
        1020.8128051757812
      ],
      [
        -3885.60595703125,
        -4811.916015625,
        1020.8226318359375
      ],
      [
        -3885.261474609375,
        -4812.74755859375,
        1022.2997436523438
      ],
      [
        -3885.261474609375,
        -4812.74755859375,
        1022.2997436523438
      ],
      [
        -3885.60595703125,
        -4811.916015625,
        1023.7671508789062
      ],
      [
        -3889.076171875,
        -4803.53857421875,
        1020.8440551757812
      ],
      [
        -3888.38720703125,
        -4805.20166015625,
        1020.853759765625
      ],
      [
        -3888.38720703125,
        -4805.20166015625,
        1023.79833984375
      ],
      [
        -3889.076171875,
        -4803.53857421875,
        1023.78857421875
      ],
      [
        -3889.076171875,
        -4803.53857421875,
        1023.78857421875
      ],
      [
        -3889.42041015625,
        -4802.70703125,
        1022.3114013671875
      ],
      [
        -3889.42041015625,
        -4802.70703125,
        1022.3114013671875
      ],
      [
        -3889.076171875,
        -4803.53857421875,
        1020.8440551757812
      ],
      [
        -3888.38720703125,
        -4805.20166015625,
        1020.853759765625
      ],
      [
        -3888.042724609375,
        -4806.033203125,
        1022.3308715820312
      ],
      [
        -3888.042724609375,
        -4806.033203125,
        1022.3308715820312
      ],
      [
        -3888.38720703125,
        -4805.20166015625,
        1023.79833984375
      ],
      [
        -3888.905517578125,
        -4803.95068359375,
        1020.846435546875
      ],
      [
        -3885.574462890625,
        -4804.97265625,
        1019.7457275390625
      ],
      [
        -3885.894775390625,
        -4804.681640625,
        1016.6239013671875
      ],
      [
        -3887.365966796875,
        -4803.35498046875,
        1016.6239013671875
      ],
      [
        -3886.13916015625,
        -4810.62890625,
        1020.8150024414062
      ],
      [
        -3882.862060546875,
        -4811.716796875,
        1019.74560546875
      ],
      [
        -3883.181396484375,
        -4811.42578125,
        1016.6239013671875
      ],
      [
        -3884.654052734375,
        -4810.0986328125,
        1016.6239013671875
      ],
      [
        -3877.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3857.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3877.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      [
        -3882.718994140625,
        -4826.326171875,
        1023.7874145507812
      ],
      [
        -3882.836669921875,
        -4825.43310546875,
        1022.3038330078125
      ],
      [
        -3882.484130859375,
        -4828.111328125,
        1023.8102416992188
      ],
      [
        -3882.718994140625,
        -4826.326171875,
        1023.7874145507812
      ],
      [
        -3882.718994140625,
        -4826.326171875,
        1020.8429565429688
      ],
      [
        -3882.484130859375,
        -4828.111328125,
        1020.8657836914062
      ],
      [
        -3882.836669921875,
        -4825.43310546875,
        1022.3038330078125
      ],
      [
        -3882.718994140625,
        -4826.326171875,
        1020.8429565429688
      ],
      [
        -3882.484130859375,
        -4828.111328125,
        1020.8657836914062
      ],
      [
        -3882.366455078125,
        -4829.00390625,
        1022.349365234375
      ],
      [
        -3882.366455078125,
        -4829.00390625,
        1022.349365234375
      ],
      [
        -3882.484130859375,
        -4828.111328125,
        1023.8102416992188
      ],
      [
        -3883.66796875,
        -4819.11767578125,
        1020.8214721679688
      ],
      [
        -3883.43310546875,
        -4820.9033203125,
        1020.8443603515625
      ],
      [
        -3883.43310546875,
        -4820.90283203125,
        1023.7888793945312
      ],
      [
        -3883.66796875,
        -4819.11767578125,
        1023.7659912109375
      ],
      [
        -3883.66796875,
        -4819.11767578125,
        1023.7659912109375
      ],
      [
        -3883.78564453125,
        -4818.22509765625,
        1022.2823486328125
      ],
      [
        -3883.78564453125,
        -4818.22509765625,
        1022.2823486328125
      ],
      [
        -3883.66796875,
        -4819.11767578125,
        1020.8214721679688
      ],
      [
        -3883.43310546875,
        -4820.9033203125,
        1020.8443603515625
      ],
      [
        -3883.315185546875,
        -4821.7958984375,
        1022.327880859375
      ],
      [
        -3883.315185546875,
        -4821.7958984375,
        1022.327880859375
      ],
      [
        -3883.43310546875,
        -4820.90283203125,
        1023.7888793945312
      ],
      [
        -3883.489990234375,
        -4820.47021484375,
        1020.8388061523438
      ],
      [
        -3881.249755859375,
        -4817.81201171875,
        1019.7459106445312
      ],
      [
        -3881.363037109375,
        -4818.22900390625,
        1016.6239013671875
      ],
      [
        -3881.891357421875,
        -4820.138671875,
        1016.6239013671875
      ],
      [
        -3882.54443359375,
        -4827.6533203125,
        1020.8599243164062
      ],
      [
        -3880.249755859375,
        -4825.01220703125,
        1019.7459106445312
      ],
      [
        -3880.363037109375,
        -4825.42919921875,
        1016.6239013671875
      ],
      [
        -3880.891357421875,
        -4827.3388671875,
        1016.6239013671875
      ],
      [
        -3857.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      [
        -3787.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      [
        -3717.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      [
        -3737.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      [
        -3807.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      [
        -3927.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      [
        -3877.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      [
        -3947.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      [
        -3667.0,
        -4869.7998046875,
        1027.5927734375
      ],
      [
        -3997.0,
        -4869.7998046875,
        1027.5927734375
      ],
      [
        -3667.0,
        -4877.26904296875,
        1020.1237182617188
      ],
      [
        -3997.0,
        -4877.26904296875,
        1020.1237182617188
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3667.0,
      "bbox_min": [
        -4037.0,
        -5201.56640625,
        829.6239013671875
      ],
      "bbox_max": [
        -3511.800048828125,
        -4909.76904296875,
        1067.6239013671875
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        -0.611905038356781,
        -0.3543611466884613,
        0.7071070671081543
      ],
      "plane_d": -4577.359375,
      "bbox_min": [
        -3667.0,
        -5099.76904296875,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4909.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0770937706183759e-06,
        -1.8655795201993897e-06,
        1.0
      ],
      "plane_d": -888.712646484375,
      "bbox_min": [
        -3601.944580078125,
        -5035.97509765625,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        888.707275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6119064092636108,
        0.3543584942817688,
        0.7071072459220886
      ],
      "plane_d": 3317.70068359375,
      "bbox_min": [
        -3601.944580078125,
        -5035.97509765625,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        888.707275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -878.70703125,
      "bbox_min": [
        -3601.944580078125,
        -5035.97509765625,
        878.70703125
      ],
      "bbox_max": [
        -3527.91259765625,
        -4932.0283203125,
        885.707275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8653658032417297,
        -0.5011407136917114,
        0.0
      ],
      "plane_d": -5587.65380859375,
      "bbox_min": [
        -3595.88330078125,
        -5032.47216796875,
        881.70703125
      ],
      "bbox_max": [
        -3542.636962890625,
        -4940.52685546875,
        885.707275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -878.70703125,
      "bbox_min": [
        -3581.159912109375,
        -5023.9755859375,
        878.70703125
      ],
      "bbox_max": [
        -3511.800048828125,
        -4930.87451171875,
        878.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -878.70703125,
      "bbox_min": [
        -3667.0,
        -5099.76904296875,
        878.70703125
      ],
      "bbox_max": [
        -3546.341796875,
        -4909.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1013.6239013671875,
      "bbox_min": [
        -3667.0,
        -5099.76904296875,
        926.70703125
      ],
      "bbox_max": [
        -3546.341796875,
        -4909.76904296875,
        1052.6239013671875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5044.599609375,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        1013.6239013671875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3570.0,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        948.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3560.0,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        948.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3193.087158203125,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -1848.58447265625,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 948.70703125,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1023.53759765625,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -6065.20849609375,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5014.50048828125,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.38267987966537476,
        -0.9238809943199158
      ],
      "plane_d": -1047.0482177734375,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9238795638084412,
        -0.38268330693244934
      ],
      "plane_d": -4274.33203125,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1858.48388671875,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 6075.1083984375,
      "bbox_min": [
        -3570.0,
        -5026.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785955429077148,
        0.2810981273651123,
        0.6785955429077148
      ],
      "plane_d": 3196.48779296875,
      "bbox_min": [
        -3570.0,
        -5026.50048828125,
        936.70703125
      ],
      "bbox_max": [
        -3566.414306640625,
        -5021.50048828125,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785979866981506,
        0.678598940372467,
        0.2810841500759125
      ],
      "plane_d": 5566.88623046875,
      "bbox_min": [
        -3570.0,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3566.609619140625,
        -5021.50048828125,
        940.2425537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.923879861831665,
        0.38268259167671204
      ],
      "plane_d": 4283.5732421875,
      "bbox_min": [
        -3567.0,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3566.609619140625,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38270050287246704,
        0.9238725304603577
      ],
      "plane_d": 1056.398681640625,
      "bbox_min": [
        -3567.0,
        -5026.50048828125,
        937.6498413085938
      ],
      "bbox_max": [
        -3566.414306640625,
        -5024.89111328125,
        938.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.923879861831665,
        0.38268259167671204
      ],
      "plane_d": 4283.5732421875,
      "bbox_min": [
        -3567.0,
        -5025.08642578125,
        937.6498413085938
      ],
      "bbox_max": [
        -3566.414306640625,
        -5024.89111328125,
        938.1212768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5024.50048828125,
      "bbox_min": [
        -3570.0,
        -5025.08642578125,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.923879861831665,
        0.38268259167671204
      ],
      "plane_d": 4283.5732421875,
      "bbox_min": [
        -3567.0,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3565.0,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1033.43701171875,
      "bbox_min": [
        -3570.0,
        -5024.50048828125,
        926.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785985231399536,
        -0.6785982251167297,
        -0.2810845375061035
      ],
      "plane_d": -718.976318359375,
      "bbox_min": [
        -3570.0,
        -5019.57177734375,
        936.70703125
      ],
      "bbox_max": [
        -3567.0,
        -5014.50048828125,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3183.187744140625,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        931.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785985231399536,
        -0.6785982251167297,
        -0.28108450770378113
      ],
      "plane_d": -5557.3837890625,
      "bbox_min": [
        -3565.0,
        -5026.50048828125,
        931.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5014.50048828125,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1033.43701171875,
      "bbox_min": [
        -3565.0,
        -5026.50048828125,
        931.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5021.50048828125,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785996556282043,
        0.2810785472393036,
        0.6785996556282043
      ],
      "plane_d": -1642.015380859375,
      "bbox_min": [
        -3563.58544921875,
        -5026.50048828125,
        936.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5021.50048828125,
        941.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785981059074402,
        0.6785985231399536,
        0.2810847759246826
      ],
      "plane_d": 728.479248046875,
      "bbox_min": [
        -3563.390380859375,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5021.50048828125,
        940.2425537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.923879861831665,
        0.38268259167671204
      ],
      "plane_d": 4283.5732421875,
      "bbox_min": [
        -3563.390380859375,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38270050287246704,
        0.9238725304603577
      ],
      "plane_d": 1056.398681640625,
      "bbox_min": [
        -3563.58544921875,
        -5026.50048828125,
        937.6500854492188
      ],
      "bbox_max": [
        -3563.0,
        -5024.89111328125,
        938.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.923879861831665,
        0.38268259167671204
      ],
      "plane_d": 4283.5732421875,
      "bbox_min": [
        -3563.58544921875,
        -5025.08642578125,
        937.6500854492188
      ],
      "bbox_max": [
        -3563.0,
        -5024.89111328125,
        938.1212768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5024.50048828125,
      "bbox_min": [
        -3565.0,
        -5025.08642578125,
        934.7070922851562
      ],
      "bbox_max": [
        -3563.0,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.923879861831665,
        0.38268259167671204
      ],
      "plane_d": 4283.5732421875,
      "bbox_min": [
        -3565.0,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -938.70703125,
      "bbox_min": [
        -3570.0,
        -5044.599609375,
        936.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5015.3291015625,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38270050287246704,
        0.9238725304603577
      ],
      "plane_d": 1056.398681640625,
      "bbox_min": [
        -3567.0,
        -5026.50048828125,
        936.70703125
      ],
      "bbox_max": [
        -3563.0,
        -5024.50048828125,
        938.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.923879861831665,
        0.38268259167671204
      ],
      "plane_d": 4283.5732421875,
      "bbox_min": [
        -3566.414306640625,
        -5025.08642578125,
        936.70703125
      ],
      "bbox_max": [
        -3563.58544921875,
        -5024.50048828125,
        938.1212768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.678598940372467,
        -0.28108182549476624,
        -0.678598940372467
      ],
      "plane_d": -3186.91455078125,
      "bbox_min": [
        -3570.0,
        -5026.50048828125,
        938.7069702148438
      ],
      "bbox_max": [
        -3560.0,
        -5015.3291015625,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785985231399536,
        -0.6785982251167297,
        -0.2810845375061035
      ],
      "plane_d": -718.976318359375,
      "bbox_min": [
        -3570.0,
        -5020.13671875,
        938.7069702148438
      ],
      "bbox_max": [
        -3560.0,
        -5015.3291015625,
        945.1923217773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785985231399536,
        -0.6785982251167297,
        -0.28108450770378113
      ],
      "plane_d": -5557.3837890625,
      "bbox_min": [
        -3563.0,
        -5020.13671875,
        938.7071533203125
      ],
      "bbox_max": [
        -3560.0,
        -5015.3291015625,
        945.1923217773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3560.0,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3612.0,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5079.76904296875,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": -1802.6810302734375,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27609625458717346,
        0.6796215176582336,
        -0.6796215176582336
      ],
      "plane_d": 5124.82568359375,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 4297.3662109375,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        993.597900390625
      ],
      "bbox_max": [
        -3602.0,
        -5073.92529296875,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1000.6239013671875,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        993.597900390625
      ],
      "bbox_max": [
        -3602.0,
        -5073.92529296875,
        1000.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2889.3408203125,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        993.597900390625
      ],
      "bbox_max": [
        -3611.84619140625,
        -5079.70654296875,
        993.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 1851.471435546875,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        993.597900390625
      ],
      "bbox_max": [
        -3611.97412109375,
        -5079.70654296875,
        993.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3570.0,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.2955402433872223,
        -0.6755204796791077,
        -0.6755204796791077
      ],
      "plane_d": -3798.35107421875,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        976.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3511234521865845,
        -0.0,
        0.936329185962677
      ],
      "plane_d": 313.78839111328125,
      "bbox_min": [
        -3596.666748046875,
        -5074.60009765625,
        1003.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25630730390548706,
        0.6834861040115356,
        0.6834861040115356
      ],
      "plane_d": 3681.75244140625,
      "bbox_min": [
        -3596.666748046875,
        -5074.60009765625,
        1003.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27609625458717346,
        -0.6796215176582336,
        -0.6796215176582336
      ],
      "plane_d": -1773.018798828125,
      "bbox_min": [
        -3572.169921875,
        -5074.60009765625,
        1008.7930297851562
      ],
      "bbox_max": [
        -3570.0,
        -5069.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37637707591056824,
        0.0,
        -0.9264666438102722
      ],
      "plane_d": 2282.7548828125,
      "bbox_min": [
        -3572.169921875,
        -5074.60009765625,
        1008.7930297851562
      ],
      "bbox_max": [
        -3570.0,
        -5069.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5069.76904296875,
      "bbox_min": [
        -3572.169921875,
        -5069.76904296875,
        1008.7930297851562
      ],
      "bbox_max": [
        -3570.0,
        -5069.76904296875,
        1010.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25630730390548706,
        -0.6834861040115356,
        0.6834861040115356
      ],
      "plane_d": -3220.91015625,
      "bbox_min": [
        -3596.666748046875,
        -5054.599609375,
        1003.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.599609375,
      "bbox_min": [
        -3588.666748046875,
        -5054.599609375,
        1006.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25630730390548706,
        -0.6834861040115356,
        -0.6834861040115356
      ],
      "plane_d": -3672.18359375,
      "bbox_min": [
        -3578.0,
        -5054.599609375,
        1010.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27609625458717346,
        0.6796215176582336,
        0.6796215176582336
      ],
      "plane_d": 1782.533447265625,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        976.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2955402433872223,
        0.6755204796791077,
        0.6755204796791077
      ],
      "plane_d": 3807.80810546875,
      "bbox_min": [
        -3572.169677734375,
        -5054.599609375,
        976.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5049.76904296875,
        981.4545288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4008188545703888,
        -0.0,
        0.9161573648452759
      ],
      "plane_d": 536.1821899414062,
      "bbox_min": [
        -3572.169677734375,
        -5054.599609375,
        976.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5049.76904296875,
        981.4545288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.599609375,
      "bbox_min": [
        -3572.169677734375,
        -5054.599609375,
        979.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5054.599609375,
        981.4545288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2955402433872223,
        -0.6755204796791077,
        0.6755204796791077
      ],
      "plane_d": -3014.40771484375,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        976.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -4269.6689453125,
      "bbox_min": [
        -3612.0,
        -5050.662109375,
        990.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5044.599609375,
        997.7775268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -990.6239013671875,
      "bbox_min": [
        -3612.0,
        -5050.662109375,
        990.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5044.599609375,
        997.7775268554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3259.49609375,
      "bbox_min": [
        -3612.0,
        -5044.97412109375,
        997.6239013671875
      ],
      "bbox_max": [
        -3611.846435546875,
        -5044.599609375,
        997.7775268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4008188545703888,
        -0.0,
        -0.9161573648452759
      ],
      "plane_d": -527.0205688476562,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        976.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37637707591056824,
        0.0,
        -0.9264666438102722
      ],
      "plane_d": 2282.7548828125,
      "bbox_min": [
        -3602.0,
        -5076.76904296875,
        995.438720703125
      ],
      "bbox_max": [
        -3570.0,
        -5069.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27609625458717346,
        -0.6796215176582336,
        -0.6796215176582336
      ],
      "plane_d": -1773.018798828125,
      "bbox_min": [
        -3602.0,
        -5076.76904296875,
        995.438720703125
      ],
      "bbox_max": [
        -3570.0,
        -5069.76904296875,
        1012.7423706054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27609625458717346,
        -0.6796215176582336,
        0.6796215176582336
      ],
      "plane_d": -5115.31103515625,
      "bbox_min": [
        -3593.70361328125,
        -5076.76904296875,
        995.438720703125
      ],
      "bbox_max": [
        -3570.0,
        -5069.76904296875,
        1006.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37637707591056824,
        0.0,
        0.9264666438102722
      ],
      "plane_d": -2273.490234375,
      "bbox_min": [
        -3590.148193359375,
        -5076.76904296875,
        995.438720703125
      ],
      "bbox_max": [
        -3570.0,
        -5072.76904296875,
        1003.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4008188545703888,
        -0.0,
        0.9161573648452759
      ],
      "plane_d": 536.1821899414062,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        976.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -990.6238403320312,
      "bbox_min": [
        -3611.97412109375,
        -5079.76904296875,
        990.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5047.599609375,
        993.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2889.3408203125,
      "bbox_min": [
        -3605.0,
        -5077.68212890625,
        990.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5076.76904296875,
        991.5369262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2889.3408203125,
      "bbox_min": [
        -3611.97412109375,
        -5079.76904296875,
        990.6239013671875
      ],
      "bbox_max": [
        -3604.0869140625,
        -5076.76904296875,
        993.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3259.49609375,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        990.6239013671875
      ],
      "bbox_max": [
        -3590.148193359375,
        -5052.912109375,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3602.0,
      "bbox_min": [
        -3608.857421875,
        -5079.76904296875,
        990.6239013671875
      ],
      "bbox_max": [
        -3590.148193359375,
        -5052.912109375,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27609625458717346,
        -0.6796215176582336,
        0.6796215176582336
      ],
      "plane_d": -5115.31103515625,
      "bbox_min": [
        -3602.0,
        -5072.76904296875,
        990.6239013671875
      ],
      "bbox_max": [
        -3590.148193359375,
        -5069.76904296875,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5069.76904296875,
      "bbox_min": [
        -3602.0,
        -5072.76904296875,
        993.6239013671875
      ],
      "bbox_max": [
        -3593.70361328125,
        -5069.76904296875,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27609625458717346,
        -0.6796215176582336,
        -0.6796215176582336
      ],
      "plane_d": -1773.018798828125,
      "bbox_min": [
        -3602.0,
        -5072.76904296875,
        997.6239013671875
      ],
      "bbox_max": [
        -3598.4443359375,
        -5069.76904296875,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -1841.572021484375,
      "bbox_min": [
        -3608.857421875,
        -5079.76904296875,
        990.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5052.912109375,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2879.44189453125,
      "bbox_min": [
        -3605.0,
        -5072.76904296875,
        997.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5069.76904296875,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2889.3408203125,
      "bbox_min": [
        -3604.0869140625,
        -5079.76904296875,
        990.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5069.76904296875,
        993.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -4287.466796875,
      "bbox_min": [
        -3604.0869140625,
        -5072.76904296875,
        990.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5069.76904296875,
        993.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2889.3408203125,
      "bbox_min": [
        -3608.857421875,
        -5079.76904296875,
        991.5369262695312
      ],
      "bbox_max": [
        -3602.0,
        -5077.68212890625,
        993.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.599609375,
      "bbox_min": [
        -3612.0,
        -5061.60009765625,
        977.5731201171875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -3249.5966796875,
      "bbox_min": [
        -3612.0,
        -5061.60009765625,
        991.5369262695312
      ],
      "bbox_max": [
        -3602.0,
        -5054.599609375,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3602.0,
      "bbox_min": [
        -3609.0,
        -5058.599609375,
        993.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5054.599609375,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 2871.54345703125,
      "bbox_min": [
        -3612.0,
        -5054.599609375,
        990.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5051.599609375,
        997.8848876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -3249.5966796875,
      "bbox_min": [
        -3604.0869140625,
        -5054.599609375,
        991.5369262695312
      ],
      "bbox_max": [
        -3602.0,
        -5052.5126953125,
        993.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3259.49609375,
      "bbox_min": [
        -3612.0,
        -5054.599609375,
        997.6239013671875
      ],
      "bbox_max": [
        -3611.739013671875,
        -5054.224609375,
        997.8848876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3259.49609375,
      "bbox_min": [
        -3612.0,
        -5054.599609375,
        997.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5044.75341796875,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1000.6238403320312,
      "bbox_min": [
        -3609.0,
        -5054.599609375,
        997.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5047.599609375,
        1000.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -1841.572021484375,
      "bbox_min": [
        -3605.0,
        -5054.599609375,
        997.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5051.599609375,
        1000.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1054.72021484375,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.599609375,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -6086.4921875,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.678613543510437,
        0.2810787558555603,
        0.6785854697227478
      ],
      "plane_d": -1636.963134765625,
      "bbox_min": [
        -3563.0,
        -5047.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786147356033325,
        -0.6786147356033325,
        -0.2810053825378418
      ],
      "plane_d": -5574.65234375,
      "bbox_min": [
        -3563.0,
        -5047.599609375,
        946.585693359375
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        948.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 6096.3916015625,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810820937156677,
        0.6785988211631775,
        -0.6785988211631775
      ],
      "plane_d": 3094.068359375,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        976.6239013671875
      ],
      "bbox_max": [
        -3566.999755859375,
        -5051.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810773253440857,
        0.6785998344421387,
        0.6785998344421387
      ],
      "plane_d": 3768.72412109375,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        976.6239013671875
      ],
      "bbox_max": [
        -3567.878662109375,
        -5051.599609375,
        979.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1044.82080078125,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786113381385803,
        0.28106939792633057,
        0.6785916686058044
      ],
      "plane_d": 3201.490478515625,
      "bbox_min": [
        -3570.0,
        -5047.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3567.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786147356033325,
        -0.6786147356033325,
        -0.2810054123401642
      ],
      "plane_d": -736.129150390625,
      "bbox_min": [
        -3570.0,
        -5047.599609375,
        946.585693359375
      ],
      "bbox_max": [
        -3567.0,
        -5044.599609375,
        979.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785998344421387,
        -0.6785998344421387,
        0.2810773253440857
      ],
      "plane_d": -1277.20556640625,
      "bbox_min": [
        -3570.0,
        -5047.599609375,
        976.6239013671875
      ],
      "bbox_max": [
        -3567.0,
        -5044.599609375,
        979.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810773551464081,
        -0.6785998344421387,
        0.6785998344421387
      ],
      "plane_d": -3084.5908203125,
      "bbox_min": [
        -3570.0,
        -5047.599609375,
        976.6239013671875
      ],
      "bbox_max": [
        -3567.878662109375,
        -5044.599609375,
        979.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38266900181770325,
        0.9238856434822083
      ],
      "plane_d": 1063.1539306640625,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792657852173,
        0.0,
        -0.38268426060676575
      ],
      "plane_d": -2915.271728515625,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826802670955658,
        -0.0,
        -0.9238808751106262
      ],
      "plane_d": -454.6456298828125,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9238904714584351,
        0.382656991481781
      ],
      "plane_d": 4306.8671875,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785934567451477,
        0.6786022186279297,
        -0.2810869812965393
      ],
      "plane_d": 1286.750244140625,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785982251167297,
        -0.6785982251167297,
        -0.2810852527618408
      ],
      "plane_d": -5566.58740234375,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786320805549622,
        0.6785681247711182,
        0.28107649087905884
      ],
      "plane_d": 5583.912109375,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786267757415771,
        0.6785820722579956,
        0.28105515241622925
      ],
      "plane_d": 745.37451171875,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        938.70703125
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810831069946289,
        -0.6786012053489685,
        -0.6785959601402283
      ],
      "plane_d": -3759.2548828125,
      "bbox_min": [
        -3570.0,
        -5047.599609375,
        981.5736694335938
      ],
      "bbox_max": [
        -3562.928955078125,
        -5044.599609375,
        986.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1003.6238403320312,
      "bbox_min": [
        -3570.0,
        -5079.76904296875,
        1003.6239013671875
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": 1812.58056640625,
      "bbox_min": [
        -3570.0,
        -5079.76904296875,
        1003.6239013671875
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -4296.6591796875,
      "bbox_min": [
        -3570.0,
        -5079.76904296875,
        1003.6239013671875
      ],
      "bbox_max": [
        -3567.0,
        -5044.599609375,
        1006.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4278.861328125,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        1003.6239013671875
      ],
      "bbox_max": [
        -3567.0,
        -5044.599609375,
        1006.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 2862.35107421875,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        1003.6239013671875
      ],
      "bbox_max": [
        -3567.0,
        -5051.599609375,
        1006.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 2880.14892578125,
      "bbox_min": [
        -3570.0,
        -5079.76904296875,
        1003.6239013671875
      ],
      "bbox_max": [
        -3567.0,
        -5076.76904296875,
        1006.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2870.24951171875,
      "bbox_min": [
        -3570.0,
        -5079.76904296875,
        1010.6239013671875
      ],
      "bbox_max": [
        -3567.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2852.45166015625,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        1010.6239013671875
      ],
      "bbox_max": [
        -3567.0,
        -5044.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 4288.7607421875,
      "bbox_min": [
        -3570.0,
        -5054.599609375,
        1010.6239013671875
      ],
      "bbox_max": [
        -3567.0,
        -5051.599609375,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4278.861328125,
      "bbox_min": [
        -3570.0,
        -5047.599609375,
        1003.6239013671875
      ],
      "bbox_max": [
        -3560.0,
        -5044.599609375,
        1006.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5099.76904296875,
      "bbox_min": [
        -3667.0,
        -5099.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3546.341796875,
        -4909.76904296875,
        1052.6239013671875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5079.76904296875,
      "bbox_min": [
        -3667.0,
        -5099.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3546.341796875,
        -4909.76904296875,
        1052.6239013671875
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4979.76904296875,
      "bbox_min": [
        -3667.0,
        -5079.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -4909.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5144957304000854,
        -0.8574929237365723
      ],
      "plane_d": 3446.68017578125,
      "bbox_min": [
        -3667.0,
        -5079.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -4979.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3511234521865845,
        -0.0,
        -0.936329185962677
      ],
      "plane_d": -304.42510986328125,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25630730390548706,
        -0.6834861040115356,
        -0.6834861040115356
      ],
      "plane_d": -3672.18359375,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3612.0,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1025.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25630730390548706,
        0.6834861040115356,
        -0.6834861040115356
      ],
      "plane_d": 3230.47900390625,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3570.0,
        -5044.599609375,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1025.6239013671875,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5052.724609375,
        1025.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -1823.89453125,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5052.724609375,
        1025.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3277.17431640625,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5054.224609375,
        1025.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3602.0,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5054.599609375,
        1022.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1833.7939453125,
      "bbox_min": [
        -3612.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5058.60009765625,
        1018.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3267.274658203125,
      "bbox_min": [
        -3609.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5058.60009765625,
        1018.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3609.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3605.0,
        -5062.724609375,
        1015.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5044.599609375,
      "bbox_min": [
        -3612.0,
        -5064.22509765625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3578.0,
        -5044.599609375,
        1025.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 1833.793701171875,
      "bbox_min": [
        -3612.0,
        -5064.22509765625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3578.0,
        -5044.599609375,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.599609375,
      "bbox_min": [
        -3612.0,
        -5064.22509765625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3578.0,
        -5044.599609375,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1015.6238403320312,
      "bbox_min": [
        -3612.0,
        -5064.22509765625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5054.599609375,
        1025.3511962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3602.0,
      "bbox_min": [
        -3612.0,
        -5058.60009765625,
        1018.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5054.599609375,
        1025.3511962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3277.17431640625,
      "bbox_min": [
        -3612.0,
        -5054.599609375,
        1013.6239013671875
      ],
      "bbox_max": [
        -3588.666748046875,
        -5044.599609375,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1015.6238403320312,
      "bbox_min": [
        -3609.0,
        -5054.599609375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5048.97509765625,
        1018.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -3267.2744140625,
      "bbox_min": [
        -3605.0,
        -5054.599609375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5051.599609375,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 2853.865966796875,
      "bbox_min": [
        -3605.0,
        -5054.599609375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5051.599609375,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25630730390548706,
        -0.6834861040115356,
        0.6834861040115356
      ],
      "plane_d": -3220.91015625,
      "bbox_min": [
        -3612.0,
        -5054.599609375,
        1013.6239013671875
      ],
      "bbox_max": [
        -3588.666748046875,
        -5044.599609375,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -4287.3466796875,
      "bbox_min": [
        -3612.0,
        -5049.60009765625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5044.599609375,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3609.0,
        -5049.60009765625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5047.599609375,
        1015.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3511234521865845,
        -0.0,
        0.936329185962677
      ],
      "plane_d": 313.78839111328125,
      "bbox_min": [
        -3607.333740234375,
        -5054.599609375,
        1013.6239013671875
      ],
      "bbox_max": [
        -3596.666748046875,
        -5047.599609375,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 4297.24609375,
      "bbox_min": [
        -3605.0,
        -5054.599609375,
        1022.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5051.599609375,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -1823.89453125,
      "bbox_min": [
        -3605.0,
        -5054.599609375,
        1022.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5051.599609375,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4989.76904296875,
      "bbox_min": [
        -3667.0,
        -4989.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4984.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4984.76904296875,
      "bbox_min": [
        -3667.0,
        -4989.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4984.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3627.0,
      "bbox_min": [
        -3627.0,
        -4989.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4984.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1028.6239013671875,
      "bbox_min": [
        -3667.0,
        -4989.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4979.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3627.0,
      "bbox_min": [
        -3627.0,
        -4989.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4979.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4974.76904296875,
      "bbox_min": [
        -3667.0,
        -4979.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4924.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5144957304000854,
        -0.8574929237365723
      ],
      "plane_d": -1674.8873291015625,
      "bbox_min": [
        -3667.0,
        -4974.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4924.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5144957304000854,
        -0.8574929237365723
      ],
      "plane_d": 3418.3828125,
      "bbox_min": [
        -3667.0,
        -4934.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4924.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1025.6239013671875,
      "bbox_min": [
        -3667.0,
        -4934.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4924.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1023.1239013671875,
      "bbox_min": [
        -3667.0,
        -4934.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4929.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4934.76904296875,
      "bbox_min": [
        -3667.0,
        -4934.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4929.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4929.76904296875,
      "bbox_min": [
        -3667.0,
        -4934.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4929.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3627.0,
      "bbox_min": [
        -3627.0,
        -4934.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4929.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1028.6239013671875,
      "bbox_min": [
        -3667.0,
        -4934.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4924.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3627.0,
      "bbox_min": [
        -3627.0,
        -4934.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4924.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1023.1239013671875,
      "bbox_min": [
        -3667.0,
        -4969.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4964.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4969.76904296875,
      "bbox_min": [
        -3667.0,
        -4969.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4964.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4964.76904296875,
      "bbox_min": [
        -3667.0,
        -4969.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4964.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3627.0,
      "bbox_min": [
        -3627.0,
        -4969.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4964.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1028.6239013671875,
      "bbox_min": [
        -3667.0,
        -4974.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4964.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3627.0,
      "bbox_min": [
        -3627.0,
        -4974.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4964.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1025.6239013671875,
      "bbox_min": [
        -3667.0,
        -4979.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4974.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3627.0,
      "bbox_min": [
        -3627.0,
        -4979.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4974.76904296875,
        1052.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4919.76904296875,
      "bbox_min": [
        -3667.0,
        -4924.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4909.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5144957304000854,
        -0.8574929237365723
      ],
      "plane_d": -1646.5899658203125,
      "bbox_min": [
        -3667.0,
        -4919.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4909.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1025.6239013671875,
      "bbox_min": [
        -3667.0,
        -4919.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4909.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1023.1239013671875,
      "bbox_min": [
        -3667.0,
        -4914.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4909.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4914.76904296875,
      "bbox_min": [
        -3667.0,
        -4914.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4909.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3627.0,
      "bbox_min": [
        -3627.0,
        -4914.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4909.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1028.6239013671875,
      "bbox_min": [
        -3667.0,
        -4919.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4909.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3627.0,
      "bbox_min": [
        -3627.0,
        -4919.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4909.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1025.6239013671875,
      "bbox_min": [
        -3667.0,
        -4924.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4919.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3627.0,
      "bbox_min": [
        -3627.0,
        -4924.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3627.0,
        -4919.76904296875,
        1052.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3667.0,
        -5099.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3546.341796875,
        -5079.76904296875,
        1037.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3550.0,
      "bbox_min": [
        -3550.0,
        -5099.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3550.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1037.6239013671875,
      "bbox_min": [
        -3667.0,
        -5099.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3546.341796875,
        -5079.76904296875,
        1037.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4336.2568359375,
      "bbox_min": [
        -3667.0,
        -5099.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3546.341796875,
        -5079.76904296875,
        1037.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2861.763671875,
      "bbox_min": [
        -3667.0,
        -5099.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3547.0,
        -5079.76904296875,
        1037.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3550.0,
      "bbox_min": [
        -3613.0,
        -5099.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3550.0,
        -5079.76904296875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5080.76904296875,
      "bbox_min": [
        -3613.0,
        -5080.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3601.0,
        -5079.76904296875,
        1026.6239013671875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7071069478988647,
        -0.0,
        0.7071065902709961
      ],
      "plane_d": 1822.895263671875,
      "bbox_min": [
        -3613.0,
        -5080.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3601.0,
        -5079.76904296875,
        1026.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071069478988647,
        0.0,
        0.7071065902709961
      ],
      "plane_d": -3278.174560546875,
      "bbox_min": [
        -3613.0,
        -5080.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3601.0,
        -5079.76904296875,
        1026.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1026.6239013671875,
      "bbox_min": [
        -3613.0,
        -5080.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3601.0,
        -5079.76904296875,
        1026.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3613.0,
      "bbox_min": [
        -3613.0,
        -5080.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3601.0,
        -5079.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3601.0,
      "bbox_min": [
        -3613.0,
        -5080.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3601.0,
        -5079.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 1833.793701171875,
      "bbox_min": [
        -3613.0,
        -5080.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3601.0,
        -5079.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -1834.7939453125,
      "bbox_min": [
        -3613.0,
        -5080.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3610.414306640625,
        -5079.76904296875,
        1018.2096557617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -3267.2744140625,
      "bbox_min": [
        -3612.0,
        -5080.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3601.0,
        -5079.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3266.2744140625,
      "bbox_min": [
        -3603.585693359375,
        -5080.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3601.0,
        -5079.76904296875,
        1018.2096557617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": -1823.894287109375,
      "bbox_min": [
        -3612.0,
        -5080.76904296875,
        1018.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5079.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3277.173828125,
      "bbox_min": [
        -3612.0,
        -5080.76904296875,
        1018.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5079.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3612.0,
      "bbox_min": [
        -3612.0,
        -5080.76904296875,
        1018.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5079.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3602.0,
      "bbox_min": [
        -3609.0,
        -5080.76904296875,
        1018.6239013671875
      ],
      "bbox_max": [
        -3602.0,
        -5079.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1025.6239013671875,
      "bbox_min": [
        -3609.0,
        -5080.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3605.0,
        -5079.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3737.0,
      "bbox_min": [
        -3947.0,
        -5142.56640625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -5029.7998046875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3857.0,
      "bbox_min": [
        -3947.0,
        -5142.56640625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -5029.7998046875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -3807.0,
        -5079.7998046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3807.0,
      "bbox_min": [
        -3807.0,
        -5079.7998046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3787.0,
      "bbox_min": [
        -3807.0,
        -5079.7998046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1017.0,
      "bbox_min": [
        -3807.0,
        -5079.7998046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -5060.0,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5079.76904296875,
      "bbox_min": [
        -3807.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -5060.0,
        1017.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5060.0,
      "bbox_min": [
        -3807.0,
        -5060.0,
        1015.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -5060.0,
        1017.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5079.76904296875,
      "bbox_min": [
        -3807.0,
        -5079.76904296875,
        1017.0
      ],
      "bbox_max": [
        -3787.0,
        -5079.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3947.0,
      "bbox_min": [
        -3947.0,
        -5142.56640625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5029.7998046875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3877.0,
      "bbox_min": [
        -3947.0,
        -5142.56640625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5029.7998046875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3927.0,
      "bbox_min": [
        -3947.0,
        -5142.56640625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5029.7998046875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5142.56640625,
      "bbox_min": [
        -3927.0,
        -5142.56640625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5029.7998046875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -3927.0,
        -5142.56640625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5029.7998046875,
        1042.6239013671875
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4352.376953125,
      "bbox_min": [
        -3927.0,
        -5122.56640625,
        1032.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5047.89453125,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1042.6239013671875,
      "bbox_min": [
        -3927.0,
        -5122.56640625,
        1032.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5047.89453125,
        1042.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -4053.170654296875,
      "bbox_min": [
        -3927.0,
        -5122.56640625,
        1032.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5047.89453125,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41562768816947937,
        0.5720621943473816,
        -0.7071056962013245
      ],
      "plane_d": 2044.60107421875,
      "bbox_min": [
        -3927.0,
        -5122.56640625,
        1032.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5047.89453125,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41562771797180176,
        0.5720621943473816,
        -0.7071056962013245
      ],
      "plane_d": 5288.15966796875,
      "bbox_min": [
        -3927.0,
        -5122.56640625,
        1032.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5047.89453125,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49705374240875244,
        -0.7436011433601379,
        -0.44720807671546936
      ],
      "plane_d": -5227.9384765625,
      "bbox_min": [
        -3927.0,
        -5117.56640625,
        1032.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5047.89453125,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4970487952232361,
        -0.7435937523841858,
        -0.44722574949264526
      ],
      "plane_d": -1348.89501953125,
      "bbox_min": [
        -3927.0,
        -5117.56640625,
        1032.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5047.89453125,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2878.576171875,
      "bbox_min": [
        -3927.0,
        -5117.56640625,
        1032.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5055.18994140625,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41562774777412415,
        -0.5720621943473816,
        -0.7071056962013245
      ],
      "plane_d": -570.8025512695312,
      "bbox_min": [
        -3927.0,
        -5108.54541015625,
        1032.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5055.18994140625,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41562774777412415,
        -0.5720621943473816,
        -0.7071056962013245
      ],
      "plane_d": -3814.361328125,
      "bbox_min": [
        -3927.0,
        -5108.54541015625,
        1032.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5055.18994140625,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6724981069564819,
        -0.21850894391536713,
        -0.70710688829422
      ],
      "plane_d": -3020.699462890625,
      "bbox_min": [
        -3927.0,
        -5097.5537109375,
        1032.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5055.18994140625,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4970487952232361,
        0.7435937523841858,
        -0.44722574949264526
      ],
      "plane_d": 2307.371826171875,
      "bbox_min": [
        -3896.7021484375,
        -5085.6435546875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3880.181640625,
        -5055.18994140625,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8433691263198853,
        -0.2978500723838806,
        -0.4472293555736542
      ],
      "plane_d": -4319.7431640625,
      "bbox_min": [
        -3892.0,
        -5078.34814453125,
        1032.6239013671875
      ],
      "bbox_max": [
        -3880.181640625,
        -5055.18994140625,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8433739542961121,
        0.2978517711162567,
        -0.44721880555152893
      ],
      "plane_d": -1301.4892578125,
      "bbox_min": [
        -3892.0,
        -5078.34814453125,
        1032.6239013671875
      ],
      "bbox_max": [
        -3880.181640625,
        -5063.76904296875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3892.0,
      "bbox_min": [
        -3892.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5067.76904296875,
      "bbox_min": [
        -3892.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5063.76904296875,
      "bbox_min": [
        -3892.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3888.0,
      "bbox_min": [
        -3888.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49705374240875244,
        0.7436011433601379,
        -0.44720807671546936
      ],
      "plane_d": 6186.37890625,
      "bbox_min": [
        -3923.818359375,
        -5094.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3895.18505859375,
        -5055.18994140625,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9886870980262756,
        0.0,
        -0.1499927043914795
      ],
      "plane_d": 4019.48095703125,
      "bbox_min": [
        -3908.81494140625,
        -5094.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3895.18505859375,
        -5080.6435546875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 5094.7685546875,
      "bbox_min": [
        -3908.81494140625,
        -5094.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3895.18505859375,
        -5094.76904296875,
        1042.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8433739542961121,
        -0.2978517711162567,
        -0.44721880555152893
      ],
      "plane_d": 2261.908935546875,
      "bbox_min": [
        -3923.818359375,
        -5078.34814453125,
        1032.6239013671875
      ],
      "bbox_max": [
        -3912.0,
        -5055.18994140625,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8433691263198853,
        0.2978500723838806,
        -0.4472293555736542
      ],
      "plane_d": 5280.1845703125,
      "bbox_min": [
        -3923.818359375,
        -5078.34814453125,
        1032.6239013671875
      ],
      "bbox_max": [
        -3912.0,
        -5063.76904296875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3912.0,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3912.0,
        -5063.76904296875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5067.76904296875,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3912.0,
        -5063.76904296875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5063.76904296875,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3912.0,
        -5063.76904296875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3916.0,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3916.0,
        -5063.76904296875,
        1042.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1037.6239013671875,
      "bbox_min": [
        -3877.521484375,
        -5097.5537109375,
        1037.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5095.94873046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1037.6239013671875,
      "bbox_min": [
        -3927.0,
        -5097.5537109375,
        1037.6239013671875
      ],
      "bbox_max": [
        -3926.478515625,
        -5095.94873046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1037.6239013671875,
      "bbox_min": [
        -3927.0,
        -5108.54541015625,
        1037.6239013671875
      ],
      "bbox_max": [
        -3911.35009765625,
        -5097.17431640625,
        1037.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1037.6239013671875,
      "bbox_min": [
        -3892.64990234375,
        -5108.54541015625,
        1037.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5097.1748046875,
        1037.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1037.6239013671875,
      "bbox_min": [
        -3926.697265625,
        -5117.56640625,
        1037.6239013671875
      ],
      "bbox_max": [
        -3877.302734375,
        -5108.54541015625,
        1037.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5877854824066162,
        -0.8090168237686157,
        0.0
      ],
      "plane_d": -1839.85595703125,
      "bbox_min": [
        -3927.0,
        -5103.54541015625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9429196715354919,
        -0.33302053809165955,
        0.0
      ],
      "plane_d": -5343.03759765625,
      "bbox_min": [
        -3927.0,
        -5103.54541015625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429196715354919,
        -0.33302053809165955,
        0.0
      ],
      "plane_d": 2015.5074462890625,
      "bbox_min": [
        -3927.0,
        -5103.54541015625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429196715354919,
        0.33302053809165955,
        -0.0
      ],
      "plane_d": 5390.18359375,
      "bbox_min": [
        -3927.0,
        -5103.54541015625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9429196715354919,
        0.33302053809165955,
        0.0
      ],
      "plane_d": -1968.361328125,
      "bbox_min": [
        -3922.225341796875,
        -5103.54541015625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5557190179824829,
        -0.8313702940940857,
        0.0
      ],
      "plane_d": -2021.466552734375,
      "bbox_min": [
        -3922.225341796875,
        -5103.54541015625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3881.774658203125,
        -5029.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8479037880897522,
        -0.5301501750946045
      ],
      "plane_d": -3724.203857421875,
      "bbox_min": [
        -3909.725341796875,
        -5044.89453125,
        1027.8258056640625
      ],
      "bbox_max": [
        -3894.765380859375,
        -5034.89453125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3909.725341796875,
      "bbox_min": [
        -3909.725341796875,
        -5044.89453125,
        1027.8258056640625
      ],
      "bbox_max": [
        -3909.725341796875,
        -5034.89453125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3909.725341796875,
      "bbox_min": [
        -3909.725341796875,
        -5044.89453125,
        1015.6257934570312
      ],
      "bbox_max": [
        -3894.274658203125,
        -5029.7998046875,
        1027.8258056640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3894.274658203125,
      "bbox_min": [
        -3894.274658203125,
        -5034.56640625,
        1015.6257934570312
      ],
      "bbox_max": [
        -3894.274658203125,
        -5029.7998046875,
        1027.8258056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5557190179824829,
        -0.8313702940940857,
        0.0
      ],
      "plane_d": -6358.2978515625,
      "bbox_min": [
        -3922.225341796875,
        -5103.54541015625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3881.774658203125,
        -5034.56640625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3894.274658203125,
      "bbox_min": [
        -3899.253662109375,
        -5044.89453125,
        1015.6257934570312
      ],
      "bbox_max": [
        -3894.274658203125,
        -5034.56640625,
        1032.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.8479037880897522,
        -0.5301501750946045
      ],
      "plane_d": -3724.203857421875,
      "bbox_min": [
        -3899.253662109375,
        -5037.89453125,
        1027.8258056640625
      ],
      "bbox_max": [
        -3894.274658203125,
        -5034.56640625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.8258056640625,
      "bbox_min": [
        -3894.765380859375,
        -5034.89453125,
        1027.8258056640625
      ],
      "bbox_max": [
        -3894.274658203125,
        -5034.56640625,
        1027.8258056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3909.725341796875,
      "bbox_min": [
        -3922.225341796875,
        -5103.54541015625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3881.774658203125,
        -5063.76904296875,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5557190179824829,
        0.8313702940940857,
        -0.0
      ],
      "plane_d": 6403.255859375,
      "bbox_min": [
        -3922.225341796875,
        -5088.6435546875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3909.725341796875,
        -5063.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5067.76904296875,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3912.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5063.76904296875,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3912.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3916.0,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3916.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3894.274658203125,
      "bbox_min": [
        -3909.725341796875,
        -5103.54541015625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3881.774658203125,
        -5063.76904296875,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5557190179824829,
        0.8313702940940857,
        0.0
      ],
      "plane_d": 2066.42431640625,
      "bbox_min": [
        -3894.274658203125,
        -5088.6435546875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3881.774658203125,
        -5063.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5067.76904296875,
      "bbox_min": [
        -3892.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5063.76904296875,
      "bbox_min": [
        -3892.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3888.0,
      "bbox_min": [
        -3888.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.8258056640625,
      "bbox_min": [
        -3909.725341796875,
        -5103.54541015625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3894.274658203125,
        -5088.6435546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4796968102455139,
        -0.8774343132972717
      ],
      "plane_d": -1542.094970703125,
      "bbox_min": [
        -3909.725341796875,
        -5103.54541015625,
        1027.8258056640625
      ],
      "bbox_max": [
        -3894.274658203125,
        -5088.6435546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5088.6435546875,
      "bbox_min": [
        -3909.725341796875,
        -5088.6435546875,
        1027.8258056640625
      ],
      "bbox_max": [
        -3894.274658203125,
        -5088.6435546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5094.01904296875,
      "bbox_min": [
        -3909.725341796875,
        -5095.51904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3894.274658203125,
        -5094.01904296875,
        1027.8258056640625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5095.51904296875,
      "bbox_min": [
        -3909.725341796875,
        -5095.51904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3894.274658203125,
        -5094.01904296875,
        1027.8258056640625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3907.0,
      "bbox_min": [
        -3907.0,
        -5095.51904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3897.0,
        -5094.01904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3897.0,
      "bbox_min": [
        -3907.0,
        -5095.51904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3897.0,
        -5094.01904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1025.6239013671875,
      "bbox_min": [
        -3907.0,
        -5095.51904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3897.0,
        -5094.01904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3888.09423828125,
      "bbox_min": [
        -3888.09423828125,
        -5142.56640625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5114.505859375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877854228019714,
        0.8090168833732605,
        0.0
      ],
      "plane_d": 1858.877685546875,
      "bbox_min": [
        -3888.09423828125,
        -5122.56640625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5114.505859375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3915.90576171875,
      "bbox_min": [
        -3927.0,
        -5142.56640625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5114.505859375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877854228019714,
        0.8090168833732605,
        0.0
      ],
      "plane_d": 6445.955078125,
      "bbox_min": [
        -3927.0,
        -5122.56640625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5114.505859375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3521.125732421875,
      "bbox_min": [
        -3947.0,
        -5114.505859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": -2046.633056640625,
      "bbox_min": [
        -3947.0,
        -5114.505859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41562771797180176,
        0.5720621943473816,
        -0.7071056962013245
      ],
      "plane_d": 5288.15966796875,
      "bbox_min": [
        -3932.000244140625,
        -5114.505859375,
        1032.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -5104.69287109375,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510564804077148,
        0.3090171217918396,
        0.0
      ],
      "plane_d": 5323.5556640625,
      "bbox_min": [
        -3947.0,
        -5114.505859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6724998354911804,
        0.2185085266828537,
        -0.7071053385734558
      ],
      "plane_d": 4494.50390625,
      "bbox_min": [
        -3947.0,
        -5114.505859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877854228019714,
        0.8090168833732605,
        0.0
      ],
      "plane_d": 6445.955078125,
      "bbox_min": [
        -3946.96923828125,
        -5114.505859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2826.408447265625,
      "bbox_min": [
        -3946.96923828125,
        -5114.505859375,
        1032.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41562771797180176,
        0.5720621943473816,
        -0.7071056962013245
      ],
      "plane_d": 5288.15966796875,
      "bbox_min": [
        -3938.40576171875,
        -5114.505859375,
        1032.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -5103.12939453125,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": -1997.135498046875,
      "bbox_min": [
        -3877.0,
        -5114.505859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3471.628173828125,
      "bbox_min": [
        -3877.0,
        -5114.505859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41562768816947937,
        0.5720621943473816,
        -0.7071056962013245
      ],
      "plane_d": 2044.60107421875,
      "bbox_min": [
        -3877.0,
        -5114.505859375,
        1032.6239013671875
      ],
      "bbox_max": [
        -3871.999755859375,
        -5104.69287109375,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510564804077148,
        0.3090171217918396,
        0.0
      ],
      "plane_d": -2098.4892578125,
      "bbox_min": [
        -3877.0,
        -5114.505859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6724986433982849,
        0.21850813925266266,
        -0.7071065902709961
      ],
      "plane_d": -753.6812744140625,
      "bbox_min": [
        -3877.0,
        -5114.505859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877854228019714,
        0.8090168833732605,
        0.0
      ],
      "plane_d": 1858.877685546875,
      "bbox_min": [
        -3877.0,
        -5114.505859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3857.03076171875,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2826.408447265625,
      "bbox_min": [
        -3877.0,
        -5114.505859375,
        1032.6239013671875
      ],
      "bbox_max": [
        -3857.03076171875,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41562768816947937,
        0.5720621943473816,
        -0.7071056962013245
      ],
      "plane_d": 2044.60107421875,
      "bbox_min": [
        -3877.0,
        -5114.505859375,
        1032.6239013671875
      ],
      "bbox_max": [
        -3865.59423828125,
        -5103.12939453125,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5099.76904296875,
      "bbox_min": [
        -3737.0,
        -5099.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1037.6239013671875,
      "bbox_min": [
        -3737.0,
        -5099.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4336.2568359375,
      "bbox_min": [
        -3737.0,
        -5099.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3717.0,
      "bbox_min": [
        -3737.0,
        -5099.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5079.76904296875,
      "bbox_min": [
        -3717.0,
        -5084.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -5079.76904296875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2861.763671875,
      "bbox_min": [
        -3717.0,
        -5084.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -5079.76904296875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": -1898.140625,
      "bbox_min": [
        -3737.0,
        -5099.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2861.763671875,
      "bbox_min": [
        -3722.000244140625,
        -5096.2333984375,
        1032.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5079.76904296875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056365966797
      ],
      "plane_d": 5141.06591796875,
      "bbox_min": [
        -3722.000244140625,
        -5096.2333984375,
        1036.1593017578125
      ],
      "bbox_max": [
        -3719.928955078125,
        -5092.69775390625,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 6237.9326171875,
      "bbox_min": [
        -3737.0,
        -5099.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3717.03076171875,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056365966797
      ],
      "plane_d": 5141.06591796875,
      "bbox_min": [
        -3737.0,
        -5099.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3717.03076171875,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2826.408447265625,
      "bbox_min": [
        -3736.96923828125,
        -5034.76904296875,
        1032.6546630859375
      ],
      "bbox_max": [
        -3717.03076171875,
        -5029.7998046875,
        1037.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1013.6239013671875,
      "bbox_min": [
        -3947.0,
        -5201.56640625,
        1002.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -5029.7998046875,
        1015.6257934570312
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1002.6257934570312,
      "bbox_min": [
        -3927.0,
        -5088.6435546875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5034.89453125,
        1013.6257934570312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5034.89453125,
      "bbox_min": [
        -3927.0,
        -5088.6435546875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5034.89453125,
        1013.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5088.6435546875,
      "bbox_min": [
        -3927.0,
        -5088.6435546875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5034.89453125,
        1013.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5557190179824829,
        -0.8313702940940857,
        0.0
      ],
      "plane_d": -2021.466552734375,
      "bbox_min": [
        -3927.0,
        -5088.6435546875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5034.89453125,
        1013.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3909.725341796875,
      "bbox_min": [
        -3909.725341796875,
        -5044.89453125,
        1002.6257934570312
      ],
      "bbox_max": [
        -3909.725341796875,
        -5034.89453125,
        1013.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5557190179824829,
        -0.8313702940940857,
        0.0
      ],
      "plane_d": -6358.2978515625,
      "bbox_min": [
        -3927.0,
        -5088.6435546875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5034.89453125,
        1013.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3894.274658203125,
      "bbox_min": [
        -3894.274658203125,
        -5044.89453125,
        1002.6257934570312
      ],
      "bbox_max": [
        -3894.274658203125,
        -5034.89453125,
        1013.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5557190179824829,
        0.8313702940940857,
        -0.0
      ],
      "plane_d": 6403.255859375,
      "bbox_min": [
        -3927.0,
        -5088.6435546875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5053.25,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5557190179824829,
        0.8313702940940857,
        0.0
      ],
      "plane_d": 2066.42431640625,
      "bbox_min": [
        -3927.0,
        -5088.6435546875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5053.25,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9429196715354919,
        -0.33302053809165955,
        0.0
      ],
      "plane_d": -5343.03759765625,
      "bbox_min": [
        -3927.0,
        -5088.6435546875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5053.25,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429196715354919,
        -0.33302053809165955,
        0.0
      ],
      "plane_d": 2015.5074462890625,
      "bbox_min": [
        -3927.0,
        -5088.6435546875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5053.25,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429196715354919,
        0.33302053809165955,
        -0.0
      ],
      "plane_d": 5390.18359375,
      "bbox_min": [
        -3927.0,
        -5088.6435546875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9429196715354919,
        0.33302053809165955,
        0.0
      ],
      "plane_d": -1968.361328125,
      "bbox_min": [
        -3916.0,
        -5088.6435546875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5086.6435546875,
      "bbox_min": [
        -3916.0,
        -5088.6435546875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1012.6257934570312,
      "bbox_min": [
        -3909.725341796875,
        -5088.6435546875,
        1011.6257934570312
      ],
      "bbox_max": [
        -3894.274658203125,
        -5086.6435546875,
        1012.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1011.6257934570312,
      "bbox_min": [
        -3909.725341796875,
        -5088.6435546875,
        1011.6257934570312
      ],
      "bbox_max": [
        -3894.274658203125,
        -5086.6435546875,
        1012.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3909.725341796875,
      "bbox_min": [
        -3909.725341796875,
        -5088.6435546875,
        1011.6257934570312
      ],
      "bbox_max": [
        -3894.274658203125,
        -5086.6435546875,
        1012.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3894.274658203125,
      "bbox_min": [
        -3894.274658203125,
        -5088.6435546875,
        1011.6257934570312
      ],
      "bbox_max": [
        -3894.274658203125,
        -5086.6435546875,
        1012.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3892.0,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3888.0,
      "bbox_min": [
        -3892.0,
        -5067.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5067.76904296875,
      "bbox_min": [
        -3892.0,
        -5067.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5063.76904296875,
      "bbox_min": [
        -3892.0,
        -5063.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3912.0,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3912.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5067.76904296875,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3912.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5063.76904296875,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3912.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3916.0,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3916.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3888.09423828125,
      "bbox_min": [
        -3947.0,
        -5201.56640625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -5029.7998046875,
        1015.6257934570312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3737.0,
      "bbox_min": [
        -3888.09423828125,
        -5122.56640625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -5029.7998046875,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3857.0,
      "bbox_min": [
        -3888.09423828125,
        -5122.56640625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -5029.7998046875,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3807.0,
      "bbox_min": [
        -3807.0,
        -5079.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5060.0,
      "bbox_min": [
        -3807.0,
        -5060.0,
        1015.5999755859375
      ],
      "bbox_max": [
        -3787.0,
        -5060.0,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3877.0,
      "bbox_min": [
        -3888.09423828125,
        -5122.56640625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5029.7998046875,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510560631752014,
        -0.3090183734893799,
        0.0
      ],
      "plane_d": 2117.50244140625,
      "bbox_min": [
        -3888.09423828125,
        -5122.56640625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5049.02587890625,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9429196715354919,
        0.33302053809165955,
        0.0
      ],
      "plane_d": -1968.361328125,
      "bbox_min": [
        -3888.09423828125,
        -5099.05517578125,
        1013.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5049.02587890625,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877854824066162,
        -0.8090168237686157,
        0.0
      ],
      "plane_d": -1839.85595703125,
      "bbox_min": [
        -3888.09423828125,
        -5099.05517578125,
        1013.6239013671875
      ],
      "bbox_max": [
        -3881.774658203125,
        -5094.4638671875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9429196715354919,
        -0.33302053809165955,
        0.0
      ],
      "plane_d": -5343.03759765625,
      "bbox_min": [
        -3888.09423828125,
        -5084.51220703125,
        1013.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5049.02587890625,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5557190179824829,
        0.8313702940940857,
        0.0
      ],
      "plane_d": 2066.42431640625,
      "bbox_min": [
        -3888.09423828125,
        -5084.51220703125,
        1013.6239013671875
      ],
      "bbox_max": [
        -3881.774658203125,
        -5049.02587890625,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5557190179824829,
        -0.8313702940940857,
        0.0
      ],
      "plane_d": -6358.2978515625,
      "bbox_min": [
        -3888.09423828125,
        -5067.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3881.774658203125,
        -5049.02587890625,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3888.0,
      "bbox_min": [
        -3888.09423828125,
        -5067.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1015.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5067.76904296875,
      "bbox_min": [
        -3888.09423828125,
        -5067.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5063.76904296875,
      "bbox_min": [
        -3888.09423828125,
        -5063.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3888.0,
        -5063.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877854228019714,
        0.8090168833732605,
        0.0
      ],
      "plane_d": 1858.877685546875,
      "bbox_min": [
        -3888.09423828125,
        -5122.56640625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5114.505859375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510564804077148,
        0.3090171217918396,
        0.0
      ],
      "plane_d": -2098.4892578125,
      "bbox_min": [
        -3877.0,
        -5114.505859375,
        1013.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877854228019714,
        0.8090168833732605,
        0.0
      ],
      "plane_d": 1858.877685546875,
      "bbox_min": [
        -3877.0,
        -5114.505859375,
        1013.6239013671875
      ],
      "bbox_max": [
        -3865.59423828125,
        -5106.21923828125,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5099.76904296875,
      "bbox_min": [
        -3737.0,
        -5099.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5079.76904296875,
      "bbox_min": [
        -3737.0,
        -5099.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3717.0,
      "bbox_min": [
        -3717.0,
        -5079.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 6237.9326171875,
      "bbox_min": [
        -3737.0,
        -5099.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3722.0,
        -5084.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3915.90576171875,
      "bbox_min": [
        -3947.0,
        -5201.56640625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3888.09423828125,
        -5029.7998046875,
        1015.6257934570312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3947.0,
      "bbox_min": [
        -3947.0,
        -5122.56640625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5029.7998046875,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3927.0,
      "bbox_min": [
        -3947.0,
        -5122.56640625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5029.7998046875,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429196715354919,
        0.33302053809165955,
        -0.0
      ],
      "plane_d": 5390.18359375,
      "bbox_min": [
        -3927.0,
        -5122.56640625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5049.02587890625,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877854228019714,
        0.8090168833732605,
        0.0
      ],
      "plane_d": 6445.955078125,
      "bbox_min": [
        -3927.0,
        -5122.56640625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5094.4638671875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877854824066162,
        -0.8090168237686157,
        0.0
      ],
      "plane_d": -6426.93359375,
      "bbox_min": [
        -3922.225341796875,
        -5099.05517578125,
        1013.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5094.4638671875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429196715354919,
        -0.33302053809165955,
        0.0
      ],
      "plane_d": 2015.5074462890625,
      "bbox_min": [
        -3927.0,
        -5084.51220703125,
        1013.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5049.02587890625,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5557190179824829,
        0.8313702940940857,
        -0.0
      ],
      "plane_d": 6403.255859375,
      "bbox_min": [
        -3922.225341796875,
        -5084.51220703125,
        1013.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5049.02587890625,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5557190179824829,
        -0.8313702940940857,
        0.0
      ],
      "plane_d": -2021.466552734375,
      "bbox_min": [
        -3922.225341796875,
        -5067.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5049.02587890625,
        1015.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3916.0,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5063.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5067.76904296875,
      "bbox_min": [
        -3916.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5063.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5063.76904296875,
      "bbox_min": [
        -3916.0,
        -5063.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3915.90576171875,
        -5063.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510564804077148,
        0.3090171217918396,
        0.0
      ],
      "plane_d": 5323.5556640625,
      "bbox_min": [
        -3947.0,
        -5114.505859375,
        1013.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -5079.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877854228019714,
        0.8090168833732605,
        0.0
      ],
      "plane_d": 6445.955078125,
      "bbox_min": [
        -3938.40576171875,
        -5114.505859375,
        1013.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -5106.21923828125,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5201.56640625,
      "bbox_min": [
        -3915.90576171875,
        -5201.56640625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3888.09423828125,
        -5044.89453125,
        1015.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5044.89453125,
      "bbox_min": [
        -3915.90576171875,
        -5103.54541015625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3888.09423828125,
        -5044.89453125,
        1015.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5046.89453125,
      "bbox_min": [
        -3915.90576171875,
        -5103.54541015625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3888.09423828125,
        -5044.89453125,
        1015.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1014.6257934570312,
      "bbox_min": [
        -3912.71728515625,
        -5046.89453125,
        1013.6253662109375
      ],
      "bbox_max": [
        -3891.28271484375,
        -5044.89453125,
        1015.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5557190179824829,
        -0.8313702940940857,
        0.0
      ],
      "plane_d": -2021.466552734375,
      "bbox_min": [
        -3912.71728515625,
        -5046.89453125,
        1013.6253662109375
      ],
      "bbox_max": [
        -3891.28271484375,
        -5044.89453125,
        1014.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3909.725341796875,
      "bbox_min": [
        -3909.725341796875,
        -5046.89453125,
        1013.6257934570312
      ],
      "bbox_max": [
        -3909.725341796875,
        -5044.89453125,
        1014.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5557190179824829,
        -0.8313702940940857,
        0.0
      ],
      "plane_d": -2021.466552734375,
      "bbox_min": [
        -3912.71728515625,
        -5046.89453125,
        1014.6257934570312
      ],
      "bbox_max": [
        -3891.28271484375,
        -5044.89453125,
        1015.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877854824066162,
        -0.8090168237686157,
        0.0
      ],
      "plane_d": -1839.85595703125,
      "bbox_min": [
        -3894.274658203125,
        -5103.54541015625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3888.09423828125,
        -5046.89453125,
        1015.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5557190179824829,
        0.8313702940940857,
        0.0
      ],
      "plane_d": 2066.42431640625,
      "bbox_min": [
        -3894.274658203125,
        -5088.6435546875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3888.09423828125,
        -5046.89453125,
        1015.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3892.0,
      "bbox_min": [
        -3892.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3888.09423828125,
        -5063.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5067.76904296875,
      "bbox_min": [
        -3892.0,
        -5067.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3888.09423828125,
        -5067.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5557190179824829,
        -0.8313702940940857,
        0.0
      ],
      "plane_d": -6358.2978515625,
      "bbox_min": [
        -3891.28271484375,
        -5049.02587890625,
        1013.6248779296875
      ],
      "bbox_max": [
        -3888.09423828125,
        -5046.89453125,
        1015.6253662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3909.725341796875,
      "bbox_min": [
        -3915.90576171875,
        -5103.54541015625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3894.274658203125,
        -5046.89453125,
        1015.6257934570312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5877854824066162,
        -0.8090168237686157,
        0.0
      ],
      "plane_d": -6426.93359375,
      "bbox_min": [
        -3915.90576171875,
        -5103.54541015625,
        1013.6239013671875
      ],
      "bbox_max": [
        -3909.725341796875,
        -5046.89453125,
        1015.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5557190179824829,
        0.8313702940940857,
        -0.0
      ],
      "plane_d": 6403.255859375,
      "bbox_min": [
        -3915.90576171875,
        -5088.6435546875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3909.725341796875,
        -5046.89453125,
        1015.6257934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3912.0,
      "bbox_min": [
        -3915.90576171875,
        -5067.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3912.0,
        -5063.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5067.76904296875,
      "bbox_min": [
        -3915.90576171875,
        -5067.76904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3912.0,
        -5067.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5557190179824829,
        -0.8313702940940857,
        0.0
      ],
      "plane_d": -2021.466552734375,
      "bbox_min": [
        -3915.90576171875,
        -5049.02587890625,
        1013.6248779296875
      ],
      "bbox_max": [
        -3912.71728515625,
        -5046.89453125,
        1015.6253662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5095.51904296875,
      "bbox_min": [
        -3909.725341796875,
        -5095.51904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3894.274658203125,
        -5094.01904296875,
        1015.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5094.01904296875,
      "bbox_min": [
        -3909.725341796875,
        -5095.51904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3894.274658203125,
        -5094.01904296875,
        1015.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3907.0,
      "bbox_min": [
        -3907.0,
        -5095.51904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3897.0,
        -5094.01904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3897.0,
      "bbox_min": [
        -3897.0,
        -5095.51904296875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3897.0,
        -5094.01904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -3997.0,
        -5029.7998046875,
        985.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4989.76904296875,
        1052.6239013671875
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 4272.6171875,
      "bbox_min": [
        -3997.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4989.76904296875,
        1052.6239013671875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2826.408447265625,
      "bbox_min": [
        -3947.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.76904296875,
        1032.6546630859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": -1997.135498046875,
      "bbox_min": [
        -3947.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.76904296875,
        1032.6546630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3372.63330078125,
      "bbox_min": [
        -3737.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.76904296875,
        1032.6546630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": -1898.140625,
      "bbox_min": [
        -3717.03076171875,
        -5029.7998046875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.76904296875,
        1032.6546630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": -2046.633056640625,
      "bbox_min": [
        -3947.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3876.96923828125,
        -5029.76904296875,
        1032.6546630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3471.628173828125,
      "bbox_min": [
        -3877.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3876.96923828125,
        -5029.76904296875,
        1032.6546630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3521.125732421875,
      "bbox_min": [
        -3947.0,
        -5029.7998046875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3946.96923828125,
        -5029.76904296875,
        1032.6546630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3997.0,
      "bbox_min": [
        -3997.0,
        -5009.76904296875,
        1032.6239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4989.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5029.76904296875,
      "bbox_min": [
        -3997.0,
        -5029.7998046875,
        985.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4989.76904296875,
        1032.6239013671875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1013.6239013671875,
      "bbox_min": [
        -3947.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.76904296875,
        1032.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3807.0,
      "bbox_min": [
        -3947.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3947.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5029.76904296875,
        1032.6239013671875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3877.0,
      "bbox_min": [
        -3947.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5029.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3947.0,
      "bbox_min": [
        -3947.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -5029.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3927.0,
      "bbox_min": [
        -3927.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -5029.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3857.0,
      "bbox_min": [
        -3857.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5029.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3877.0,
      "bbox_min": [
        -3947.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5029.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3927.0,
      "bbox_min": [
        -3947.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3894.274658203125,
        -5029.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1027.8258056640625,
      "bbox_min": [
        -3909.725341796875,
        -5029.7998046875,
        1015.6257934570312
      ],
      "bbox_max": [
        -3894.274658203125,
        -5029.76904296875,
        1027.8258056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3909.725341796875,
      "bbox_min": [
        -3909.725341796875,
        -5029.7998046875,
        1015.6257934570312
      ],
      "bbox_max": [
        -3894.274658203125,
        -5029.76904296875,
        1027.8258056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3894.274658203125,
      "bbox_min": [
        -3894.274658203125,
        -5029.7998046875,
        1015.6257934570312
      ],
      "bbox_max": [
        -3894.274658203125,
        -5029.76904296875,
        1027.8258056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3947.0,
      "bbox_min": [
        -3947.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3947.0,
        -5029.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3857.0,
      "bbox_min": [
        -3857.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -5029.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3787.0,
      "bbox_min": [
        -3807.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3737.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3737.0,
      "bbox_min": [
        -3737.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3717.0,
      "bbox_min": [
        -3717.0,
        -5029.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3737.0,
      "bbox_min": [
        -3737.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3717.0,
      "bbox_min": [
        -3717.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -5029.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3807.0,
        -5029.7998046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -5029.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2829.94384765625,
      "bbox_min": [
        -3997.0,
        -5029.76904296875,
        985.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4989.76904296875,
        1032.6239013671875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.0,
        0.3713906705379486,
        0.9284766912460327
      ],
      "plane_d": 925.0261840820312,
      "bbox_min": [
        -3997.0,
        -5029.76904296875,
        985.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4989.76904296875,
        1027.6240234375
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.0,
        0.710514485836029,
        0.7036826014518738
      ],
      "plane_d": 2851.73681640625,
      "bbox_min": [
        -3947.0,
        -5029.76904296875,
        985.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4989.76904296875,
        1015.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.34794387221336365,
        0.937515377998352
      ],
      "plane_d": 799.7892456054688,
      "bbox_min": [
        -3947.0,
        -5029.76904296875,
        1006.4238891601562
      ],
      "bbox_max": [
        -3717.0,
        -5010.369140625,
        1015.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3737.0,
      "bbox_min": [
        -3787.0,
        -5029.76904296875,
        1006.4238891601562
      ],
      "bbox_max": [
        -3717.0,
        -5010.369140625,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3787.0,
      "bbox_min": [
        -3787.0,
        -5029.76904296875,
        1006.4238891601562
      ],
      "bbox_max": [
        -3787.0,
        -5010.369140625,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3717.0,
      "bbox_min": [
        -3717.0,
        -5029.76904296875,
        1006.4238891601562
      ],
      "bbox_max": [
        -3717.0,
        -5010.369140625,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3877.0,
      "bbox_min": [
        -3947.0,
        -5012.73095703125,
        985.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4989.76904296875,
        1008.8086547851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3947.0,
      "bbox_min": [
        -3947.0,
        -5012.73095703125,
        985.6239013671875
      ],
      "bbox_max": [
        -3947.0,
        -4989.76904296875,
        1008.8086547851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3857.0,
      "bbox_min": [
        -3857.0,
        -5012.73095703125,
        985.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4989.76904296875,
        1008.8086547851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3787.0,
      "bbox_min": [
        -3787.0,
        -5012.73095703125,
        985.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4989.76904296875,
        1008.8086547851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3717.0,
      "bbox_min": [
        -3717.0,
        -5012.73095703125,
        985.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4989.76904296875,
        1008.8086547851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3997.0,
      "bbox_min": [
        -3997.0,
        -5029.76904296875,
        1007.6239013671875
      ],
      "bbox_max": [
        -3997.0,
        -5009.76904296875,
        1027.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3997.0,
      "bbox_min": [
        -3997.0,
        -5029.76904296875,
        987.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4989.76904296875,
        1032.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3679.0,
      "bbox_min": [
        -3997.0,
        -4999.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4989.76904296875,
        1017.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1017.6239013671875,
      "bbox_min": [
        -3679.0,
        -4999.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4989.76904296875,
        1017.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1002.6239013671875,
      "bbox_min": [
        -3679.0,
        -4999.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4989.76904296875,
        1002.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3985.0,
      "bbox_min": [
        -3997.0,
        -4999.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3985.0,
        -4989.76904296875,
        1017.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1017.6239013671875,
      "bbox_min": [
        -3997.0,
        -4999.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3985.0,
        -4989.76904296875,
        1017.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1002.6239013671875,
      "bbox_min": [
        -3997.0,
        -4999.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3985.0,
        -4989.76904296875,
        1002.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -829.6239013671875,
      "bbox_min": [
        -3997.0,
        -4989.76904296875,
        829.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4909.76904296875,
        854.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3997.0,
      "bbox_min": [
        -3997.0,
        -4989.76904296875,
        829.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4909.76904296875,
        854.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 2229.06640625,
      "bbox_min": [
        -3997.0,
        -4989.76904296875,
        829.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4909.76904296875,
        853.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -3190.19970703125,
      "bbox_min": [
        -3997.0,
        -4989.76904296875,
        829.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4909.76904296875,
        853.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2931.060302734375,
      "bbox_min": [
        -3997.0,
        -4989.76904296875,
        829.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4909.76904296875,
        853.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4068.97021484375,
      "bbox_min": [
        -3997.0,
        -4924.76904296875,
        829.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4909.76904296875,
        853.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4909.7998046875,
      "bbox_min": [
        -3990.0,
        -4909.7998046875,
        851.0
      ],
      "bbox_max": [
        -3986.971435546875,
        -4909.7998046875,
        853.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3997.0,
      "bbox_min": [
        -4037.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4909.76904296875,
        1067.6239013671875
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4974.76904296875,
      "bbox_min": [
        -4037.0,
        -4989.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4909.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4924.76904296875,
      "bbox_min": [
        -4037.0,
        -4974.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4909.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5144957304000854,
        -0.8574929237365723
      ],
      "plane_d": -1674.8873291015625,
      "bbox_min": [
        -4037.0,
        -4974.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4924.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5144957304000854,
        -0.8574929237365723
      ],
      "plane_d": 3418.3828125,
      "bbox_min": [
        -4037.0,
        -4934.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4924.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1025.6239013671875,
      "bbox_min": [
        -4037.0,
        -4934.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4924.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1023.1239013671875,
      "bbox_min": [
        -4037.0,
        -4934.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4929.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4929.76904296875,
      "bbox_min": [
        -4037.0,
        -4934.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4929.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4934.76904296875,
      "bbox_min": [
        -4037.0,
        -4934.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4929.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4037.0,
      "bbox_min": [
        -4037.0,
        -4934.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -4037.0,
        -4929.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1028.6239013671875,
      "bbox_min": [
        -4037.0,
        -4934.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4924.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4037.0,
      "bbox_min": [
        -4037.0,
        -4934.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -4037.0,
        -4924.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1023.1239013671875,
      "bbox_min": [
        -4037.0,
        -4969.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4964.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4964.76904296875,
      "bbox_min": [
        -4037.0,
        -4969.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4964.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4969.76904296875,
      "bbox_min": [
        -4037.0,
        -4969.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4964.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4037.0,
      "bbox_min": [
        -4037.0,
        -4969.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -4037.0,
        -4964.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1028.6239013671875,
      "bbox_min": [
        -4037.0,
        -4974.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4964.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 4037.0,
      "bbox_min": [
        -4037.0,
        -4974.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -4037.0,
        -4964.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5144957304000854,
        -0.8574929237365723
      ],
      "plane_d": -1646.5899658203125,
      "bbox_min": [
        -4037.0,
        -4919.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4909.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1025.6239013671875,
      "bbox_min": [
        -4037.0,
        -4919.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4909.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1023.1239013671875,
      "bbox_min": [
        -4037.0,
        -4914.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4909.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4914.76904296875,
      "bbox_min": [
        -4037.0,
        -4914.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4909.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4037.0,
      "bbox_min": [
        -4037.0,
        -4914.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -4037.0,
        -4909.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1028.6239013671875,
      "bbox_min": [
        -4037.0,
        -4919.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4909.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4037.0,
      "bbox_min": [
        -4037.0,
        -4919.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -4037.0,
        -4909.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1025.6239013671875,
      "bbox_min": [
        -4037.0,
        -4924.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4919.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4037.0,
      "bbox_min": [
        -4037.0,
        -4924.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -4037.0,
        -4919.76904296875,
        1052.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4979.76904296875,
      "bbox_min": [
        -4037.0,
        -4989.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4974.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5144957304000854,
        -0.8574929237365723
      ],
      "plane_d": 3446.68017578125,
      "bbox_min": [
        -4037.0,
        -4989.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4979.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1025.6239013671875,
      "bbox_min": [
        -4037.0,
        -4989.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4979.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1023.1239013671875,
      "bbox_min": [
        -4037.0,
        -4989.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4984.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4984.76904296875,
      "bbox_min": [
        -4037.0,
        -4989.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4984.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4037.0,
      "bbox_min": [
        -4037.0,
        -4989.76904296875,
        1023.1239013671875
      ],
      "bbox_max": [
        -4037.0,
        -4984.76904296875,
        1025.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1028.6239013671875,
      "bbox_min": [
        -4037.0,
        -4989.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4979.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 4037.0,
      "bbox_min": [
        -4037.0,
        -4989.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -4037.0,
        -4979.76904296875,
        1028.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1025.6239013671875,
      "bbox_min": [
        -4037.0,
        -4979.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4974.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4037.0,
      "bbox_min": [
        -4037.0,
        -4979.76904296875,
        1025.6239013671875
      ],
      "bbox_max": [
        -4037.0,
        -4974.76904296875,
        1052.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9486833214759827,
        -0.3162277638912201
      ],
      "plane_d": -4391.35498046875,
      "bbox_min": [
        -3997.0,
        -4989.76904296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3667.0,
        -4909.76904296875,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833214759827,
        -0.3162277638912201
      ],
      "plane_d": 5000.171875,
      "bbox_min": [
        -3997.0,
        -4984.76953125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3667.0,
        -4909.76904296875,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4974.76904296875,
      "bbox_min": [
        -3997.0,
        -4984.76953125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3667.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1067.6239013671875,
      "bbox_min": [
        -3997.0,
        -4984.76953125,
        1067.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4974.76904296875,
        1067.6239013671875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4924.76904296875,
      "bbox_min": [
        -3997.0,
        -4974.76904296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3667.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1067.6239013671875,
      "bbox_min": [
        -3997.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1067.6239013671875,
      "bbox_min": [
        -3997.0,
        -4974.76904296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3667.0,
        -4924.76904296875,
        1067.6239013671875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.9238775372505188,
        0.3826882839202881,
        -0.0
      ],
      "plane_d": 5422.2783203125,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3748.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238775372505188,
        0.3826882839202881,
        -0.0
      ],
      "plane_d": 5486.94970703125,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3818.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238775372505188,
        -0.3826882839202881,
        0.0
      ],
      "plane_d": 1698.5128173828125,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3888.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268494606018066,
        -0.9238789081573486,
        0.0
      ],
      "plane_d": -3091.98974609375,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3888.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268494606018066,
        -0.9238789081573486,
        0.0
      ],
      "plane_d": -6078.462890625,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3888.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238775372505188,
        -0.3826882839202881,
        0.0
      ],
      "plane_d": -5511.427734375,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3888.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238775372505188,
        0.3826882839202881,
        0.0
      ],
      "plane_d": -1722.9901123046875,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3888.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826850950717926,
        0.9238788485527039,
        0.0
      ],
      "plane_d": 3067.51123046875,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3888.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826850950717926,
        0.9238788485527039,
        -0.0
      ],
      "plane_d": 6053.9853515625,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3888.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": 5489.9423828125,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3888.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        -0.38268598914146423,
        0.0
      ],
      "plane_d": 1701.52783203125,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3890.37646484375,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 6056.98388671875,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3894.928955078125,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 3070.5146484375,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3894.928955078125,
        -4938.1455078125,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": -1720.00537109375,
      "bbox_min": [
        -3915.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3894.928955078125,
        -4942.69775390625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        -0.38268598914146423,
        -0.0
      ],
      "plane_d": -5508.419921875,
      "bbox_min": [
        -3913.62353515625,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3894.928955078125,
        -4949.76904296875,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        -0.923879086971283,
        -0.0
      ],
      "plane_d": -6075.4619140625,
      "bbox_min": [
        -3909.071044921875,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3894.928955078125,
        -4956.84033203125,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        -0.923879086971283,
        0.0
      ],
      "plane_d": -3088.9921875,
      "bbox_min": [
        -3902.0,
        -4961.392578125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3894.928955078125,
        -4956.84033203125,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1057.6239013671875,
      "bbox_min": [
        -3902.0,
        -4961.392578125,
        1057.6239013671875
      ],
      "bbox_max": [
        -3894.928955078125,
        -4956.84033203125,
        1057.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1057.6239013671875,
      "bbox_min": [
        -3896.552490234375,
        -4960.759765625,
        1057.6239013671875
      ],
      "bbox_max": [
        -3890.37646484375,
        -4949.76904296875,
        1057.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38268494606018066,
        -0.9238789081573486,
        0.0
      ],
      "plane_d": -6051.6748046875,
      "bbox_min": [
        -3845.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3818.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238775372505188,
        -0.3826882839202881,
        0.0
      ],
      "plane_d": -5446.75634765625,
      "bbox_min": [
        -3845.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3818.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238775372505188,
        0.3826882839202881,
        0.0
      ],
      "plane_d": -1658.3187255859375,
      "bbox_min": [
        -3845.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3818.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826850950717926,
        0.9238788485527039,
        0.0
      ],
      "plane_d": 3094.299072265625,
      "bbox_min": [
        -3845.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3818.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826850950717926,
        0.9238788485527039,
        -0.0
      ],
      "plane_d": 6027.197265625,
      "bbox_min": [
        -3845.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3818.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": -1655.333984375,
      "bbox_min": [
        -3845.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3818.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        -0.38268598914146423,
        -0.0
      ],
      "plane_d": -5443.74853515625,
      "bbox_min": [
        -3843.62353515625,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3818.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 3097.302490234375,
      "bbox_min": [
        -3839.071044921875,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3818.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 6030.1962890625,
      "bbox_min": [
        -3839.071044921875,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3818.7529296875,
        -4938.1455078125,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": 5425.2705078125,
      "bbox_min": [
        -3839.071044921875,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3818.7529296875,
        -4942.69775390625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        -0.38268598914146423,
        0.0
      ],
      "plane_d": 1636.856201171875,
      "bbox_min": [
        -3839.071044921875,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3820.376220703125,
        -4949.76904296875,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        -0.923879086971283,
        -0.0
      ],
      "plane_d": -6048.673828125,
      "bbox_min": [
        -3839.071044921875,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3824.928955078125,
        -4956.84033203125,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        -0.923879086971283,
        0.0
      ],
      "plane_d": -3115.780029296875,
      "bbox_min": [
        -3832.0,
        -4961.392578125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3824.928955078125,
        -4956.84033203125,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1057.6239013671875,
      "bbox_min": [
        -3832.0,
        -4961.392578125,
        1057.6239013671875
      ],
      "bbox_max": [
        -3824.928955078125,
        -4956.84033203125,
        1057.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1057.6239013671875,
      "bbox_min": [
        -3843.62353515625,
        -4960.759765625,
        1057.6239013671875
      ],
      "bbox_max": [
        -3837.447509765625,
        -4949.76904296875,
        1057.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238775372505188,
        -0.3826882839202881,
        0.0
      ],
      "plane_d": 1569.1700439453125,
      "bbox_min": [
        -3775.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3748.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268494606018066,
        -0.9238789081573486,
        0.0
      ],
      "plane_d": -3145.5654296875,
      "bbox_min": [
        -3775.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3748.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268494606018066,
        -0.9238789081573486,
        0.0
      ],
      "plane_d": -6024.88671875,
      "bbox_min": [
        -3775.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3748.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238775372505188,
        -0.3826882839202881,
        0.0
      ],
      "plane_d": -5382.0849609375,
      "bbox_min": [
        -3775.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3748.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238775372505188,
        0.3826882839202881,
        0.0
      ],
      "plane_d": -1593.6473388671875,
      "bbox_min": [
        -3775.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3748.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826850950717926,
        0.9238788485527039,
        0.0
      ],
      "plane_d": 3121.0869140625,
      "bbox_min": [
        -3775.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3748.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826850950717926,
        0.9238788485527039,
        -0.0
      ],
      "plane_d": 6000.4091796875,
      "bbox_min": [
        -3775.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3748.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        -0.38268598914146423,
        0.0
      ],
      "plane_d": 1572.184814453125,
      "bbox_min": [
        -3775.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3748.7529296875,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": 5360.599609375,
      "bbox_min": [
        -3775.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3750.37646484375,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 6003.408203125,
      "bbox_min": [
        -3775.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3754.928955078125,
        -4936.52197265625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 3124.09033203125,
      "bbox_min": [
        -3775.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3754.928955078125,
        -4938.1455078125,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": -1590.662353515625,
      "bbox_min": [
        -3775.2470703125,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3754.928955078125,
        -4942.69775390625,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        -0.38268598914146423,
        -0.0
      ],
      "plane_d": -5379.0771484375,
      "bbox_min": [
        -3773.62353515625,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3754.928955078125,
        -4949.76904296875,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        -0.923879086971283,
        -0.0
      ],
      "plane_d": -6021.88623046875,
      "bbox_min": [
        -3769.071044921875,
        -4963.01611328125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3754.928955078125,
        -4956.84033203125,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        -0.923879086971283,
        0.0
      ],
      "plane_d": -3142.56787109375,
      "bbox_min": [
        -3762.0,
        -4961.392578125,
        1057.5999755859375
      ],
      "bbox_max": [
        -3754.928955078125,
        -4956.84033203125,
        1067.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1057.6239013671875,
      "bbox_min": [
        -3762.0,
        -4961.392578125,
        1057.6239013671875
      ],
      "bbox_max": [
        -3754.928955078125,
        -4956.84033203125,
        1057.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1057.6239013671875,
      "bbox_min": [
        -3756.552734375,
        -4949.76904296875,
        1057.6239013671875
      ],
      "bbox_max": [
        -3750.37646484375,
        -4938.7783203125,
        1057.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1057.6239013671875,
      "bbox_min": [
        -3756.552490234375,
        -4960.759765625,
        1057.6239013671875
      ],
      "bbox_max": [
        -3748.7529296875,
        -4945.849609375,
        1057.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1067.6239013671875,
      "bbox_min": [
        -3997.0,
        -4914.76904296875,
        1067.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4909.76904296875,
        1067.6239013671875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1067.6239013671875,
      "bbox_min": [
        -3997.0,
        -4989.76904296875,
        1067.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4984.76953125,
        1067.6239013671875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.0,
        -0.9486833214759827,
        -0.3162277638912201
      ],
      "plane_d": -4391.35498046875,
      "bbox_min": [
        -3997.0,
        -4981.427734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -3667.0,
        -4918.1103515625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833214759827,
        -0.3162277638912201
      ],
      "plane_d": 5000.171875,
      "bbox_min": [
        -3997.0,
        -4979.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3667.0,
        -4918.1103515625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4974.76904296875,
      "bbox_min": [
        -3997.0,
        -4979.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3667.0,
        -4919.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1052.6239013671875,
      "bbox_min": [
        -3997.0,
        -4979.76904296875,
        1052.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4974.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4924.76904296875,
      "bbox_min": [
        -3997.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3667.0,
        -4919.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1052.6239013671875,
      "bbox_min": [
        -3997.0,
        -4924.76904296875,
        1052.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4919.76904296875,
        1052.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": -1655.333984375,
      "bbox_min": [
        -3912.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3752.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": -1590.662353515625,
      "bbox_min": [
        -3842.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3752.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        -0.38268598914146423,
        0.0
      ],
      "plane_d": 1572.184814453125,
      "bbox_min": [
        -3772.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3752.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": 5360.599609375,
      "bbox_min": [
        -3772.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3752.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        -0.38268598914146423,
        -0.0
      ],
      "plane_d": -5379.0771484375,
      "bbox_min": [
        -3772.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3754.928955078125,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 6003.408203125,
      "bbox_min": [
        -3769.071044921875,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3754.928955078125,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 3124.09033203125,
      "bbox_min": [
        -3769.071044921875,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3754.928955078125,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        -0.923879086971283,
        -0.0
      ],
      "plane_d": -6021.88623046875,
      "bbox_min": [
        -3769.071044921875,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3754.928955078125,
        -4956.84033203125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        -0.923879086971283,
        0.0
      ],
      "plane_d": -3142.56787109375,
      "bbox_min": [
        -3762.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3754.928955078125,
        -4956.84033203125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        -0.38268598914146423,
        0.0
      ],
      "plane_d": 1636.856201171875,
      "bbox_min": [
        -3842.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3822.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": 5425.2705078125,
      "bbox_min": [
        -3842.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3822.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        -0.38268598914146423,
        -0.0
      ],
      "plane_d": -5443.74853515625,
      "bbox_min": [
        -3842.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3824.928955078125,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 6030.1962890625,
      "bbox_min": [
        -3839.071044921875,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3824.928955078125,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 3097.302490234375,
      "bbox_min": [
        -3839.071044921875,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3824.928955078125,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        -0.923879086971283,
        -0.0
      ],
      "plane_d": -6048.673828125,
      "bbox_min": [
        -3839.071044921875,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3824.928955078125,
        -4956.84033203125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        -0.923879086971283,
        0.0
      ],
      "plane_d": -3115.780029296875,
      "bbox_min": [
        -3832.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3824.928955078125,
        -4956.84033203125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": 5489.9423828125,
      "bbox_min": [
        -3912.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3892.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        -0.38268598914146423,
        0.0
      ],
      "plane_d": 1701.52783203125,
      "bbox_min": [
        -3912.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3892.0,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": -1720.00537109375,
      "bbox_min": [
        -3912.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3894.928955078125,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        -0.38268598914146423,
        -0.0
      ],
      "plane_d": -5508.419921875,
      "bbox_min": [
        -3912.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3894.928955078125,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 6056.98388671875,
      "bbox_min": [
        -3909.071044921875,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3894.928955078125,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 3070.5146484375,
      "bbox_min": [
        -3909.071044921875,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3894.928955078125,
        -4939.76904296875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        -0.923879086971283,
        -0.0
      ],
      "plane_d": -6075.4619140625,
      "bbox_min": [
        -3909.071044921875,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3894.928955078125,
        -4956.84033203125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        -0.923879086971283,
        0.0
      ],
      "plane_d": -3088.9921875,
      "bbox_min": [
        -3902.0,
        -4959.76904296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3894.928955078125,
        -4956.84033203125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3947.0,
      "bbox_min": [
        -3947.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        1052.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3927.0,
      "bbox_min": [
        -3947.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        1052.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3877.0,
      "bbox_min": [
        -3912.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        1052.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3857.0,
      "bbox_min": [
        -3877.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        1052.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3807.0,
      "bbox_min": [
        -3842.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        1052.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3787.0,
      "bbox_min": [
        -3807.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        1052.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3737.0,
      "bbox_min": [
        -3772.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        1052.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3717.0,
      "bbox_min": [
        -3737.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.9990643262863159,
        0.04324953630566597
      ],
      "plane_d": 4929.6552734375,
      "bbox_min": [
        -3737.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998500943183899,
        0.01731342263519764
      ],
      "plane_d": -4998.818359375,
      "bbox_min": [
        -3737.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4976.26904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8652453422546387,
        0.5013486742973328
      ],
      "plane_d": 3819.323486328125,
      "bbox_min": [
        -3737.0,
        -4982.59423828125,
        970.1239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4976.26904296875,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7183318138122559,
        0.6957006454467773
      ],
      "plane_d": 2897.219482421875,
      "bbox_min": [
        -3737.0,
        -4982.59423828125,
        978.9878540039062
      ],
      "bbox_max": [
        -3717.0,
        -4981.4052734375,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7183318138122559,
        0.6957006454467773
      ],
      "plane_d": 2897.219482421875,
      "bbox_min": [
        -3737.0,
        -4989.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4982.59423828125,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8594192862510681,
        -0.5112714767456055
      ],
      "plane_d": -3784.38232421875,
      "bbox_min": [
        -3737.0,
        -4989.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4982.76904296875,
        985.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9631588459014893,
        -0.26893314719200134
      ],
      "plane_d": -4538.2998046875,
      "bbox_min": [
        -3737.0,
        -4984.7333984375,
        970.1239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4982.76904296875,
        977.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9990643262863159,
        0.04324953630566597
      ],
      "plane_d": -4960.6201171875,
      "bbox_min": [
        -3737.0,
        -4928.26904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9998500943183899,
        0.01731342263519764
      ],
      "plane_d": 4899.23583984375,
      "bbox_min": [
        -3737.0,
        -4923.26904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8652454018592834,
        0.5013485550880432
      ],
      "plane_d": -4746.2060546875,
      "bbox_min": [
        -3737.0,
        -4923.26904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4916.94384765625,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7183317542076111,
        0.6957007050514221
      ],
      "plane_d": -4213.93359375,
      "bbox_min": [
        -3737.0,
        -4918.1328125,
        978.9878540039062
      ],
      "bbox_max": [
        -3717.0,
        -4916.94384765625,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7183317542076111,
        0.6957007050514221
      ],
      "plane_d": -4213.93359375,
      "bbox_min": [
        -3737.0,
        -4916.94384765625,
        970.1239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8594194650650024,
        -0.5112711787223816
      ],
      "plane_d": 4723.47216796875,
      "bbox_min": [
        -3737.0,
        -4916.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4909.76904296875,
        985.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9631587266921997,
        -0.26893362402915955
      ],
      "plane_d": 4996.52783203125,
      "bbox_min": [
        -3737.0,
        -4916.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4914.8046875,
        977.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        -0.38268598914146423,
        0.0
      ],
      "plane_d": 1572.184814453125,
      "bbox_min": [
        -3772.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3752.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": 5360.599609375,
      "bbox_min": [
        -3772.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3752.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": -1590.662353515625,
      "bbox_min": [
        -3772.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3754.928955078125,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        -0.38268598914146423,
        -0.0
      ],
      "plane_d": -5379.0771484375,
      "bbox_min": [
        -3772.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3754.928955078125,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 6003.408203125,
      "bbox_min": [
        -3769.071044921875,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3754.928955078125,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 3124.09033203125,
      "bbox_min": [
        -3769.071044921875,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3754.928955078125,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        -0.923879086971283,
        -0.0
      ],
      "plane_d": -6021.88623046875,
      "bbox_min": [
        -3769.071044921875,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3754.928955078125,
        -4956.84033203125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        -0.923879086971283,
        0.0
      ],
      "plane_d": -3142.56787109375,
      "bbox_min": [
        -3762.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3754.928955078125,
        -4956.84033203125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9990643262863159,
        0.04324953630566597
      ],
      "plane_d": 4929.6552734375,
      "bbox_min": [
        -3807.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998500943183899,
        0.01731342263519764
      ],
      "plane_d": -4998.818359375,
      "bbox_min": [
        -3807.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4976.26904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8652453422546387,
        0.5013486742973328
      ],
      "plane_d": 3819.323486328125,
      "bbox_min": [
        -3807.0,
        -4982.59423828125,
        970.1239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4976.26904296875,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7183318138122559,
        0.6957006454467773
      ],
      "plane_d": 2897.219482421875,
      "bbox_min": [
        -3807.0,
        -4982.59423828125,
        978.9878540039062
      ],
      "bbox_max": [
        -3787.0,
        -4981.4052734375,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7183318138122559,
        0.6957006454467773
      ],
      "plane_d": 2897.219482421875,
      "bbox_min": [
        -3807.0,
        -4989.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4982.59423828125,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8594192862510681,
        -0.5112714767456055
      ],
      "plane_d": -3784.38232421875,
      "bbox_min": [
        -3807.0,
        -4989.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4982.76904296875,
        985.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9631588459014893,
        -0.26893314719200134
      ],
      "plane_d": -4538.2998046875,
      "bbox_min": [
        -3807.0,
        -4984.7333984375,
        970.1239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4982.76904296875,
        977.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9990643262863159,
        0.04324953630566597
      ],
      "plane_d": -4960.6201171875,
      "bbox_min": [
        -3807.0,
        -4928.26904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9998500943183899,
        0.01731342263519764
      ],
      "plane_d": 4899.23583984375,
      "bbox_min": [
        -3807.0,
        -4923.26904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8652454018592834,
        0.5013485550880432
      ],
      "plane_d": -4746.2060546875,
      "bbox_min": [
        -3807.0,
        -4923.26904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4916.94384765625,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7183317542076111,
        0.6957007050514221
      ],
      "plane_d": -4213.93359375,
      "bbox_min": [
        -3807.0,
        -4918.1328125,
        978.9878540039062
      ],
      "bbox_max": [
        -3787.0,
        -4916.94384765625,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7183317542076111,
        0.6957007050514221
      ],
      "plane_d": -4213.93359375,
      "bbox_min": [
        -3807.0,
        -4916.94384765625,
        970.1239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8594194650650024,
        -0.5112711787223816
      ],
      "plane_d": 4723.47216796875,
      "bbox_min": [
        -3807.0,
        -4916.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4909.76904296875,
        985.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9631587266921997,
        -0.26893362402915955
      ],
      "plane_d": 4996.52783203125,
      "bbox_min": [
        -3807.0,
        -4916.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4914.8046875,
        977.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": -1655.333984375,
      "bbox_min": [
        -3842.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3822.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        -0.38268598914146423,
        0.0
      ],
      "plane_d": 1636.856201171875,
      "bbox_min": [
        -3842.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3822.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": 5425.2705078125,
      "bbox_min": [
        -3842.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3822.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        -0.38268598914146423,
        -0.0
      ],
      "plane_d": -5443.74853515625,
      "bbox_min": [
        -3842.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3824.928955078125,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 6030.1962890625,
      "bbox_min": [
        -3839.071044921875,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3824.928955078125,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 3097.302490234375,
      "bbox_min": [
        -3839.071044921875,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3824.928955078125,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        -0.923879086971283,
        -0.0
      ],
      "plane_d": -6048.673828125,
      "bbox_min": [
        -3839.071044921875,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3824.928955078125,
        -4956.84033203125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        -0.923879086971283,
        0.0
      ],
      "plane_d": -3115.780029296875,
      "bbox_min": [
        -3832.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3824.928955078125,
        -4956.84033203125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9990643262863159,
        0.04324953630566597
      ],
      "plane_d": 4929.6552734375,
      "bbox_min": [
        -3877.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998500943183899,
        0.01731342263519764
      ],
      "plane_d": -4998.818359375,
      "bbox_min": [
        -3877.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4976.26904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8652453422546387,
        0.5013486742973328
      ],
      "plane_d": 3819.323486328125,
      "bbox_min": [
        -3877.0,
        -4982.59423828125,
        970.1239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4976.26904296875,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7183318138122559,
        0.6957006454467773
      ],
      "plane_d": 2897.219482421875,
      "bbox_min": [
        -3877.0,
        -4982.59423828125,
        978.9878540039062
      ],
      "bbox_max": [
        -3857.0,
        -4981.4052734375,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7183318138122559,
        0.6957006454467773
      ],
      "plane_d": 2897.219482421875,
      "bbox_min": [
        -3877.0,
        -4989.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4982.59423828125,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8594192862510681,
        -0.5112714767456055
      ],
      "plane_d": -3784.38232421875,
      "bbox_min": [
        -3877.0,
        -4989.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4982.76904296875,
        985.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9631588459014893,
        -0.26893314719200134
      ],
      "plane_d": -4538.2998046875,
      "bbox_min": [
        -3877.0,
        -4984.7333984375,
        970.1239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4982.76904296875,
        977.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9990643262863159,
        0.04324953630566597
      ],
      "plane_d": -4960.6201171875,
      "bbox_min": [
        -3877.0,
        -4928.26904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9998500943183899,
        0.01731342263519764
      ],
      "plane_d": 4899.23583984375,
      "bbox_min": [
        -3877.0,
        -4923.26904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8652454018592834,
        0.5013485550880432
      ],
      "plane_d": -4746.2060546875,
      "bbox_min": [
        -3877.0,
        -4923.26904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4916.94384765625,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7183317542076111,
        0.6957007050514221
      ],
      "plane_d": -4213.93359375,
      "bbox_min": [
        -3877.0,
        -4918.1328125,
        978.9878540039062
      ],
      "bbox_max": [
        -3857.0,
        -4916.94384765625,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7183317542076111,
        0.6957007050514221
      ],
      "plane_d": -4213.93359375,
      "bbox_min": [
        -3877.0,
        -4916.94384765625,
        970.1239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8594194650650024,
        -0.5112711787223816
      ],
      "plane_d": 4723.47216796875,
      "bbox_min": [
        -3877.0,
        -4916.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4909.76904296875,
        985.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9631587266921997,
        -0.26893362402915955
      ],
      "plane_d": 4996.52783203125,
      "bbox_min": [
        -3877.0,
        -4916.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4914.8046875,
        977.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": 5489.9423828125,
      "bbox_min": [
        -3912.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3892.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238784909248352,
        -0.38268598914146423,
        0.0
      ],
      "plane_d": 1701.52783203125,
      "bbox_min": [
        -3912.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3892.0,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        0.38268598914146423,
        0.0
      ],
      "plane_d": -1720.00537109375,
      "bbox_min": [
        -3912.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3894.928955078125,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238784909248352,
        -0.38268598914146423,
        -0.0
      ],
      "plane_d": -5508.419921875,
      "bbox_min": [
        -3912.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3894.928955078125,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 6056.98388671875,
      "bbox_min": [
        -3909.071044921875,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3894.928955078125,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        0.923879086971283,
        0.0
      ],
      "plane_d": 3070.5146484375,
      "bbox_min": [
        -3909.071044921875,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3894.928955078125,
        -4939.76904296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268449902534485,
        -0.923879086971283,
        -0.0
      ],
      "plane_d": -6075.4619140625,
      "bbox_min": [
        -3909.071044921875,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3894.928955078125,
        -4956.84033203125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268449902534485,
        -0.923879086971283,
        0.0
      ],
      "plane_d": -3088.9921875,
      "bbox_min": [
        -3902.0,
        -4959.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3894.928955078125,
        -4956.84033203125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9990643262863159,
        0.04324953630566597
      ],
      "plane_d": 4929.6552734375,
      "bbox_min": [
        -3947.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998500943183899,
        0.01731342263519764
      ],
      "plane_d": -4998.818359375,
      "bbox_min": [
        -3947.0,
        -4989.76904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4976.26904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8652453422546387,
        0.5013486742973328
      ],
      "plane_d": 3819.323486328125,
      "bbox_min": [
        -3947.0,
        -4982.59423828125,
        970.1239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4976.26904296875,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7183318138122559,
        0.6957006454467773
      ],
      "plane_d": 2897.219482421875,
      "bbox_min": [
        -3947.0,
        -4982.59423828125,
        978.9878540039062
      ],
      "bbox_max": [
        -3927.0,
        -4981.4052734375,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7183318138122559,
        0.6957006454467773
      ],
      "plane_d": 2897.219482421875,
      "bbox_min": [
        -3947.0,
        -4989.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4982.59423828125,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8594192862510681,
        -0.5112714767456055
      ],
      "plane_d": -3784.38232421875,
      "bbox_min": [
        -3947.0,
        -4989.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4982.76904296875,
        985.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9631588459014893,
        -0.26893314719200134
      ],
      "plane_d": -4538.2998046875,
      "bbox_min": [
        -3947.0,
        -4984.7333984375,
        970.1239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4982.76904296875,
        977.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9990643262863159,
        0.04324953630566597
      ],
      "plane_d": -4960.6201171875,
      "bbox_min": [
        -3947.0,
        -4928.26904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9998500943183899,
        0.01731342263519764
      ],
      "plane_d": 4899.23583984375,
      "bbox_min": [
        -3947.0,
        -4923.26904296875,
        854.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8652454018592834,
        0.5013485550880432
      ],
      "plane_d": -4746.2060546875,
      "bbox_min": [
        -3947.0,
        -4923.26904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4916.94384765625,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7183317542076111,
        0.6957007050514221
      ],
      "plane_d": -4213.93359375,
      "bbox_min": [
        -3947.0,
        -4918.1328125,
        978.9878540039062
      ],
      "bbox_max": [
        -3927.0,
        -4916.94384765625,
        980.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7183317542076111,
        0.6957007050514221
      ],
      "plane_d": -4213.93359375,
      "bbox_min": [
        -3947.0,
        -4916.94384765625,
        970.1239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8594194650650024,
        -0.5112711787223816
      ],
      "plane_d": 4723.47216796875,
      "bbox_min": [
        -3947.0,
        -4916.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4909.76904296875,
        985.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9631587266921997,
        -0.26893362402915955
      ],
      "plane_d": 4996.52783203125,
      "bbox_min": [
        -3947.0,
        -4916.76904296875,
        970.1239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4914.8046875,
        977.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914451837539673,
        -0.1305239349603653,
        0.0
      ],
      "plane_d": -4459.62548828125,
      "bbox_min": [
        -4133.0,
        -4869.7998046875,
        1006.0
      ],
      "bbox_max": [
        -3667.0,
        -4489.76904296875,
        1036.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -3857.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3667.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3737.0,
      "bbox_min": [
        -3857.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3667.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3807.0,
      "bbox_min": [
        -3857.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3737.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4869.76904296875,
      "bbox_min": [
        -3857.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3807.0,
        -4869.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3713906705379486,
        0.9284766912460327
      ],
      "plane_d": -2751.56982421875,
      "bbox_min": [
        -3857.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3807.0,
        -4869.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3787.0,
      "bbox_min": [
        -3807.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3737.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4869.76904296875,
      "bbox_min": [
        -3787.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3737.0,
        -4869.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3713906705379486,
        0.9284766912460327
      ],
      "plane_d": -2751.56982421875,
      "bbox_min": [
        -3787.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3737.0,
        -4869.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1013.6239013671875,
      "bbox_min": [
        -3807.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3787.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.33803048729896545,
        0.9411351680755615
      ],
      "plane_d": -2600.08740234375,
      "bbox_min": [
        -3807.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3787.0,
        -4869.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3807.0,
        -4869.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4819.76904296875,
      "bbox_min": [
        -3807.0,
        -4869.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4819.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3713906705379486,
        0.9284766912460327
      ],
      "plane_d": -2751.56982421875,
      "bbox_min": [
        -3807.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3787.0,
        -4869.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4819.76904296875,
      "bbox_min": [
        -3807.0,
        -4819.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3787.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3717.0,
      "bbox_min": [
        -3737.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3667.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4869.76904296875,
      "bbox_min": [
        -3717.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3667.0,
        -4869.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3713906705379486,
        0.9284766912460327
      ],
      "plane_d": -2751.56982421875,
      "bbox_min": [
        -3717.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3667.0,
        -4869.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -3667.0,
      "bbox_min": [
        -3667.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3667.0,
        -4869.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1013.6239013671875,
      "bbox_min": [
        -3737.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3717.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.33803048729896545,
        0.9411351680755615
      ],
      "plane_d": -2600.08740234375,
      "bbox_min": [
        -3737.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3717.0,
        -4869.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3737.0,
        -4869.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4819.76904296875,
      "bbox_min": [
        -3737.0,
        -4869.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4819.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3713906705379486,
        0.9284766912460327
      ],
      "plane_d": -2751.56982421875,
      "bbox_min": [
        -3737.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3717.0,
        -4869.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4819.76904296875,
      "bbox_min": [
        -3737.0,
        -4819.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -4133.0,
        -4666.9248046875,
        1012.6239013671875
      ],
      "bbox_max": [
        -4027.4716796875,
        -4489.76904296875,
        1032.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1012.6239013671875,
      "bbox_min": [
        -4128.0,
        -4666.9248046875,
        1012.6239013671875
      ],
      "bbox_max": [
        -4027.4716796875,
        -4539.76904296875,
        1015.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4128.0,
        -4659.76904296875,
        1012.6239013671875
      ],
      "bbox_max": [
        -4027.4716796875,
        -4539.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4639.76904296875,
      "bbox_min": [
        -4128.0,
        -4659.76904296875,
        1012.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4639.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4128.0,
      "bbox_min": [
        -4128.0,
        -4659.76904296875,
        1012.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4639.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13052630424499512,
        -0.9914448261260986,
        0.0
      ],
      "plane_d": -5133.53564453125,
      "bbox_min": [
        -4087.0,
        -4647.60595703125,
        1012.6239013671875
      ],
      "bbox_max": [
        -4027.4716796875,
        -4639.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -4133.0,
        -4666.9248046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4027.4716796875,
        -4539.76904296875,
        1032.6239013671875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 4108.0,
      "bbox_min": [
        -4133.0,
        -4666.9248046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4027.4716796875,
        -4539.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4639.76904296875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.8574929237365723,
        0.0
      ],
      "plane_d": 6119.5576171875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": -1854.73046875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439898312091827
      ],
      "plane_d": -4412.7958984375,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -4133.0,
        -4645.7685546875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 3009.306396484375,
      "bbox_min": [
        -4133.0,
        -4645.7685546875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4133.0,
      "bbox_min": [
        -4133.0,
        -4645.2685546875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4639.76904296875,
        1029.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        -0.0,
        0.8574929237365723
      ],
      "plane_d": 1252.9482421875,
      "bbox_min": [
        -4133.0,
        -4643.43603515625,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4639.76904296875,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": -1863.305419921875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4642.935546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.8574929237365723,
        0.0
      ],
      "plane_d": 6110.982421875,
      "bbox_min": [
        -4133.0,
        -4649.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4642.935546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4133.0,
      "bbox_min": [
        -4133.0,
        -4649.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4642.935546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        -0.0,
        0.8574929237365723
      ],
      "plane_d": 1252.9482421875,
      "bbox_min": [
        -4133.0,
        -4649.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4642.935546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 3009.306396484375,
      "bbox_min": [
        -4133.0,
        -4649.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4645.2685546875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4649.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439898312091827
      ],
      "plane_d": -4423.646484375,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4108.0,
        -4649.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 3009.306396484375,
      "bbox_min": [
        -4133.0,
        -4656.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4649.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 3009.306396484375,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4656.26904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 4133.0,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4649.76904296875,
        1029.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957900047302,
        -0.0,
        0.8574929237365723
      ],
      "plane_d": 1252.9482421875,
      "bbox_min": [
        -4133.0,
        -4659.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4128.0,
        -4649.76904296875,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13052630424499512,
        -0.9914448261260986,
        0.0
      ],
      "plane_d": -5133.53564453125,
      "bbox_min": [
        -4108.0,
        -4666.9248046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4027.4716796875,
        -4639.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -4108.0,
        -4666.9248046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4028.38525390625,
        -4643.26904296875,
        1032.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.129609152674675,
        -0.9778425097465515,
        -0.16439448297023773
      ],
      "plane_d": -4902.78515625,
      "bbox_min": [
        -4108.0,
        -4666.9248046875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4028.9072265625,
        -4645.26904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.127860426902771,
        0.9780719876289368,
        -0.16439850628376007
      ],
      "plane_d": 5244.048828125,
      "bbox_min": [
        -4108.0,
        -4666.9248046875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4031.081787109375,
        -4645.26904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12829910218715668,
        -0.9780147671699524,
        -0.16439707577228546
      ],
      "plane_d": -4908.98681640625,
      "bbox_min": [
        -4108.0,
        -4666.9248046875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4031.734375,
        -4656.26904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13052625954151154,
        0.9914448261260986,
        0.0
      ],
      "plane_d": 5153.365234375,
      "bbox_min": [
        -4108.0,
        -4666.9248046875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4032.64794921875,
        -4656.26904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439898312091827
      ],
      "plane_d": -4423.646484375,
      "bbox_min": [
        -4108.0,
        -4656.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4086.96728515625,
        -4656.26904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439898312091827
      ],
      "plane_d": -4412.7958984375,
      "bbox_min": [
        -4108.0,
        -4645.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -4086.967041015625,
        -4645.26904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13052625954151154,
        0.9914448261260986,
        0.0
      ],
      "plane_d": 5153.365234375,
      "bbox_min": [
        -4087.0,
        -4666.9248046875,
        1015.6239013671875
      ],
      "bbox_max": [
        -4032.64794921875,
        -4659.76904296875,
        1029.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826834261417389,
        -0.9238795042037964,
        0.0
      ],
      "plane_d": -5835.07470703125,
      "bbox_min": [
        -4032.64794921875,
        -4687.90380859375,
        1012.6239013671875
      ],
      "bbox_max": [
        -3972.0,
        -4647.60595703125,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -4032.64794921875,
        -4687.90380859375,
        1012.6239013671875
      ],
      "bbox_max": [
        -3972.0,
        -4647.60595703125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1012.6239013671875,
      "bbox_min": [
        -4032.64794921875,
        -4687.90380859375,
        1012.6239013671875
      ],
      "bbox_max": [
        -3972.0,
        -4647.60595703125,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268324732780457,
        0.9238796234130859,
        0.0
      ],
      "plane_d": 5854.9033203125,
      "bbox_min": [
        -4032.64794921875,
        -4687.90380859375,
        1012.6239013671875
      ],
      "bbox_max": [
        -3982.0,
        -4666.9248046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -4032.64794921875,
        -4687.90380859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3972.0,
        -4647.60595703125,
        1032.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.37747666239738464,
        0.9113092422485352,
        -0.16439828276634216
      ],
      "plane_d": 5928.404296875,
      "bbox_min": [
        -4032.64794921875,
        -4687.90380859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3973.512939453125,
        -4650.52880859375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3774767220020294,
        -0.9113094210624695,
        -0.16439735889434814
      ],
      "plane_d": -5591.841796875,
      "bbox_min": [
        -4032.64794921875,
        -4687.90380859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3973.76513671875,
        -4651.01611328125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -4028.9072265625,
        -4675.3876953125,
        1029.6239013671875
      ],
      "bbox_max": [
        -3973.76513671875,
        -4651.01611328125,
        1029.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268324732780457,
        0.9238796234130859,
        0.0
      ],
      "plane_d": 5854.9033203125,
      "bbox_min": [
        -4032.64794921875,
        -4687.90380859375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3978.97412109375,
        -4661.0791015625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3774760961532593,
        0.9113097190856934,
        -0.1643970012664795
      ],
      "plane_d": 5939.083984375,
      "bbox_min": [
        -4031.86474609375,
        -4685.283203125,
        1029.6239013671875
      ],
      "bbox_max": [
        -3978.97412109375,
        -4661.0791015625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -4031.86474609375,
        -4685.283203125,
        1029.6239013671875
      ],
      "bbox_max": [
        -3979.226318359375,
        -4661.56640625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.377476304769516,
        -0.9113095998764038,
        -0.16439735889434814
      ],
      "plane_d": -5602.5224609375,
      "bbox_min": [
        -4031.86474609375,
        -4685.283203125,
        1029.6239013671875
      ],
      "bbox_max": [
        -3980.23486328125,
        -4663.5146484375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6087611317634583,
        -0.7933535575866699,
        0.0
      ],
      "plane_d": -6123.4228515625,
      "bbox_min": [
        -3982.0,
        -4721.2763671875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3924.365478515625,
        -4670.5830078125,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3982.0,
        -4721.2763671875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3924.365478515625,
        -4670.5830078125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1012.6239013671875,
      "bbox_min": [
        -3982.0,
        -4721.2763671875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3924.365478515625,
        -4670.5830078125,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087613701820374,
        0.7933533787727356,
        0.0
      ],
      "plane_d": 6143.251953125,
      "bbox_min": [
        -3982.0,
        -4721.2763671875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3938.507568359375,
        -4687.90380859375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -3982.0,
        -4721.2763671875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3924.365478515625,
        -4670.5830078125,
        1032.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6004786491394043,
        0.7825595140457153,
        -0.16439571976661682
      ],
      "plane_d": 6212.828125,
      "bbox_min": [
        -3982.0,
        -4721.2763671875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3926.505126953125,
        -4673.20361328125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6004782915115356,
        -0.7825585007667542,
        -0.16440211236476898
      ],
      "plane_d": -5876.2568359375,
      "bbox_min": [
        -3982.0,
        -4721.2763671875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3926.86181640625,
        -4673.640625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -3974.773681640625,
        -4711.05712890625,
        1029.6239013671875
      ],
      "bbox_max": [
        -3926.86181640625,
        -4673.640625,
        1029.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6087613701820374,
        0.7933533787727356,
        0.0
      ],
      "plane_d": 6143.251953125,
      "bbox_min": [
        -3982.0,
        -4721.2763671875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3934.228271484375,
        -4682.66259765625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6004785895347595,
        0.7825595736503601,
        -0.16439571976661682
      ],
      "plane_d": 6223.51025390625,
      "bbox_min": [
        -3980.487060546875,
        -4719.13720703125,
        1029.6239013671875
      ],
      "bbox_max": [
        -3934.228271484375,
        -4682.66259765625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -3980.487060546875,
        -4719.13720703125,
        1029.6239013671875
      ],
      "bbox_max": [
        -3934.5849609375,
        -4683.099609375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6004780530929565,
        -0.7825586795806885,
        -0.16440211236476898
      ],
      "plane_d": -5886.9384765625,
      "bbox_min": [
        -3980.487060546875,
        -4719.13720703125,
        1029.6239013671875
      ],
      "bbox_max": [
        -3936.01123046875,
        -4684.8466796875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933534979820251,
        -0.6087612509727478,
        0.0
      ],
      "plane_d": -5978.9296875,
      "bbox_min": [
        -3938.507568359375,
        -4764.76904296875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3887.814208984375,
        -4707.13427734375,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3938.507568359375,
        -4764.76904296875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3887.814208984375,
        -4707.13427734375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1012.6239013671875,
      "bbox_min": [
        -3938.507568359375,
        -4764.76904296875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3887.814208984375,
        -4707.13427734375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.793353259563446,
        0.6087615489959717,
        0.0
      ],
      "plane_d": 5998.759765625,
      "bbox_min": [
        -3938.507568359375,
        -4764.76904296875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3905.134765625,
        -4721.2763671875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -3938.507568359375,
        -4764.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3887.814208984375,
        -4707.13427734375,
        1032.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7825582027435303,
        0.6004781723022461,
        -0.16440390050411224
      ],
      "plane_d": 6070.302734375,
      "bbox_min": [
        -3938.507568359375,
        -4764.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3890.4345703125,
        -4709.27392578125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7825579643249512,
        -0.6004788279533386,
        -0.1644025295972824
      ],
      "plane_d": -5733.72998046875,
      "bbox_min": [
        -3938.507568359375,
        -4764.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3890.871337890625,
        -4709.630859375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -3928.2880859375,
        -4757.54296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -3890.871337890625,
        -4709.630859375,
        1029.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.793353259563446,
        0.6087615489959717,
        0.0
      ],
      "plane_d": 5998.759765625,
      "bbox_min": [
        -3938.507568359375,
        -4764.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3899.8935546875,
        -4716.99755859375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7825587391853333,
        0.6004774570465088,
        -0.16440390050411224
      ],
      "plane_d": 6080.982421875,
      "bbox_min": [
        -3936.367919921875,
        -4763.255859375,
        1029.6239013671875
      ],
      "bbox_max": [
        -3899.8935546875,
        -4716.99755859375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -3936.367919921875,
        -4763.255859375,
        1029.6239013671875
      ],
      "bbox_max": [
        -3900.33056640625,
        -4717.35400390625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7825586795806885,
        -0.600477933883667,
        -0.1644025593996048
      ],
      "plane_d": -5744.41064453125,
      "bbox_min": [
        -3936.367919921875,
        -4763.255859375,
        1029.6239013671875
      ],
      "bbox_max": [
        -3902.077392578125,
        -4718.7802734375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -3997.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3906.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3947.0,
      "bbox_min": [
        -3997.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3906.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4869.76904296875,
      "bbox_min": [
        -3997.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3947.0,
        -4869.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3713906705379486,
        0.9284766912460327
      ],
      "plane_d": -2751.56982421875,
      "bbox_min": [
        -3997.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3947.0,
        -4869.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3997.0,
      "bbox_min": [
        -3997.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3997.0,
        -4869.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3927.0,
      "bbox_min": [
        -3947.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3906.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4869.76904296875,
      "bbox_min": [
        -3927.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3906.0,
        -4869.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3713906705379486,
        0.9284766912460327
      ],
      "plane_d": -2751.56982421875,
      "bbox_min": [
        -3927.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3906.0,
        -4869.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.33803048729896545,
        0.9411351680755615
      ],
      "plane_d": -2600.08740234375,
      "bbox_min": [
        -3947.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3927.0,
        -4869.76904296875,
        1013.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3947.0,
        -4869.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4819.76904296875,
      "bbox_min": [
        -3947.0,
        -4869.7998046875,
        1013.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4819.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3713906705379486,
        0.9284766912460327
      ],
      "plane_d": -2751.56982421875,
      "bbox_min": [
        -3947.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3927.0,
        -4869.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4819.76904296875,
      "bbox_min": [
        -3947.0,
        -4819.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3927.0,
        -4819.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1016.6239013671875,
      "bbox_min": [
        -3906.0,
        -4869.7998046875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4754.76904296875,
        1032.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1012.6239013671875,
      "bbox_min": [
        -3905.134765625,
        -4815.4169921875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3864.8369140625,
        -4754.76904296875,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": -5411.44384765625,
      "bbox_min": [
        -3905.134765625,
        -4815.4169921875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3864.8369140625,
        -4754.76904296875,
        1016.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3905.134765625,
        -4815.4169921875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3864.8369140625,
        -4754.76904296875,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238796830177307,
        0.38268303871154785,
        0.0
      ],
      "plane_d": 5431.27099609375,
      "bbox_min": [
        -3905.134765625,
        -4815.4169921875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3871.995361328125,
        -4764.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4067361056804657,
        0.9135456681251526,
        0.0
      ],
      "plane_d": 2803.706787109375,
      "bbox_min": [
        -3890.1162109375,
        -4811.533203125,
        1012.6239013671875
      ],
      "bbox_max": [
        -3871.995361328125,
        -4792.958984375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8160149455070496,
        -0.5780308246612549,
        0.0
      ],
      "plane_d": 393.022216796875,
      "bbox_min": [
        -3887.56591796875,
        -4811.533203125,
        1014.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4801.4814453125,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.918796956539154,
        -0.39473047852516174,
        -0.0
      ],
      "plane_d": -5467.73046875,
      "bbox_min": [
        -3887.56591796875,
        -4804.7890625,
        1014.6239013671875
      ],
      "bbox_max": [
        -3884.14990234375,
        -4801.4814453125,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.918796956539154,
        0.39473047852516174,
        0.0
      ],
      "plane_d": 5464.7861328125,
      "bbox_min": [
        -3887.56591796875,
        -4804.7890625,
        1014.6239013671875
      ],
      "bbox_max": [
        -3884.14990234375,
        -4801.4814453125,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8160271644592285,
        0.57801353931427,
        0.0
      ],
      "plane_d": -396.22412109375,
      "bbox_min": [
        -3887.56591796875,
        -4804.7890625,
        1014.6239013671875
      ],
      "bbox_max": [
        -3884.8603515625,
        -4801.4814453125,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14240609109401703,
        0.9898083209991455,
        0.0
      ],
      "plane_d": 5306.017578125,
      "bbox_min": [
        -3886.85546875,
        -4804.7890625,
        1014.6239013671875
      ],
      "bbox_max": [
        -3884.8603515625,
        -4801.4814453125,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.142424076795578,
        -0.9898057579994202,
        -0.0
      ],
      "plane_d": -5309.146484375,
      "bbox_min": [
        -3886.85546875,
        -4804.7890625,
        1014.6239013671875
      ],
      "bbox_max": [
        -3885.1474609375,
        -4804.54345703125,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9187976121902466,
        0.3947289288043976,
        0.0
      ],
      "plane_d": 5464.951171875,
      "bbox_min": [
        -3884.853759765625,
        -4811.533203125,
        1014.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9187976121902466,
        -0.3947289288043976,
        -0.0
      ],
      "plane_d": -5467.89599609375,
      "bbox_min": [
        -3884.853759765625,
        -4811.533203125,
        1014.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8160134553909302,
        -0.578032910823822,
        0.0
      ],
      "plane_d": 386.894775390625,
      "bbox_min": [
        -3884.853759765625,
        -4811.533203125,
        1014.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.816008985042572,
        0.5780391693115234,
        0.0
      ],
      "plane_d": -389.9189453125,
      "bbox_min": [
        -3884.853759765625,
        -4811.533203125,
        1014.6239013671875
      ],
      "bbox_max": [
        -3882.1484375,
        -4808.2255859375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14240175485610962,
        0.9898089170455933,
        0.0
      ],
      "plane_d": 5312.29248046875,
      "bbox_min": [
        -3884.143310546875,
        -4811.533203125,
        1014.6239013671875
      ],
      "bbox_max": [
        -3882.1484375,
        -4808.2255859375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14241474866867065,
        -0.9898070693016052,
        -0.0
      ],
      "plane_d": -5315.40576171875,
      "bbox_min": [
        -3884.143310546875,
        -4811.533203125,
        1014.6239013671875
      ],
      "bbox_max": [
        -3882.435302734375,
        -4811.28759765625,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238796830177307,
        0.38268303871154785,
        0.0
      ],
      "plane_d": 5431.27099609375,
      "bbox_min": [
        -3905.134765625,
        -4815.4169921875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3871.995361328125,
        -4764.76904296875,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4067361056804657,
        0.9135456681251526,
        0.0
      ],
      "plane_d": 2803.706787109375,
      "bbox_min": [
        -3890.1162109375,
        -4811.533203125,
        1015.6239013671875
      ],
      "bbox_max": [
        -3871.995361328125,
        -4792.958984375,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8160149455070496,
        -0.5780308246612549,
        0.0
      ],
      "plane_d": 393.022216796875,
      "bbox_min": [
        -3887.56591796875,
        -4811.533203125,
        1015.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4801.4814453125,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.918796956539154,
        -0.39473047852516174,
        -0.0
      ],
      "plane_d": -5467.73046875,
      "bbox_min": [
        -3887.56591796875,
        -4804.7890625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3884.14990234375,
        -4801.4814453125,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.918796956539154,
        0.39473047852516174,
        0.0
      ],
      "plane_d": 5464.7861328125,
      "bbox_min": [
        -3887.56591796875,
        -4804.7890625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3884.14990234375,
        -4801.4814453125,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8160271644592285,
        0.57801353931427,
        0.0
      ],
      "plane_d": -396.22412109375,
      "bbox_min": [
        -3887.56591796875,
        -4804.7890625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3884.8603515625,
        -4801.4814453125,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14240609109401703,
        0.9898083209991455,
        0.0
      ],
      "plane_d": 5306.017578125,
      "bbox_min": [
        -3886.85546875,
        -4804.7890625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3884.8603515625,
        -4801.4814453125,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.142424076795578,
        -0.9898057579994202,
        -0.0
      ],
      "plane_d": -5309.146484375,
      "bbox_min": [
        -3886.85546875,
        -4804.7890625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3885.1474609375,
        -4804.54345703125,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9187976121902466,
        0.3947289288043976,
        0.0
      ],
      "plane_d": 5464.951171875,
      "bbox_min": [
        -3884.853759765625,
        -4811.533203125,
        1015.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9187976121902466,
        -0.3947289288043976,
        -0.0
      ],
      "plane_d": -5467.89599609375,
      "bbox_min": [
        -3884.853759765625,
        -4811.533203125,
        1015.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8160134553909302,
        -0.578032910823822,
        0.0
      ],
      "plane_d": 386.894775390625,
      "bbox_min": [
        -3884.853759765625,
        -4811.533203125,
        1015.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.816008985042572,
        0.5780391693115234,
        0.0
      ],
      "plane_d": -389.9189453125,
      "bbox_min": [
        -3884.853759765625,
        -4811.533203125,
        1015.6239013671875
      ],
      "bbox_max": [
        -3882.1484375,
        -4808.2255859375,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14240175485610962,
        0.9898089170455933,
        0.0
      ],
      "plane_d": 5312.29248046875,
      "bbox_min": [
        -3884.143310546875,
        -4811.533203125,
        1015.6239013671875
      ],
      "bbox_max": [
        -3882.1484375,
        -4808.2255859375,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14241474866867065,
        -0.9898070693016052,
        -0.0
      ],
      "plane_d": -5315.40576171875,
      "bbox_min": [
        -3884.143310546875,
        -4811.533203125,
        1015.6239013671875
      ],
      "bbox_max": [
        -3882.435302734375,
        -4811.28759765625,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.01679634116590023,
        0.9998589158058167
      ],
      "plane_d": -931.6865844726562,
      "bbox_min": [
        -3906.0,
        -4869.7998046875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4810.24072265625,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004761095624417067,
        0.01776866428554058,
        0.9998307824134827
      ],
      "plane_d": -945.3818359375,
      "bbox_min": [
        -3884.155517578125,
        -4869.7998046875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4810.24072265625,
        1013.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.33803048729896545,
        0.9411351680755615
      ],
      "plane_d": -2600.08740234375,
      "bbox_min": [
        -3881.81298828125,
        -4869.7998046875,
        1012.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4829.41943359375,
        1013.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3877.0,
      "bbox_min": [
        -3877.0,
        -4869.7998046875,
        1013.6128540039062
      ],
      "bbox_max": [
        -3877.0,
        -4869.76904296875,
        1013.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1908085197210312,
        -0.9816272854804993,
        0.0
      ],
      "plane_d": -4003.72802734375,
      "bbox_min": [
        -3881.81298828125,
        -4833.2099609375,
        1012.9512939453125
      ],
      "bbox_max": [
        -3869.01708984375,
        -4830.72265625,
        1013.009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.6239013671875,
      "bbox_min": [
        -3906.0,
        -4869.7998046875,
        1012.7108764648438
      ],
      "bbox_max": [
        -3857.0,
        -4810.24072265625,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3713906705379486,
        0.9284766912460327
      ],
      "plane_d": -2751.56982421875,
      "bbox_min": [
        -3906.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3877.0,
        -4869.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4869.76904296875,
      "bbox_min": [
        -3882.099365234375,
        -4869.7998046875,
        1012.9461059570312
      ],
      "bbox_max": [
        -3857.0,
        -4817.7373046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3713906705379486,
        0.9284766912460327
      ],
      "plane_d": -2751.56982421875,
      "bbox_min": [
        -3877.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "bbox_max": [
        -3857.0,
        -4869.76904296875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1908085197210312,
        -0.9816272854804993,
        0.0
      ],
      "plane_d": -4003.72802734375,
      "bbox_min": [
        -3882.099365234375,
        -4833.2099609375,
        1012.9461059570312
      ],
      "bbox_max": [
        -3862.31201171875,
        -4817.7373046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37764614820480347,
        -0.9259499907493591,
        -0.0
      ],
      "plane_d": -5929.62109375,
      "bbox_min": [
        -3882.099365234375,
        -4828.49072265625,
        1014.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4817.7373046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869989156723022,
        -0.16072678565979004,
        -0.0
      ],
      "plane_d": -4606.1484375,
      "bbox_min": [
        -3882.099365234375,
        -4821.29052734375,
        1014.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9869989156723022,
        0.16072678565979004,
        0.0
      ],
      "plane_d": 4603.20361328125,
      "bbox_min": [
        -3882.099365234375,
        -4821.29052734375,
        1014.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37762999534606934,
        0.9259566068649292,
        0.0
      ],
      "plane_d": 5926.5185546875,
      "bbox_min": [
        -3882.099365234375,
        -4821.29052734375,
        1014.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6519463658332825,
        0.7582650780677795,
        0.0
      ],
      "plane_d": 1123.054443359375,
      "bbox_min": [
        -3882.099365234375,
        -4821.29052734375,
        1014.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6519314050674438,
        -0.758277952671051,
        0.0
      ],
      "plane_d": -1126.246337890625,
      "bbox_min": [
        -3880.212158203125,
        -4821.29052734375,
        1014.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4820.16552734375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9869989156723022,
        0.16072678565979004,
        0.0
      ],
      "plane_d": 4603.3740234375,
      "bbox_min": [
        -3881.099365234375,
        -4828.49072265625,
        1014.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869989156723022,
        -0.16072678565979004,
        -0.0
      ],
      "plane_d": -4606.318359375,
      "bbox_min": [
        -3881.099365234375,
        -4828.49072265625,
        1014.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37764614820480347,
        -0.9259499907493591,
        -0.0
      ],
      "plane_d": -5935.91015625,
      "bbox_min": [
        -3881.099365234375,
        -4828.49072265625,
        1014.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37762999534606934,
        0.9259566068649292,
        0.0
      ],
      "plane_d": 5932.80810546875,
      "bbox_min": [
        -3881.099365234375,
        -4828.49072265625,
        1014.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6519463658332825,
        0.7582650780677795,
        0.0
      ],
      "plane_d": 1129.165771484375,
      "bbox_min": [
        -3881.099365234375,
        -4828.49072265625,
        1014.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6519314050674438,
        -0.758277952671051,
        0.0
      ],
      "plane_d": -1132.35791015625,
      "bbox_min": [
        -3879.212158203125,
        -4828.49072265625,
        1014.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4827.36572265625,
        1015.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914448261260986,
        0.13052622973918915,
        0.0
      ],
      "plane_d": 4479.4638671875,
      "bbox_min": [
        -3906.0,
        -4869.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3862.31201171875,
        -4815.4169921875,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4869.76904296875,
      "bbox_min": [
        -3906.0,
        -4869.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -4869.76904296875,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869989156723022,
        -0.16072678565979004,
        -0.0
      ],
      "plane_d": -4606.1484375,
      "bbox_min": [
        -3882.099365234375,
        -4821.29052734375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9869989156723022,
        0.16072678565979004,
        0.0
      ],
      "plane_d": 4603.20361328125,
      "bbox_min": [
        -3882.099365234375,
        -4821.29052734375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37762999534606934,
        0.9259566068649292,
        0.0
      ],
      "plane_d": 5926.5185546875,
      "bbox_min": [
        -3882.099365234375,
        -4821.29052734375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6519463658332825,
        0.7582650780677795,
        0.0
      ],
      "plane_d": 1123.054443359375,
      "bbox_min": [
        -3882.099365234375,
        -4821.29052734375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6519314050674438,
        -0.758277952671051,
        0.0
      ],
      "plane_d": -1126.246337890625,
      "bbox_min": [
        -3880.212158203125,
        -4821.29052734375,
        1015.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4820.16552734375,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9869989156723022,
        0.16072678565979004,
        0.0
      ],
      "plane_d": 4603.3740234375,
      "bbox_min": [
        -3881.099365234375,
        -4828.49072265625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869989156723022,
        -0.16072678565979004,
        -0.0
      ],
      "plane_d": -4606.318359375,
      "bbox_min": [
        -3881.099365234375,
        -4828.49072265625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37764614820480347,
        -0.9259499907493591,
        -0.0
      ],
      "plane_d": -5935.91015625,
      "bbox_min": [
        -3881.099365234375,
        -4828.49072265625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37762999534606934,
        0.9259566068649292,
        0.0
      ],
      "plane_d": 5932.80810546875,
      "bbox_min": [
        -3881.099365234375,
        -4828.49072265625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6519463658332825,
        0.7582650780677795,
        0.0
      ],
      "plane_d": 1129.165771484375,
      "bbox_min": [
        -3881.099365234375,
        -4828.49072265625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6519314050674438,
        -0.758277952671051,
        0.0
      ],
      "plane_d": -1132.35791015625,
      "bbox_min": [
        -3879.212158203125,
        -4828.49072265625,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4827.36572265625,
        1016.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": -5411.44384765625,
      "bbox_min": [
        -3905.134765625,
        -4815.4169921875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3864.8369140625,
        -4754.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -3905.134765625,
        -4815.4169921875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3864.8369140625,
        -4754.76904296875,
        1032.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9113084673881531,
        0.37747621536254883,
        -0.1644037365913391
      ],
      "plane_d": 5510.53662109375,
      "bbox_min": [
        -3905.134765625,
        -4815.4169921875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3867.759765625,
        -4756.2822265625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9113080501556396,
        -0.37747570872306824,
        -0.16440720856189728
      ],
      "plane_d": -5173.95361328125,
      "bbox_min": [
        -3905.134765625,
        -4815.4169921875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3868.24755859375,
        -4756.5341796875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -3892.618408203125,
        -4811.6796875,
        1029.6239013671875
      ],
      "bbox_max": [
        -3868.24755859375,
        -4756.5341796875,
        1029.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9113102555274963,
        -0.3774770200252533,
        -0.16439183056354523
      ],
      "plane_d": -5184.666015625,
      "bbox_min": [
        -3905.134765625,
        -4815.4169921875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3878.31005859375,
        -4761.7431640625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9113082885742188,
        0.3774765729904175,
        -0.1644037365913391
      ],
      "plane_d": 5521.21923828125,
      "bbox_min": [
        -3902.077392578125,
        -4814.5048828125,
        1029.6239013671875
      ],
      "bbox_max": [
        -3878.31005859375,
        -4761.7431640625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -3902.077392578125,
        -4814.5048828125,
        1029.6239013671875
      ],
      "bbox_max": [
        -3878.79833984375,
        -4761.9951171875,
        1029.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238796830177307,
        0.38268303871154785,
        0.0
      ],
      "plane_d": 5431.27099609375,
      "bbox_min": [
        -3905.134765625,
        -4815.4169921875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4764.76904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13517944514751434,
        0.849597156047821,
        0.5098149180412292
      ],
      "plane_d": 3039.50341796875,
      "bbox_min": [
        -3890.33544921875,
        -4813.15185546875,
        1020.8128051757812
      ],
      "bbox_max": [
        -3885.261474609375,
        -4802.70703125,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35161659121513367,
        -0.1510603427886963,
        -0.9238758087158203
      ],
      "plane_d": -1150.02001953125,
      "bbox_min": [
        -3887.62353515625,
        -4813.15185546875,
        1020.8128051757812
      ],
      "bbox_max": [
        -3885.261474609375,
        -4809.42138671875,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35160502791404724,
        0.15105538070201874,
        0.9238810539245605
      ],
      "plane_d": 1147.225341796875,
      "bbox_min": [
        -3887.62353515625,
        -4813.15185546875,
        1020.8128051757812
      ],
      "bbox_max": [
        -3885.261474609375,
        -4809.42138671875,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5232186317443848,
        0.6828729510307312,
        -0.5098301768302917
      ],
      "plane_d": 1771.850830078125,
      "bbox_min": [
        -3887.62353515625,
        -4813.15185546875,
        1020.8128051757812
      ],
      "bbox_max": [
        -3885.261474609375,
        -4809.42138671875,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13518071174621582,
        -0.849598228931427,
        -0.5098127722740173
      ],
      "plane_d": -3042.5078125,
      "bbox_min": [
        -3886.5576171875,
        -4813.15185546875,
        1020.8226318359375
      ],
      "bbox_max": [
        -3885.261474609375,
        -4811.916015625,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5232251286506653,
        -0.6828873753547668,
        0.5098042488098145
      ],
      "plane_d": -1774.870849609375,
      "bbox_min": [
        -3886.5576171875,
        -4813.15185546875,
        1022.2997436523438
      ],
      "bbox_max": [
        -3885.261474609375,
        -4811.916015625,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3516082763671875,
        -0.15105606615543365,
        -0.9238796830177307
      ],
      "plane_d": -1149.89794921875,
      "bbox_min": [
        -3890.33544921875,
        -4806.40771484375,
        1020.8440551757812
      ],
      "bbox_max": [
        -3888.042724609375,
        -4802.70703125,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35160505771636963,
        0.15105469524860382,
        0.9238811731338501
      ],
      "plane_d": 1147.15673828125,
      "bbox_min": [
        -3890.33544921875,
        -4806.40771484375,
        1020.8440551757812
      ],
      "bbox_max": [
        -3888.042724609375,
        -4802.70703125,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1351824849843979,
        0.8496009111404419,
        0.5098077654838562
      ],
      "plane_d": 3033.42041015625,
      "bbox_min": [
        -3890.33544921875,
        -4806.40771484375,
        1020.8440551757812
      ],
      "bbox_max": [
        -3888.042724609375,
        -4802.70703125,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5232257843017578,
        0.6828814148902893,
        -0.5098114609718323
      ],
      "plane_d": 1765.8203125,
      "bbox_min": [
        -3890.33544921875,
        -4806.40771484375,
        1020.8440551757812
      ],
      "bbox_max": [
        -3888.042724609375,
        -4802.70703125,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1351792812347412,
        -0.8495979905128479,
        -0.5098134875297546
      ],
      "plane_d": -3036.4150390625,
      "bbox_min": [
        -3889.269775390625,
        -4806.40771484375,
        1020.853759765625
      ],
      "bbox_max": [
        -3888.042724609375,
        -4805.20166015625,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5232263207435608,
        -0.6828770041465759,
        0.5098168253898621
      ],
      "plane_d": -1768.8046875,
      "bbox_min": [
        -3889.269775390625,
        -4806.40771484375,
        1022.3308715820312
      ],
      "bbox_max": [
        -3888.042724609375,
        -4805.20166015625,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7976086139678955,
        -0.5650033950805664,
        0.21116746962070465
      ],
      "plane_d": 169.00474548339844,
      "bbox_min": [
        -3889.42041015625,
        -4812.74755859375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4801.4814453125,
        1023.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8488466739654541,
        0.3647133409976959,
        0.3826793134212494
      ],
      "plane_d": 4659.0986328125,
      "bbox_min": [
        -3889.42041015625,
        -4806.033203125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3884.14990234375,
        -4801.4814453125,
        1023.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13920097053050995,
        0.9674859046936035,
        0.21117323637008667
      ],
      "plane_d": 4971.2734375,
      "bbox_min": [
        -3889.42041015625,
        -4806.033203125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3884.14990234375,
        -4801.4814453125,
        1023.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35160505771636963,
        0.15105469524860382,
        0.9238811731338501
      ],
      "plane_d": 1147.15673828125,
      "bbox_min": [
        -3889.42041015625,
        -4806.033203125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3884.14990234375,
        -4801.4814453125,
        1023.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5232263207435608,
        -0.6828770041465759,
        0.5098168253898621
      ],
      "plane_d": -1768.8046875,
      "bbox_min": [
        -3889.42041015625,
        -4806.033203125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3884.14990234375,
        -4801.4814453125,
        1023.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1351824849843979,
        0.8496009111404419,
        0.5098077654838562
      ],
      "plane_d": 3033.42041015625,
      "bbox_min": [
        -3889.42041015625,
        -4806.033203125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3884.14990234375,
        -4801.4814453125,
        1023.78857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.918796956539154,
        0.39473047852516174,
        0.0
      ],
      "plane_d": 5464.7861328125,
      "bbox_min": [
        -3889.42041015625,
        -4806.033203125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3884.14990234375,
        -4801.4814453125,
        1022.3308715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8160149455070496,
        -0.5780308246612549,
        0.0
      ],
      "plane_d": 393.022216796875,
      "bbox_min": [
        -3889.42041015625,
        -4806.033203125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3884.14990234375,
        -4801.4814453125,
        1022.3308715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14240609109401703,
        0.9898083209991455,
        0.0
      ],
      "plane_d": 5306.017578125,
      "bbox_min": [
        -3889.42041015625,
        -4806.033203125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3884.8603515625,
        -4801.4814453125,
        1022.3308715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7976207733154297,
        0.5649843811988831,
        -0.21117225289344788
      ],
      "plane_d": -172.1405029296875,
      "bbox_min": [
        -3889.42041015625,
        -4806.033203125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3885.1474609375,
        -4801.4814453125,
        1022.3308715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3516082763671875,
        -0.15105606615543365,
        -0.9238796830177307
      ],
      "plane_d": -1149.89794921875,
      "bbox_min": [
        -3888.905517578125,
        -4806.033203125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3885.1474609375,
        -4802.8896484375,
        1022.3308715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1351792812347412,
        -0.8495979905128479,
        -0.5098134875297546
      ],
      "plane_d": -3036.4150390625,
      "bbox_min": [
        -3888.38720703125,
        -4806.033203125,
        1019.7457275390625
      ],
      "bbox_max": [
        -3885.574462890625,
        -4804.84716796875,
        1022.3308715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13920968770980835,
        -0.9674855470657349,
        -0.21116919815540314
      ],
      "plane_d": -4974.31201171875,
      "bbox_min": [
        -3887.5625,
        -4805.26318359375,
        1019.7457275390625
      ],
      "bbox_max": [
        -3885.574462890625,
        -4804.84716796875,
        1021.5230102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13920968770980835,
        -0.9674855470657349,
        -0.21116919815540314
      ],
      "plane_d": -4974.31201171875,
      "bbox_min": [
        -3887.5625,
        -4804.97265625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3885.1474609375,
        -4804.54345703125,
        1020.4819946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.142424076795578,
        -0.9898057579994202,
        -0.0
      ],
      "plane_d": -5309.146484375,
      "bbox_min": [
        -3886.85546875,
        -4804.7890625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3885.1474609375,
        -4804.54345703125,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.918796956539154,
        -0.39473047852516174,
        -0.0
      ],
      "plane_d": -5467.73046875,
      "bbox_min": [
        -3887.56591796875,
        -4804.681640625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3885.894775390625,
        -4802.8896484375,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.142424076795578,
        -0.9898057579994202,
        -0.0
      ],
      "plane_d": -5309.146484375,
      "bbox_min": [
        -3886.85546875,
        -4804.681640625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3885.894775390625,
        -4804.54345703125,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8160271644592285,
        0.57801353931427,
        0.0
      ],
      "plane_d": -396.22412109375,
      "bbox_min": [
        -3889.42041015625,
        -4803.95068359375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3886.568359375,
        -4801.4814453125,
        1022.3114013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.918796956539154,
        -0.39473047852516174,
        -0.0
      ],
      "plane_d": -5467.73046875,
      "bbox_min": [
        -3887.56591796875,
        -4803.35498046875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3887.365966796875,
        -4802.8896484375,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5232257843017578,
        0.6828814148902893,
        -0.5098114609718323
      ],
      "plane_d": 1765.8203125,
      "bbox_min": [
        -3889.42041015625,
        -4803.95068359375,
        1020.4819946289062
      ],
      "bbox_max": [
        -3887.671875,
        -4801.95556640625,
        1022.3114013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3516082763671875,
        -0.15105606615543365,
        -0.9238796830177307
      ],
      "plane_d": -1149.89794921875,
      "bbox_min": [
        -3889.076171875,
        -4803.95068359375,
        1020.4819946289062
      ],
      "bbox_max": [
        -3888.27294921875,
        -4803.193359375,
        1020.846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8488473296165466,
        0.3647119402885437,
        0.3826793432235718
      ],
      "plane_d": 4659.251953125,
      "bbox_min": [
        -3886.639404296875,
        -4812.74755859375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1023.7671508789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7975866198539734,
        -0.5650336742401123,
        0.21116945147514343
      ],
      "plane_d": 162.7978973388672,
      "bbox_min": [
        -3886.639404296875,
        -4812.74755859375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1023.7671508789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13920097053050995,
        0.9674859046936035,
        0.21117323637008667
      ],
      "plane_d": 4977.4208984375,
      "bbox_min": [
        -3886.639404296875,
        -4812.74755859375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1023.7671508789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35160502791404724,
        0.15105538070201874,
        0.9238810539245605
      ],
      "plane_d": 1147.225341796875,
      "bbox_min": [
        -3886.639404296875,
        -4812.74755859375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1023.7671508789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5232251286506653,
        -0.6828873753547668,
        0.5098042488098145
      ],
      "plane_d": -1774.870849609375,
      "bbox_min": [
        -3886.639404296875,
        -4812.74755859375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1023.7671508789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13517944514751434,
        0.849597156047821,
        0.5098149180412292
      ],
      "plane_d": 3039.50341796875,
      "bbox_min": [
        -3886.639404296875,
        -4812.74755859375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1023.7573852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9187976121902466,
        0.3947289288043976,
        0.0
      ],
      "plane_d": 5464.951171875,
      "bbox_min": [
        -3886.639404296875,
        -4812.74755859375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1022.2997436523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8160134553909302,
        -0.578032910823822,
        0.0
      ],
      "plane_d": 386.894775390625,
      "bbox_min": [
        -3886.639404296875,
        -4812.74755859375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.437744140625,
        -4808.2255859375,
        1022.2997436523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14240175485610962,
        0.9898089170455933,
        0.0
      ],
      "plane_d": 5312.29248046875,
      "bbox_min": [
        -3886.639404296875,
        -4812.74755859375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3882.1484375,
        -4808.2255859375,
        1022.2997436523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7976054549217224,
        0.5650091767311096,
        -0.21116383373737335
      ],
      "plane_d": -165.99697875976562,
      "bbox_min": [
        -3886.639404296875,
        -4812.74755859375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3882.435302734375,
        -4808.2255859375,
        1022.2997436523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35161659121513367,
        -0.1510603427886963,
        -0.9238758087158203
      ],
      "plane_d": -1150.02001953125,
      "bbox_min": [
        -3886.13916015625,
        -4812.74755859375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3882.435302734375,
        -4809.6337890625,
        1022.2997436523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13920968770980835,
        -0.9674855470657349,
        -0.21116919815540314
      ],
      "plane_d": -4980.45947265625,
      "bbox_min": [
        -3885.60595703125,
        -4812.74755859375,
        1019.74560546875
      ],
      "bbox_max": [
        -3882.862060546875,
        -4811.59130859375,
        1022.2997436523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13518071174621582,
        -0.849598228931427,
        -0.5098127722740173
      ],
      "plane_d": -3042.5078125,
      "bbox_min": [
        -3885.60595703125,
        -4812.74755859375,
        1020.4819946289062
      ],
      "bbox_max": [
        -3883.53857421875,
        -4811.59130859375,
        1022.2997436523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.848858118057251,
        -0.3646818995475769,
        -0.38268396258354187
      ],
      "plane_d": -4661.86474609375,
      "bbox_min": [
        -3885.56103515625,
        -4811.716796875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3882.435302734375,
        -4809.6337890625,
        1020.4819946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13920968770980835,
        -0.9674855470657349,
        -0.21116919815540314
      ],
      "plane_d": -4980.45947265625,
      "bbox_min": [
        -3884.850341796875,
        -4811.716796875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3882.435302734375,
        -4811.28759765625,
        1020.4819946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14241474866867065,
        -0.9898070693016052,
        -0.0
      ],
      "plane_d": -5315.40576171875,
      "bbox_min": [
        -3884.143310546875,
        -4811.533203125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3882.435302734375,
        -4811.28759765625,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9187976121902466,
        -0.3947289288043976,
        -0.0
      ],
      "plane_d": -5467.89599609375,
      "bbox_min": [
        -3884.853759765625,
        -4811.42578125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3883.181396484375,
        -4809.6337890625,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14241474866867065,
        -0.9898070693016052,
        -0.0
      ],
      "plane_d": -5315.40576171875,
      "bbox_min": [
        -3884.143310546875,
        -4811.42578125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3883.181396484375,
        -4811.28759765625,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.816008985042572,
        0.5780391693115234,
        0.0
      ],
      "plane_d": -389.9189453125,
      "bbox_min": [
        -3886.639404296875,
        -4810.62890625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3883.8564453125,
        -4808.2255859375,
        1022.2802124023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9187976121902466,
        -0.3947289288043976,
        -0.0
      ],
      "plane_d": -5467.89599609375,
      "bbox_min": [
        -3884.853759765625,
        -4810.0986328125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3884.654052734375,
        -4809.6337890625,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5232186317443848,
        0.6828729510307312,
        -0.5098301768302917
      ],
      "plane_d": 1771.850830078125,
      "bbox_min": [
        -3886.639404296875,
        -4810.62890625,
        1020.4819946289062
      ],
      "bbox_max": [
        -3884.959716796875,
        -4808.69970703125,
        1022.2802124023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35161659121513367,
        -0.1510603427886963,
        -0.9238758087158203
      ],
      "plane_d": -1150.02001953125,
      "bbox_min": [
        -3886.294677734375,
        -4810.62890625,
        1020.4819946289062
      ],
      "bbox_max": [
        -3885.56103515625,
        -4809.9375,
        1020.8150024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -3906.0,
        -4869.7998046875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3857.0,
        -4810.24072265625,
        1032.6239013671875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9795947670936584,
        -0.11561615765094757,
        -0.1643989384174347
      ],
      "plane_d": -4178.2607421875,
      "bbox_min": [
        -3906.0,
        -4869.76904296875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3860.4208984375,
        -4811.15283203125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -3870.194091796875,
        -4869.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -3860.4208984375,
        -4811.15283203125,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.986393928527832,
        -0.16439898312091827
      ],
      "plane_d": -4633.74853515625,
      "bbox_min": [
        -3863.841796875,
        -4869.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -3860.4208984375,
        -4869.26904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9788396954536438,
        -0.12185455858707428,
        -0.16439083218574524
      ],
      "plane_d": -4216.0361328125,
      "bbox_min": [
        -3906.0,
        -4869.76904296875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3871.73828125,
        -4813.8505859375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9796525835990906,
        0.1151343435049057,
        -0.1643923968076706
      ],
      "plane_d": 4523.3916015625,
      "bbox_min": [
        -3880.7451171875,
        -4869.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -3871.73828125,
        -4813.8505859375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.6239013671875,
      "bbox_min": [
        -3880.7451171875,
        -4869.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -3871.73828125,
        -4813.97802734375,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.986393928527832,
        -0.16439898312091827
      ],
      "plane_d": -4633.74853515625,
      "bbox_min": [
        -3874.369140625,
        -4869.76904296875,
        1029.6239013671875
      ],
      "bbox_max": [
        -3871.73828125,
        -4869.26904296875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9914448261260986,
        0.13052622973918915,
        0.0
      ],
      "plane_d": 4479.4638671875,
      "bbox_min": [
        -3906.0,
        -4869.76904296875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -4815.4169921875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4869.76904296875,
      "bbox_min": [
        -3906.0,
        -4869.76904296875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -4818.22509765625,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3777047097682953,
        0.06150692328810692,
        0.9238809943199158
      ],
      "plane_d": 817.515869140625,
      "bbox_min": [
        -3883.837646484375,
        -4829.1494140625,
        1020.8429565429688
      ],
      "bbox_max": [
        -3882.366455078125,
        -4825.43310546875,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37771111726760864,
        -0.06150796636939049,
        -0.9238782525062561
      ],
      "plane_d": -820.26904296875,
      "bbox_min": [
        -3883.837646484375,
        -4829.1494140625,
        1020.8429565429688
      ],
      "bbox_max": [
        -3882.366455078125,
        -4825.43310546875,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3424791991710663,
        0.7891709804534912,
        -0.5098207592964172
      ],
      "plane_d": 2999.492919921875,
      "bbox_min": [
        -3883.837646484375,
        -4829.1494140625,
        1020.8429565429688
      ],
      "bbox_max": [
        -3882.366455078125,
        -4825.43310546875,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07437311857938766,
        -0.8570640683174133,
        -0.5098134875297546
      ],
      "plane_d": -3906.30224609375,
      "bbox_min": [
        -3883.403564453125,
        -4829.1494140625,
        1020.8657836914062
      ],
      "bbox_max": [
        -3882.366455078125,
        -4828.111328125,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34247642755508423,
        -0.7891782522201538,
        0.5098113417625427
      ],
      "plane_d": -3002.531494140625,
      "bbox_min": [
        -3883.403564453125,
        -4829.1494140625,
        1022.349365234375
      ],
      "bbox_max": [
        -3882.366455078125,
        -4828.111328125,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37771111726760864,
        -0.06150796636939049,
        -0.9238782525062561
      ],
      "plane_d": -820.203857421875,
      "bbox_min": [
        -3884.837646484375,
        -4821.94970703125,
        1020.8214721679688
      ],
      "bbox_max": [
        -3883.315185546875,
        -4818.22509765625,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3777047097682953,
        0.06150692328810692,
        0.9238809943199158
      ],
      "plane_d": 817.45068359375,
      "bbox_min": [
        -3884.837646484375,
        -4821.94970703125,
        1020.8214721679688
      ],
      "bbox_max": [
        -3883.315185546875,
        -4818.22509765625,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07437141239643097,
        0.8570651412010193,
        0.5098119378089905
      ],
      "plane_d": 3897.20361328125,
      "bbox_min": [
        -3884.837646484375,
        -4821.94970703125,
        1020.8214721679688
      ],
      "bbox_max": [
        -3883.315185546875,
        -4818.22509765625,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3424791991710663,
        0.7891709804534912,
        -0.5098207592964172
      ],
      "plane_d": 2993.46826171875,
      "bbox_min": [
        -3884.837646484375,
        -4821.94970703125,
        1020.8214721679688
      ],
      "bbox_max": [
        -3883.315185546875,
        -4818.22509765625,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07437311857938766,
        -0.8570640683174133,
        -0.5098134875297546
      ],
      "plane_d": -3900.2060546875,
      "bbox_min": [
        -3884.403564453125,
        -4821.94970703125,
        1020.8443603515625
      ],
      "bbox_max": [
        -3883.315185546875,
        -4820.90283203125,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34247642755508423,
        -0.7891782522201538,
        0.5098113417625427
      ],
      "plane_d": -2996.506591796875,
      "bbox_min": [
        -3884.403564453125,
        -4821.94970703125,
        1022.327880859375
      ],
      "bbox_max": [
        -3883.315185546875,
        -4820.90283203125,
        1024.1961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6372266411781311,
        -0.7411820292472839,
        0.21116691827774048
      ],
      "plane_d": -1315.97900390625,
      "bbox_min": [
        -3883.78564453125,
        -4829.00390625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4817.7373046875,
        1023.8102416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9118638634681702,
        0.14852282404899597,
        0.38268160820007324
      ],
      "plane_d": 3863.12841796875,
      "bbox_min": [
        -3883.78564453125,
        -4821.7958984375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1023.7888793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3691219091415405,
        0.9050717353820801,
        0.211173415184021
      ],
      "plane_d": 5577.7763671875,
      "bbox_min": [
        -3883.78564453125,
        -4821.7958984375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1023.7888793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3777047097682953,
        0.06150692328810692,
        0.9238809943199158
      ],
      "plane_d": 817.45068359375,
      "bbox_min": [
        -3883.78564453125,
        -4821.7958984375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1023.7888793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34247642755508423,
        -0.7891782522201538,
        0.5098113417625427
      ],
      "plane_d": -2996.506591796875,
      "bbox_min": [
        -3883.78564453125,
        -4821.7958984375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1023.7888793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07437141239643097,
        0.8570651412010193,
        0.5098119378089905
      ],
      "plane_d": 3897.20361328125,
      "bbox_min": [
        -3883.78564453125,
        -4821.7958984375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1023.7659912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9869989156723022,
        0.16072678565979004,
        0.0
      ],
      "plane_d": 4603.20361328125,
      "bbox_min": [
        -3883.78564453125,
        -4821.7958984375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1022.327880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37762999534606934,
        0.9259566068649292,
        0.0
      ],
      "plane_d": 5926.5185546875,
      "bbox_min": [
        -3883.78564453125,
        -4821.7958984375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1022.327880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6519314050674438,
        -0.758277952671051,
        0.0
      ],
      "plane_d": -1126.246337890625,
      "bbox_min": [
        -3883.78564453125,
        -4821.7958984375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3878.90380859375,
        -4817.7373046875,
        1022.327880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36913028359413147,
        -0.9050693511962891,
        -0.21116898953914642
      ],
      "plane_d": -5580.80419921875,
      "bbox_min": [
        -3883.78564453125,
        -4821.7958984375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3880.212158203125,
        -4817.7373046875,
        1022.327880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37771111726760864,
        -0.06150796636939049,
        -0.9238782525062561
      ],
      "plane_d": -820.203857421875,
      "bbox_min": [
        -3883.78564453125,
        -4820.7626953125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3880.791015625,
        -4817.7373046875,
        1022.2823486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6372414231300354,
        0.7411678433418274,
        -0.2111719399690628
      ],
      "plane_d": 1312.85595703125,
      "bbox_min": [
        -3883.78564453125,
        -4819.11767578125,
        1019.7459106445312
      ],
      "bbox_max": [
        -3881.249755859375,
        -4817.81201171875,
        1022.2823486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3424791991710663,
        0.7891709804534912,
        -0.5098207592964172
      ],
      "plane_d": 2993.46826171875,
      "bbox_min": [
        -3883.78564453125,
        -4819.11767578125,
        1020.4819946289062
      ],
      "bbox_max": [
        -3881.97607421875,
        -4817.93017578125,
        1022.2823486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9118683338165283,
        -0.1484922170639038,
        -0.3826829195022583
      ],
      "plane_d": -3865.716796875,
      "bbox_min": [
        -3882.85888671875,
        -4820.7626953125,
        1016.6239013671875
      ],
      "bbox_max": [
        -3880.791015625,
        -4817.7373046875,
        1020.4819946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6372414231300354,
        0.7411678433418274,
        -0.2111719399690628
      ],
      "plane_d": 1312.85595703125,
      "bbox_min": [
        -3882.85888671875,
        -4818.98583984375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3880.791015625,
        -4817.7373046875,
        1020.4819946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6519463658332825,
        0.7582650780677795,
        0.0
      ],
      "plane_d": 1123.054443359375,
      "bbox_min": [
        -3882.099365234375,
        -4818.8623046875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3880.791015625,
        -4817.7373046875,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869989156723022,
        -0.16072678565979004,
        -0.0
      ],
      "plane_d": -4606.1484375,
      "bbox_min": [
        -3882.099365234375,
        -4820.638671875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.363037109375,
        -4818.22900390625,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6519463658332825,
        0.7582650780677795,
        0.0
      ],
      "plane_d": 1123.054443359375,
      "bbox_min": [
        -3882.099365234375,
        -4818.8623046875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.363037109375,
        -4818.22900390625,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37764614820480347,
        -0.9259499907493591,
        -0.0
      ],
      "plane_d": -5929.62109375,
      "bbox_min": [
        -3883.489990234375,
        -4821.7958984375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3880.212158203125,
        -4820.138671875,
        1022.327880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869989156723022,
        -0.16072678565979004,
        -0.0
      ],
      "plane_d": -4606.1484375,
      "bbox_min": [
        -3881.891357421875,
        -4820.638671875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3881.81005859375,
        -4820.138671875,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07437311857938766,
        -0.8570640683174133,
        -0.5098134875297546
      ],
      "plane_d": -3900.2060546875,
      "bbox_min": [
        -3883.489990234375,
        -4821.7958984375,
        1020.4819946289062
      ],
      "bbox_max": [
        -3881.3974609375,
        -4820.47021484375,
        1022.327880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37771111726760864,
        -0.06150796636939049,
        -0.9238782525062561
      ],
      "plane_d": -820.203857421875,
      "bbox_min": [
        -3883.489990234375,
        -4820.9033203125,
        1020.4819946289062
      ],
      "bbox_max": [
        -3882.569580078125,
        -4820.47021484375,
        1020.8443603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9118638634681702,
        0.14852282404899597,
        0.38268160820007324
      ],
      "plane_d": 3863.28564453125,
      "bbox_min": [
        -3882.836669921875,
        -4829.00390625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1023.8102416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6372266411781311,
        -0.7411820292472839,
        0.21116691827774048
      ],
      "plane_d": -1321.952880859375,
      "bbox_min": [
        -3882.836669921875,
        -4829.00390625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1023.8102416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3691219091415405,
        0.9050717353820801,
        0.211173415184021
      ],
      "plane_d": 5583.92333984375,
      "bbox_min": [
        -3882.836669921875,
        -4829.00390625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1023.8102416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3777047097682953,
        0.06150692328810692,
        0.9238809943199158
      ],
      "plane_d": 817.515869140625,
      "bbox_min": [
        -3882.836669921875,
        -4829.00390625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1023.8102416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34247642755508423,
        -0.7891782522201538,
        0.5098113417625427
      ],
      "plane_d": -3002.531494140625,
      "bbox_min": [
        -3882.836669921875,
        -4829.00390625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1023.8102416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07437141239643097,
        0.8570651412010193,
        0.5098119378089905
      ],
      "plane_d": 3903.2998046875,
      "bbox_min": [
        -3882.836669921875,
        -4829.00390625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1023.7874145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9869989156723022,
        0.16072678565979004,
        0.0
      ],
      "plane_d": 4603.3740234375,
      "bbox_min": [
        -3882.836669921875,
        -4829.00390625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1022.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37762999534606934,
        0.9259566068649292,
        0.0
      ],
      "plane_d": 5932.80810546875,
      "bbox_min": [
        -3882.836669921875,
        -4829.00390625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1022.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6519314050674438,
        -0.758277952671051,
        0.0
      ],
      "plane_d": -1132.35791015625,
      "bbox_min": [
        -3882.836669921875,
        -4829.00390625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3877.90380859375,
        -4824.9375,
        1022.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36913028359413147,
        -0.9050693511962891,
        -0.21116898953914642
      ],
      "plane_d": -5586.95166015625,
      "bbox_min": [
        -3882.836669921875,
        -4829.00390625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3879.212158203125,
        -4824.9375,
        1022.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37771111726760864,
        -0.06150796636939049,
        -0.9238782525062561
      ],
      "plane_d": -820.26904296875,
      "bbox_min": [
        -3882.836669921875,
        -4827.96240234375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3879.791015625,
        -4824.9375,
        1022.3038330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6372414231300354,
        0.7411678433418274,
        -0.2111719399690628
      ],
      "plane_d": 1318.829833984375,
      "bbox_min": [
        -3882.836669921875,
        -4826.326171875,
        1019.7459106445312
      ],
      "bbox_max": [
        -3880.249755859375,
        -4825.01220703125,
        1022.3038330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3424791991710663,
        0.7891709804534912,
        -0.5098207592964172
      ],
      "plane_d": 2999.492919921875,
      "bbox_min": [
        -3882.836669921875,
        -4826.326171875,
        1020.4819946289062
      ],
      "bbox_max": [
        -3880.97607421875,
        -4825.13037109375,
        1022.3038330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9118683338165283,
        -0.1484922170639038,
        -0.3826829195022583
      ],
      "plane_d": -3865.8740234375,
      "bbox_min": [
        -3881.85888671875,
        -4827.96240234375,
        1016.6239013671875
      ],
      "bbox_max": [
        -3879.791015625,
        -4824.9375,
        1020.4819946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6372414231300354,
        0.7411678433418274,
        -0.2111719399690628
      ],
      "plane_d": 1318.829833984375,
      "bbox_min": [
        -3881.85888671875,
        -4826.18603515625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3879.791015625,
        -4824.9375,
        1020.4819946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6519463658332825,
        0.7582650780677795,
        0.0
      ],
      "plane_d": 1129.165771484375,
      "bbox_min": [
        -3881.099365234375,
        -4826.0625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3879.791015625,
        -4824.9375,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869989156723022,
        -0.16072678565979004,
        -0.0
      ],
      "plane_d": -4606.318359375,
      "bbox_min": [
        -3881.099365234375,
        -4827.8388671875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3880.363037109375,
        -4825.42919921875,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6519463658332825,
        0.7582650780677795,
        0.0
      ],
      "plane_d": 1129.165771484375,
      "bbox_min": [
        -3881.099365234375,
        -4826.0625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3880.363037109375,
        -4825.42919921875,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37764614820480347,
        -0.9259499907493591,
        -0.0
      ],
      "plane_d": -5935.91015625,
      "bbox_min": [
        -3882.54443359375,
        -4829.00390625,
        1016.6239013671875
      ],
      "bbox_max": [
        -3879.212158203125,
        -4827.3388671875,
        1022.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869989156723022,
        -0.16072678565979004,
        -0.0
      ],
      "plane_d": -4606.318359375,
      "bbox_min": [
        -3880.891357421875,
        -4827.8388671875,
        1016.6239013671875
      ],
      "bbox_max": [
        -3880.81005859375,
        -4827.3388671875,
        1018.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07437311857938766,
        -0.8570640683174133,
        -0.5098134875297546
      ],
      "plane_d": -3906.30224609375,
      "bbox_min": [
        -3882.54443359375,
        -4829.00390625,
        1020.4819946289062
      ],
      "bbox_max": [
        -3880.3974609375,
        -4827.6533203125,
        1022.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37771111726760864,
        -0.06150796636939049,
        -0.9238782525062561
      ],
      "plane_d": -820.26904296875,
      "bbox_min": [
        -3882.54443359375,
        -4828.111328125,
        1020.4819946289062
      ],
      "bbox_max": [
        -3881.569580078125,
        -4827.6533203125,
        1020.8657836914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4170.08642578125,
      "bbox_min": [
        -3997.0,
        -4909.76904296875,
        985.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4869.7998046875,
        1052.6239013671875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -0.3713906705379486,
        0.9284766912460327
      ],
      "plane_d": -2751.56982421875,
      "bbox_min": [
        -3997.0,
        -4909.76904296875,
        985.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4869.7998046875,
        1027.5927734375
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -0.7138567566871643,
        0.7002917528152466
      ],
      "plane_d": -4195.09619140625,
      "bbox_min": [
        -3947.0,
        -4909.76904296875,
        985.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.33803048729896545,
        0.9411351680755615
      ],
      "plane_d": -2600.08740234375,
      "bbox_min": [
        -3947.0,
        -4889.119140625,
        1006.6738891601562
      ],
      "bbox_max": [
        -3717.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3927.0,
      "bbox_min": [
        -3947.0,
        -4889.119140625,
        1006.6738891601562
      ],
      "bbox_max": [
        -3877.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3877.0,
      "bbox_min": [
        -3877.0,
        -4889.119140625,
        1006.6738891601562
      ],
      "bbox_max": [
        -3877.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3947.0,
      "bbox_min": [
        -3947.0,
        -4889.119140625,
        1006.6738891601562
      ],
      "bbox_max": [
        -3947.0,
        -4869.7998046875,
        1015.611572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3787.0,
      "bbox_min": [
        -3807.0,
        -4909.76904296875,
        985.6239013671875
      ],
      "bbox_max": [
        -3717.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3737.0,
      "bbox_min": [
        -3737.0,
        -4909.76904296875,
        985.6239013671875
      ],
      "bbox_max": [
        -3737.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3807.0,
      "bbox_min": [
        -3807.0,
        -4909.76904296875,
        985.6239013671875
      ],
      "bbox_max": [
        -3807.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3877.0,
      "bbox_min": [
        -3877.0,
        -4909.76904296875,
        985.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3947.0,
      "bbox_min": [
        -3947.0,
        -4909.76904296875,
        985.6239013671875
      ],
      "bbox_max": [
        -3947.0,
        -4887.1650390625,
        1008.6654052734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3997.0,
      "bbox_min": [
        -3997.0,
        -4889.76904296875,
        1007.6239013671875
      ],
      "bbox_max": [
        -3997.0,
        -4869.7998046875,
        1027.5927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2727.41357421875,
      "bbox_min": [
        -3997.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4869.7998046875,
        1052.6239013671875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.6239013671875,
      "bbox_min": [
        -3997.0,
        -4889.76904296875,
        1020.1237182617188
      ],
      "bbox_max": [
        -3667.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3997.0,
      "bbox_min": [
        -3997.0,
        -4889.76904296875,
        1020.1237182617188
      ],
      "bbox_max": [
        -3997.0,
        -4869.7998046875,
        1032.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3667.0,
      "bbox_min": [
        -3997.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4877.26904296875,
        1052.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3997.0,
      "bbox_min": [
        -3997.0,
        -4909.76904296875,
        987.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4877.26904296875,
        1052.6239013671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4899.76904296875,
      "bbox_min": [
        -3997.0,
        -4909.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4899.76904296875,
        1017.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3679.0,
      "bbox_min": [
        -3997.0,
        -4909.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4899.76904296875,
        1017.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1017.6239013671875,
      "bbox_min": [
        -3679.0,
        -4909.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4899.76904296875,
        1017.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1002.6239013671875,
      "bbox_min": [
        -3679.0,
        -4909.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3667.0,
        -4899.76904296875,
        1002.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3985.0,
      "bbox_min": [
        -3997.0,
        -4909.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3985.0,
        -4899.76904296875,
        1017.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1017.6239013671875,
      "bbox_min": [
        -3997.0,
        -4909.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3985.0,
        -4899.76904296875,
        1017.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1002.6239013671875,
      "bbox_min": [
        -3997.0,
        -4909.76904296875,
        1002.6239013671875
      ],
      "bbox_max": [
        -3985.0,
        -4899.76904296875,
        1002.6239013671875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: watertnk",
      "entity_class": "CSlidingDoor",
      "piece_name": "watertnk",
      "offset": 23312,
      "centroid": [
        -3902.0,
        -5065.483328683035,
        1015.6255231584821
      ],
      "bbox_min": [
        -3927.0,
        -5094.76904296875,
        1015.6239013671875
      ],
      "bbox_max": [
        -3877.0,
        -5029.76904296875,
        1015.6257934570312
      ],
      "dimensions_source": {
        "span_x": 50.0,
        "span_y": 65.0,
        "height_z": 0.00189208984375,
        "door_width": 65.0,
        "door_depth": 50.0,
        "leaf_depth": 49.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -3909.725341796875,
          -5029.76904296875,
          1015.6257934570312
        ],
        [
          -3894.274658203125,
          -5029.76904296875,
          1015.6257934570312
        ],
        [
          -3894.274658203125,
          -5094.76904296875,
          1015.6239013671875
        ],
        [
          -3909.725341796875,
          -5094.76904296875,
          1015.6239013671875
        ],
        [
          -3877.0,
          -5066.76904296875,
          1015.6257934570312
        ],
        [
          -3881.774658203125,
          -5080.2880859375,
          1015.6257934570312
        ],
        [
          -3894.274658203125,
          -5088.6435546875,
          1015.6257934570312
        ],
        [
          -3909.725341796875,
          -5088.6435546875,
          1015.6257934570312
        ],
        [
          -3922.225341796875,
          -5080.2880859375,
          1015.6257934570312
        ],
        [
          -3927.0,
          -5066.76904296875,
          1015.6257934570312
        ],
        [
          -3922.225341796875,
          -5053.25,
          1015.6257934570312
        ],
        [
          -3909.725341796875,
          -5044.89453125,
          1015.6257934570312
        ],
        [
          -3894.274658203125,
          -5044.89453125,
          1015.6257934570312
        ],
        [
          -3881.774658203125,
          -5053.25,
          1015.6257934570312
        ]
      ],
      "plane_distance": -1015.6258
    }
  ],
  "tutorial_messages": []
}